export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format.
   *   Its input on the server can be a Date, a Luxon DateTime or an ISO string.
   *
   */
  Date: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
  /** Represents NULL values */
  Void: { input: void; output: void; }
}

export interface GqlASearchUsersInput {
  filter: Scalars['String']['input'];
  pageLimit: Scalars['Int']['input'];
  pageOffset: Scalars['Int']['input'];
}

export interface GqlASearchZignedDocumentsInput {
  filter: Scalars['String']['input'];
  pageLimit: Scalars['Int']['input'];
  pageOffset: Scalars['Int']['input'];
}

/** AuthorizationGroup Connect meeting */
export interface GqlAgConnectMeetingInput {
  id: Scalars['ID']['input'];
  meetingId: Scalars['ID']['input'];
}

export interface GqlAgConnectMeetingResponse {
  authorizationGroup: GqlAuthorizationGroup;
}

/** AuthorizationGroup Create and connect meeting */
export interface GqlAgCreateMeetingInput {
  id: Scalars['ID']['input'];
  meetingCreate: GqlMeetingCreateInput;
}

export interface GqlAgDeletedResponse {
  aiDeletedResponses?: Maybe<Array<GqlAiDeletedResponse>>;
  aiSetDoneResponse?: Maybe<GqlAiSetDoneResponse>;
  id: Scalars['ID']['output'];
  mcDeletedResponse?: Maybe<GqlMcDeletedResponse>;
}

/** AuthorizationGroup Disconnect meeting */
export interface GqlAgDisconnectMeetingInput {
  id: Scalars['ID']['input'];
}

export interface GqlAgDisconnectMeetingResponse {
  aiDeletedResponses?: Maybe<Array<GqlAiDeletedResponse>>;
  aiSetDoneResponse?: Maybe<GqlAiSetDoneResponse>;
  authorizationGroup: GqlAuthorizationGroup;
  mcDeletedResponse?: Maybe<GqlMcDeletedResponse>;
}

export interface GqlAgSetNoBoardStatementInput {
  id: Scalars['ID']['input'];
  noBoardStatement: Scalars['Boolean']['input'];
}

export interface GqlAgSetSnrAuthIdInput {
  id: Scalars['ID']['input'];
  snrAuthorizationId?: InputMaybe<Scalars['ID']['input']>;
}

export interface GqlAgSetSnrCaseIdInput {
  id: Scalars['ID']['input'];
  snrCaseId?: InputMaybe<Scalars['ID']['input']>;
}

/** AuthorizationGroup Set validThru */
export interface GqlAgSetValidThruInput {
  id: Scalars['ID']['input'];
  validThruAgmYear?: InputMaybe<Scalars['String']['input']>;
  validThruDate?: InputMaybe<Scalars['Date']['input']>;
}

export interface GqlAgUpdateInput {
  contact?: InputMaybe<GqlCreateIdentityInput>;
  id: Scalars['ID']['input'];
  primaryLang?: InputMaybe<Scalars['Boolean']['input']>;
  regFormPaymentThroughBolago?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryLang?: InputMaybe<Scalars['Boolean']['input']>;
  signatory?: InputMaybe<GqlCreateIdentityInput>;
}

export interface GqlAgValidatorErrors {
  auths: GqlValidatorStatus;
  availability: GqlValidatorStatus;
  boardStatement: GqlValidatorStatus;
  decision: GqlValidatorStatus;
  language: GqlValidatorStatus;
  signsRegForm: GqlValidatorStatus;
}

export interface GqlAgendaItem {
  agendaItemDecisions: Array<GqlAgendaItemDecision>;
  canHaveBoardsRecommendation: Scalars['Boolean']['output'];
  canHavePostalVote: Scalars['Boolean']['output'];
  commentPrimaryLang?: Maybe<Scalars['String']['output']>;
  commentSecondaryLang?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  decisionSuggestions?: Maybe<Scalars['JSON']['output']>;
  done: Scalars['Boolean']['output'];
  firstGroup: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  kind: GqlAgendaItemKind;
  lastGroup: Scalars['Boolean']['output'];
  mandatory: Scalars['Boolean']['output'];
  meeting: GqlMeeting;
  meetingId: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  subjectPrimaryLang: Scalars['String']['output'];
  subjectSecondaryLang?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
}

export interface GqlAgendaItemDecision {
  agendaItem: GqlAgendaItem;
  agendaItemId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  decisionPrimaryLang?: Maybe<Scalars['String']['output']>;
  decisionSecondaryLang?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
}

export enum GqlAgendaItemKind {
  AgendaApproval = 'AgendaApproval',
  ArticlesOfAssoc = 'ArticlesOfAssoc',
  AuthorizationGroup = 'AuthorizationGroup',
  CommentOnly = 'CommentOnly',
  EmployeeOptionsProgram = 'EmployeeOptionsProgram',
  FunctionSelect = 'FunctionSelect',
  MeetingEnd = 'MeetingEnd',
  MeetingStart = 'MeetingStart',
  NextMeeting = 'NextMeeting',
  NiceConvertible = 'NiceConvertible',
  PriorMeetingApproval = 'PriorMeetingApproval',
  ShareIssue = 'ShareIssue',
  Standard = 'Standard',
  VotingList = 'VotingList',
  WarrantIssue = 'WarrantIssue',
  WiseConvertible = 'WiseConvertible'
}

export interface GqlAgreement {
  companyId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  delta: Scalars['JSON']['output'];
  fields: Array<GqlAgreementField>;
  file: GqlBolagoFile;
  id: Scalars['ID']['output'];
  isValid: Scalars['Boolean']['output'];
  language: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: GqlAgreementFlowStatus;
  templateName: Scalars['String']['output'];
  templateRevisionId: Scalars['String']['output'];
}

export interface GqlAgreementField {
  id: Scalars['ID']['output'];
  longForm?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  type: GqlFieldType;
  value?: Maybe<GqlAgreementValue>;
  valueOptions?: Maybe<Array<Scalars['String']['output']>>;
}

/** The status of the agreement */
export enum GqlAgreementFlowStatus {
  Completed = 'Completed',
  Created = 'Created',
  Pending = 'Pending',
  Signing = 'Signing'
}

export enum GqlAgreementStatus {
  Failed = 'FAILED',
  NotSent = 'NOT_SENT',
  Sent = 'SENT',
  Signed = 'SIGNED'
}

export interface GqlAgreementValue {
  companyId?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['JSON']['output']>;
  fieldId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  value?: Maybe<Scalars['JSON']['output']>;
}

export interface GqlAiCreateInput {
  agendaItemsDecisionsCreate?: InputMaybe<Array<GqlAidCreateWithoutAiInput>>;
  commentPrimaryLang?: InputMaybe<Scalars['String']['input']>;
  commentSecondaryLang?: InputMaybe<Scalars['String']['input']>;
  decisionSuggestions?: InputMaybe<Scalars['JSON']['input']>;
  kind: GqlAgendaItemKind;
  mandatory?: Scalars['Boolean']['input'];
  meetingId: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  subjectPrimaryLang: Scalars['String']['input'];
  subjectSecondaryLang?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlAiDeletedResponse {
  id: Scalars['ID']['output'];
  updatedAis: Array<GqlAgendaItem>;
}

/** Sets done and comments */
export interface GqlAiSetDoneInput {
  commentPrimaryLang?: InputMaybe<Scalars['String']['input']>;
  commentSecondaryLang?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  summonsDirty: Scalars['Boolean']['input'];
}

export interface GqlAiSetDoneResponse {
  agendaItem: GqlAgendaItem;
  deletedAidIds?: Maybe<Array<GqlAidDeletedResponse>>;
}

export interface GqlAiSetOrderInput {
  id: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
}

export interface GqlAidCreateInput {
  agendaItemId: Scalars['ID']['input'];
  decisionPrimaryLang?: InputMaybe<Scalars['String']['input']>;
  decisionSecondaryLang?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlAidCreateWithoutAiInput {
  decisionPrimaryLang?: InputMaybe<Scalars['String']['input']>;
  decisionSecondaryLang?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
}

export interface GqlAidDeletedResponse {
  agendaItem?: Maybe<GqlAgendaItem>;
  id: Scalars['ID']['output'];
}

export interface GqlAidUpdateInput {
  decisionPrimaryLang?: InputMaybe<Scalars['String']['input']>;
  decisionSecondaryLang?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
}

export enum GqlAllocationKind {
  OnlyWithPreferentialRights = 'OnlyWithPreferentialRights',
  OnlyWithoutPreferentialRights = 'OnlyWithoutPreferentialRights',
  WithOrWithoutPreferentialRights = 'WithOrWithoutPreferentialRights'
}

/** Connect meeting */
export interface GqlAoaConnectMeetingInput {
  id: Scalars['ID']['input'];
  meetingId: Scalars['ID']['input'];
}

export interface GqlAoaCreateInput {
  changeNumberOfShares?: InputMaybe<Scalars['Boolean']['input']>;
  copyFromAoaId?: InputMaybe<Scalars['ID']['input']>;
  meetingId?: InputMaybe<Scalars['ID']['input']>;
}

/** Create and connect meeting */
export interface GqlAoaCreateMeetingInput {
  id: Scalars['ID']['input'];
  meetingCreate: GqlMeetingCreateInput;
}

export interface GqlAoaDeletedResponse {
  agendaItems?: Maybe<Array<GqlAgendaItem>>;
  aiDeletedResponses?: Maybe<Array<GqlAiDeletedResponse>>;
  id: Scalars['ID']['output'];
  mcDeletedResponse?: Maybe<GqlMcDeletedResponse>;
}

/** Disconnect meeting */
export interface GqlAoaDisconnectMeetingInput {
  id: Scalars['ID']['input'];
}

export interface GqlAoaDisconnectMeetingResponse {
  agendaItems?: Maybe<Array<GqlAgendaItem>>;
  aiDeletedResponses?: Maybe<Array<GqlAiDeletedResponse>>;
  articlesOfAssoc: GqlArticlesOfAssoc;
  mcDeletedResponse?: Maybe<GqlMcDeletedResponse>;
}

/** gets affected concerns connected to the same meeting */
export interface GqlAoaGetAffectedResponse {
  authorizationGroups: Array<GqlAuthorizationGroup>;
  shareIssues: Array<GqlShareIssue>;
  warrantPrograms: Array<GqlWarrantProgram>;
}

export interface GqlAoaSetShareChangeInput {
  id: Scalars['ID']['input'];
  numberOfSharesAfter: Scalars['String']['input'];
}

export interface GqlAoaUpdateInput {
  arbitratorPrimaryLang?: InputMaybe<Scalars['String']['input']>;
  changeArbitrator?: InputMaybe<Scalars['Boolean']['input']>;
  changeBoardLimits?: InputMaybe<Scalars['Boolean']['input']>;
  changeConsent?: InputMaybe<Scalars['Boolean']['input']>;
  changeFiscalYear?: InputMaybe<Scalars['Boolean']['input']>;
  changeKindOfBusiness?: InputMaybe<Scalars['Boolean']['input']>;
  changeMajority?: InputMaybe<Scalars['Boolean']['input']>;
  changeNumberOfAuditors?: InputMaybe<Scalars['Boolean']['input']>;
  changePostTransferPurchaseRight?: InputMaybe<Scalars['Boolean']['input']>;
  changeRightOfFirstRefusal?: InputMaybe<Scalars['Boolean']['input']>;
  changeShareLimits?: InputMaybe<Scalars['Boolean']['input']>;
  changeSummoning?: InputMaybe<Scalars['Boolean']['input']>;
  consentPrimaryLang?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<GqlCreateIdentityInput>;
  digitalAgm?: InputMaybe<GqlDigitalAgm>;
  fiscalYear?: InputMaybe<GqlFiscalYear>;
  haveArbitrator?: InputMaybe<Scalars['Boolean']['input']>;
  haveConsent?: InputMaybe<Scalars['Boolean']['input']>;
  haveMajority?: InputMaybe<Scalars['Boolean']['input']>;
  havePostTransferPurchaseRight?: InputMaybe<Scalars['Boolean']['input']>;
  haveRightOfFirstRefusal?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  kindOfBusiness?: InputMaybe<Scalars['String']['input']>;
  majorityPrimaryLang?: InputMaybe<Scalars['String']['input']>;
  maximumNumberOfAuditors?: InputMaybe<Scalars['String']['input']>;
  maximumNumberOfBoardMembers?: InputMaybe<Scalars['String']['input']>;
  maximumNumberOfShares?: InputMaybe<Scalars['String']['input']>;
  maximumNumberOfSubstituteAuditors?: InputMaybe<Scalars['String']['input']>;
  maximumNumberOfSubstitutes?: InputMaybe<Scalars['String']['input']>;
  maximumShareCapital?: InputMaybe<Scalars['String']['input']>;
  minimumNumberOfAuditors?: InputMaybe<Scalars['String']['input']>;
  minimumNumberOfBoardMembers?: InputMaybe<Scalars['String']['input']>;
  minimumNumberOfShares?: InputMaybe<Scalars['String']['input']>;
  minimumNumberOfSubstituteAuditors?: InputMaybe<Scalars['String']['input']>;
  minimumNumberOfSubstitutes?: InputMaybe<Scalars['String']['input']>;
  minimumShareCapital?: InputMaybe<Scalars['String']['input']>;
  numberOfSharesAfter?: InputMaybe<Scalars['String']['input']>;
  postTransferPurchaseRightPrimaryLang?: InputMaybe<Scalars['String']['input']>;
  regFormPaymentThroughBolago?: InputMaybe<Scalars['Boolean']['input']>;
  rightOfFirstRefusalPrimaryLang?: InputMaybe<Scalars['String']['input']>;
  seat?: InputMaybe<Scalars['String']['input']>;
  signatory?: InputMaybe<GqlCreateIdentityInput>;
  skipConcernUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  summoningMethodEmail?: InputMaybe<Scalars['Boolean']['input']>;
  summoningMethodFax?: InputMaybe<Scalars['Boolean']['input']>;
  summoningMethodMail?: InputMaybe<Scalars['Boolean']['input']>;
  summoningMethodNewspaper?: InputMaybe<Scalars['String']['input']>;
  summoningMethodOtherPrimaryLang?: InputMaybe<Scalars['String']['input']>;
  summoningMethodPoit?: InputMaybe<Scalars['Boolean']['input']>;
  summoningTimeMax?: InputMaybe<Scalars['String']['input']>;
  summoningTimeMin?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlAoaValidatorErrors {
  board: GqlValidatorStatus;
  business: GqlValidatorStatus;
  companyName: GqlValidatorStatus;
  decision: GqlValidatorStatus;
  fiscalYear: GqlValidatorStatus;
  reservations: GqlValidatorStatus;
  seat: GqlValidatorStatus;
  shareChange: GqlValidatorStatus;
  shareLimit: GqlValidatorStatus;
  signsRegForm: GqlValidatorStatus;
  summons: GqlValidatorStatus;
}

export interface GqlArticlesOfAssoc {
  agendaItemsAgmHtml?: Maybe<Scalars['JSON']['output']>;
  arbitratorPrimaryLang?: Maybe<Scalars['String']['output']>;
  articlesOfAssocDocuments: Array<GqlArticlesOfAssocDocument>;
  changeAgendaItems?: Maybe<Scalars['Boolean']['output']>;
  changeArbitrator: Scalars['Boolean']['output'];
  changeBoardLimits: Scalars['Boolean']['output'];
  changeCompanyName: Scalars['Boolean']['output'];
  changeConsent: Scalars['Boolean']['output'];
  changeDigitalAgm: Scalars['Boolean']['output'];
  changeFiscalYear: Scalars['Boolean']['output'];
  changeKindOfBusiness: Scalars['Boolean']['output'];
  changeMajority: Scalars['Boolean']['output'];
  changeNumberOfAuditors: Scalars['Boolean']['output'];
  changeNumberOfShares: Scalars['Boolean']['output'];
  changePostTransferPurchaseRight: Scalars['Boolean']['output'];
  changeRightOfFirstRefusal: Scalars['Boolean']['output'];
  changeSeat: Scalars['Boolean']['output'];
  changeShareLimits: Scalars['Boolean']['output'];
  changeSummoning: Scalars['Boolean']['output'];
  company: GqlCompany;
  companyId: Scalars['ID']['output'];
  companyName: Scalars['String']['output'];
  consentPrimaryLang?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<GqlIdentity>;
  contactId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Date']['output'];
  defaultFileName: Scalars['String']['output'];
  digitalAgm?: Maybe<GqlDigitalAgm>;
  fiscalYear: GqlFiscalYear;
  fiscalYearBefore?: Maybe<GqlFiscalYear>;
  fiscalYearBeforeStart?: Maybe<Scalars['Date']['output']>;
  haveArbitrator: Scalars['Boolean']['output'];
  haveConsent: Scalars['Boolean']['output'];
  haveMajority: Scalars['Boolean']['output'];
  havePostTransferPurchaseRight: Scalars['Boolean']['output'];
  haveRightOfFirstRefusal: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  kindOfBusiness: Scalars['String']['output'];
  latestDocument?: Maybe<GqlBolagoFile>;
  majorityPrimaryLang?: Maybe<Scalars['String']['output']>;
  maximumNumberOfAuditors?: Maybe<Scalars['String']['output']>;
  maximumNumberOfBoardMembers?: Maybe<Scalars['String']['output']>;
  maximumNumberOfShares?: Maybe<Scalars['String']['output']>;
  maximumNumberOfSubstituteAuditors?: Maybe<Scalars['String']['output']>;
  maximumNumberOfSubstitutes?: Maybe<Scalars['String']['output']>;
  maximumShareCapital?: Maybe<Scalars['String']['output']>;
  meetingConcern?: Maybe<GqlMeetingConcern>;
  minimumNumberOfAuditors?: Maybe<Scalars['String']['output']>;
  minimumNumberOfBoardMembers?: Maybe<Scalars['String']['output']>;
  minimumNumberOfShares?: Maybe<Scalars['String']['output']>;
  minimumNumberOfSubstituteAuditors?: Maybe<Scalars['String']['output']>;
  minimumNumberOfSubstitutes?: Maybe<Scalars['String']['output']>;
  minimumShareCapital?: Maybe<Scalars['String']['output']>;
  newCompanyNames?: Maybe<Scalars['JSONObject']['output']>;
  numberOfSharesAfter?: Maybe<Scalars['String']['output']>;
  numberOfSharesBefore: Scalars['String']['output'];
  postTransferPurchaseRightPrimaryLang?: Maybe<Scalars['String']['output']>;
  quotaAfter?: Maybe<Scalars['String']['output']>;
  quotaBefore?: Maybe<Scalars['String']['output']>;
  regFormPaymentThroughBolago: Scalars['Boolean']['output'];
  rightOfFirstRefusalPrimaryLang?: Maybe<Scalars['String']['output']>;
  seat: Scalars['String']['output'];
  shareCapitalBefore?: Maybe<Scalars['String']['output']>;
  signatory?: Maybe<GqlIdentity>;
  signatoryId?: Maybe<Scalars['ID']['output']>;
  snrCaseId?: Maybe<Scalars['ID']['output']>;
  summoningMethodEmail?: Maybe<Scalars['Boolean']['output']>;
  summoningMethodFax?: Maybe<Scalars['Boolean']['output']>;
  summoningMethodMail?: Maybe<Scalars['Boolean']['output']>;
  summoningMethodNewspaper?: Maybe<Scalars['String']['output']>;
  summoningMethodOtherPrimaryLang?: Maybe<Scalars['String']['output']>;
  summoningMethodPoit?: Maybe<Scalars['Boolean']['output']>;
  summoningTimeMax?: Maybe<Scalars['String']['output']>;
  summoningTimeMin?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
}

export interface GqlArticlesOfAssocDocument {
  articlesOfAssoc: GqlArticlesOfAssoc;
  articlesOfAssocId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  file: GqlBolagoFile;
  fileId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
}

/** Create a authorization */
export interface GqlAuthCreateInput {
  authorizationGroupId: Scalars['ID']['input'];
  kind: GqlAuthKind;
}

export interface GqlAuthDeletedResponse {
  aiDeletedResponses?: Maybe<Array<GqlAiDeletedResponse>>;
  id: Scalars['ID']['output'];
  mcDeletedResponse?: Maybe<GqlMcDeletedResponse>;
}

export enum GqlAuthKind {
  Bonds = 'Bonds',
  Convertibles = 'Convertibles',
  Issue = 'Issue',
  Warrants = 'Warrants'
}

/** Update a authorization */
export interface GqlAuthUpdateInput {
  allocation: GqlAllocationKind;
  cashPayment: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  inKindPayment: Scalars['Boolean']['input'];
  kind: GqlAuthKind;
  maxRaise?: InputMaybe<Scalars['String']['input']>;
  maxRaiseByAoa: Scalars['Boolean']['input'];
  offsetPayment: Scalars['Boolean']['input'];
  purposeTextPl: Scalars['String']['input'];
  purposeTextSl: Scalars['String']['input'];
  singleUse: Scalars['Boolean']['input'];
}

export interface GqlAuthorization {
  allocation: GqlAllocationKind;
  authorizationGroup: GqlAuthorizationGroup;
  authorizationGroupId: Scalars['String']['output'];
  cashPayment: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  inKindPayment: Scalars['Boolean']['output'];
  kind: GqlAuthKind;
  maxRaise?: Maybe<Scalars['String']['output']>;
  maxRaiseByAoa: Scalars['Boolean']['output'];
  offsetPayment: Scalars['Boolean']['output'];
  purposeTextPl: Scalars['String']['output'];
  purposeTextSl: Scalars['String']['output'];
  singleUse: Scalars['Boolean']['output'];
  updatedAt: Scalars['Date']['output'];
}

export interface GqlAuthorizationGroup {
  articlesOfAssoc?: Maybe<GqlArticlesOfAssoc>;
  authorizationGroupDocuments: Array<GqlAuthorizationGroupDocument>;
  authorizations: Array<GqlAuthorization>;
  company: GqlCompany;
  companyId: Scalars['ID']['output'];
  contact?: Maybe<GqlIdentity>;
  contactId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Date']['output'];
  defaultFilename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  latestDocument?: Maybe<GqlBolagoFile>;
  maxNumberOfShares: Scalars['Int']['output'];
  meetingConcern?: Maybe<GqlMeetingConcern>;
  noBoardStatement: Scalars['Boolean']['output'];
  otherIncreasesOfShares: Scalars['Int']['output'];
  primaryLang: Scalars['Boolean']['output'];
  regFormPaymentThroughBolago: Scalars['Boolean']['output'];
  requiresShareLimitChange: Scalars['Boolean']['output'];
  secondaryLang: Scalars['Boolean']['output'];
  signatory?: Maybe<GqlIdentity>;
  signatoryId?: Maybe<Scalars['ID']['output']>;
  snrAuthorizationId?: Maybe<Scalars['ID']['output']>;
  snrCase?: Maybe<GqlSnrCase>;
  snrCaseId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['Date']['output'];
  validThruAgmYear?: Maybe<Scalars['String']['output']>;
  validThruDate?: Maybe<Scalars['Date']['output']>;
}

export interface GqlAuthorizationGroupDocument {
  authorizationGroup: GqlAuthorizationGroup;
  authorizationGroupId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  file: GqlBolagoFile;
  fileId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
}

export interface GqlBoardSettings {
  base: GqlMeetingBase;
  dayOfWeek: GqlDayOfWeek;
  frequency: Scalars['Int']['output'];
}

export enum GqlBoardsStatementOption {
  None = 'None',
  Produce = 'Produce',
  ProducedExternally = 'ProducedExternally',
  WaivedByAuth = 'WaivedByAuth',
  Waiver = 'Waiver'
}

export interface GqlBolagoFile {
  adminCompany: GqlCompany;
  agreementId?: Maybe<Scalars['ID']['output']>;
  articlesOfAssocDocument?: Maybe<GqlArticlesOfAssocDocument>;
  authorizationGroupDocument?: Maybe<GqlAuthorizationGroupDocument>;
  children: GqlFilePagedResult;
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  deletable: Scalars['Boolean']['output'];
  dirty: Scalars['Boolean']['output'];
  documentSignatures: Array<GqlDocumentSignature>;
  filename: Scalars['String']['output'];
  filenameSecondaryLang?: Maybe<Scalars['String']['output']>;
  filesize?: Maybe<Scalars['Int']['output']>;
  genState: GqlDocGenState;
  groupId?: Maybe<Scalars['String']['output']>;
  hasSignStatus: Scalars['Boolean']['output'];
  hasThumbnail: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  internalFolderTag?: Maybe<Scalars['String']['output']>;
  isFullySigned: Scalars['Boolean']['output'];
  kind: GqlDocSystemTagKind;
  meetingDocument?: Maybe<GqlMeetingDocument>;
  meetingParticipantDocument?: Maybe<GqlMeetingParticipantDocument>;
  mimeType: Scalars['String']['output'];
  models: Array<GqlBolagoFile>;
  optionsRegistrationDocument?: Maybe<GqlOptionsRegistrationDocument>;
  parent?: Maybe<GqlBolagoFile>;
  parentId?: Maybe<Scalars['ID']['output']>;
  reminderSentAt?: Maybe<Scalars['Date']['output']>;
  scriveCtime?: Maybe<Scalars['Date']['output']>;
  scriveMtime?: Maybe<Scalars['Date']['output']>;
  scriveParties?: Maybe<Scalars['JSON']['output']>;
  scriveStatus?: Maybe<GqlScriveDocumentStatus>;
  scriveTimeoutTime?: Maybe<Scalars['String']['output']>;
  sha256?: Maybe<Scalars['String']['output']>;
  shareIssueDocument?: Maybe<GqlShareIssueDocument>;
  shareIssueRegistrationDocument?: Maybe<GqlShareIssueRegistrationDocument>;
  shareTransactionDocument?: Maybe<GqlShareTransactionDocument>;
  sharedWithShareholders: Scalars['Boolean']['output'];
  signAllowedAction: GqlSignAllowedAction;
  signatureMethod?: Maybe<GqlDocumentSignatureMethod>;
  signedFilesize?: Maybe<Scalars['Int']['output']>;
  signedSha256?: Maybe<Scalars['String']['output']>;
  softDeletable: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
  uploaded: Scalars['Boolean']['output'];
  userTags?: Maybe<Array<Scalars['String']['output']>>;
  warrantProgramDocument?: Maybe<GqlWarrantDocument>;
  zignedAgreementStatus?: Maybe<GqlZignedAgreementStatus>;
  zignedStartedAt?: Maybe<Scalars['Date']['output']>;
}


export interface GqlBolagoFileChildrenArgs {
  filter?: InputMaybe<GqlFileFilterInput>;
  lang?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
}

export enum GqlBondKind {
  Convertibles = 'Convertibles',
  PromissoryNote = 'PromissoryNote',
  Warrant = 'Warrant'
}

export interface GqlCapTable {
  capTableStakes: Array<GqlCapTableStake>;
  company: GqlCompany;
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  currentShareCount: Scalars['String']['output'];
  dirty: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  fullyDiluted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  pricePerShare?: Maybe<Scalars['String']['output']>;
  recordDate?: Maybe<Scalars['Date']['output']>;
  stakeholders: Array<GqlCapTableStakeholder>;
  unregisteredShares?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
}

export interface GqlCapTableStake {
  acqCost?: Maybe<Scalars['String']['output']>;
  cap?: Maybe<Scalars['String']['output']>;
  capTable: GqlCapTable;
  capTableId: Scalars['ID']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  enabled: Scalars['Boolean']['output'];
  floor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identity: GqlIdentity;
  identityId: Scalars['ID']['output'];
  investedAmount?: Maybe<Scalars['String']['output']>;
  kind: Scalars['Int']['output'];
  manualEntry: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  profit?: Maybe<Scalars['String']['output']>;
  stake: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  value?: Maybe<Scalars['String']['output']>;
  wiseQuantity?: Maybe<Scalars['String']['output']>;
}

export interface GqlCapTableStakeDeleteInput {
  id: Scalars['ID']['input'];
}

export interface GqlCapTableStakeSetEnabledInput {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
}

export interface GqlCapTableStakeUpdateInput {
  acqCost?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  kind?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  stake?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlCapTableStakeholder {
  acqCost: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  identity: GqlIdentity;
  profit?: Maybe<Scalars['String']['output']>;
  share: Scalars['String']['output'];
  stake: Scalars['String']['output'];
  stakes: Array<GqlCapTableStake>;
  value?: Maybe<Scalars['String']['output']>;
}

export interface GqlCdSetInvitedInput {
  id: Scalars['ID']['input'];
  invited: Scalars['Boolean']['input'];
}

export interface GqlCiCreateInput {
  email: Scalars['String']['input'];
}

export interface GqlCmpCreateInput {
  identityInput: GqlCreateIdentityInput;
}

export interface GqlCmpDeletedResponse {
  id: Scalars['ID']['output'];
}

export interface GqlCmpSetInvitedInput {
  id: Scalars['ID']['input'];
  invited: Scalars['Boolean']['input'];
}

export interface GqlCompany {
  address?: Maybe<Scalars['JSONObject']['output']>;
  addressAsStr?: Maybe<Scalars['String']['output']>;
  allowShortQeso: Scalars['Boolean']['output'];
  articlesOfAssocs: Array<GqlArticlesOfAssoc>;
  authorizationGroups: Array<GqlAuthorizationGroup>;
  authorizedSignatory: Scalars['String']['output'];
  boardMembersMax: Scalars['String']['output'];
  boardMembersMin: Scalars['String']['output'];
  boardSettings?: Maybe<GqlBoardSettings>;
  boardSubstitutesMax: Scalars['String']['output'];
  boardSubstitutesMin: Scalars['String']['output'];
  bolagsverketsid?: Maybe<Scalars['String']['output']>;
  capTableTrialExpires?: Maybe<Scalars['Date']['output']>;
  capTables: Array<GqlCapTable>;
  companyInvites: Array<GqlCompanyInvite>;
  companyUsers: Array<GqlCompanyUser>;
  county: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  currency: GqlCurrency;
  email?: Maybe<Scalars['String']['output']>;
  fiscalYear: GqlFiscalYear;
  foundationDate: Scalars['Date']['output'];
  hubspotObjectId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAntlerCompany: Scalars['Boolean']['output'];
  isDemo: Scalars['Boolean']['output'];
  isPublic: Scalars['Boolean']['output'];
  meetingAgendaTemplates: Array<GqlMeetingAgendaTemplate>;
  meetings: Array<GqlMeeting>;
  municipal: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationNumber: Scalars['String']['output'];
  promoCode?: Maybe<Scalars['String']['output']>;
  reservationArbitrator: Scalars['Boolean']['output'];
  reservationConsent: Scalars['Boolean']['output'];
  reservationDescrepancy: Scalars['Boolean']['output'];
  reservationMajority: Scalars['Boolean']['output'];
  reservationNoAuditor: Scalars['Boolean']['output'];
  reservationOther: Scalars['String']['output'];
  reservationPostTransferPurchaseRight: Scalars['Boolean']['output'];
  reservationPreferential: Scalars['Boolean']['output'];
  reservationReconciliation: Scalars['Boolean']['output'];
  reservationReconciliationDate?: Maybe<Scalars['Date']['output']>;
  reservationRightOfFirstRefusal: Scalars['Boolean']['output'];
  reservationVote: Scalars['Boolean']['output'];
  residenceMunicipal: Scalars['String']['output'];
  shareCapital: Scalars['String']['output'];
  shareCapitalMax?: Maybe<Scalars['String']['output']>;
  shareCapitalMin?: Maybe<Scalars['String']['output']>;
  shareClasses: Array<GqlShareClass>;
  shareIssues: Array<GqlShareIssue>;
  shareRegisterLimit?: Maybe<Scalars['Int']['output']>;
  shareRegisterShareCount: Scalars['Float']['output'];
  shareholderMeetingHowtoCall: Scalars['String']['output'];
  shareholders: Array<GqlShareholder>;
  sharesAtFoundation?: Maybe<Scalars['String']['output']>;
  sharesMax?: Maybe<Scalars['String']['output']>;
  sharesMin?: Maybe<Scalars['String']['output']>;
  sharesTotal: Scalars['String']['output'];
  snrAuthorizations: Array<GqlSnrAuthorization>;
  snrBonds: Array<GqlSnrBond>;
  snrCases: Array<GqlSnrCase>;
  snrShareCapitalChanges: Array<GqlSnrShareCapitalChange>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripeInvitePromoCode?: Maybe<Scalars['String']['output']>;
  subscriptions: Array<GqlCompanySubscription>;
  transferDate?: Maybe<Scalars['Date']['output']>;
  updatedAt: Scalars['Date']['output'];
  useGravatar?: Maybe<Scalars['Boolean']['output']>;
  warrantParticipants: GqlWppPagedResult;
  warrantPrograms: Array<GqlWarrantProgram>;
  web?: Maybe<Scalars['String']['output']>;
}


export interface GqlCompanySnrShareCapitalChangesArgs {
  names?: InputMaybe<Array<Scalars['String']['input']>>;
}


export interface GqlCompanyWarrantParticipantsArgs {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  showSplitAdjusted?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<GqlWppSort>;
}


export interface GqlCompanyWarrantProgramsArgs {
  kinds?: InputMaybe<Array<GqlWarrantProgramKind>>;
}

export interface GqlCompanyConnection {
  company: GqlCompany;
  companyId: Scalars['ID']['output'];
  connection: GqlCompanyConnectionEnum;
  identityId?: Maybe<Scalars['ID']['output']>;
  through?: Maybe<GqlIdentity>;
}

export enum GqlCompanyConnectionEnum {
  CompanyUser = 'companyUser',
  MeetingParticipant = 'meetingParticipant',
  Shareholder = 'shareholder',
  Warrantholder = 'warrantholder'
}

export interface GqlCompanyDirector {
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  functions: Array<Scalars['JSONObject']['output']>;
  id: Scalars['ID']['output'];
  identity: GqlIdentity;
  identityId: Scalars['ID']['output'];
  invited: Scalars['Boolean']['output'];
  registeredAbroad: Scalars['Boolean']['output'];
  updatedAt: Scalars['Date']['output'];
}

export interface GqlCompanyInvite {
  acceptedAt: Scalars['Date']['output'];
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inviterName?: Maybe<Scalars['String']['output']>;
  role: GqlCompanyUserRole;
  updatedAt: Scalars['Date']['output'];
}

export interface GqlCompanyInviteRequest {
  acceptedAt?: Maybe<Scalars['Date']['output']>;
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  rejectedAt?: Maybe<Scalars['Date']['output']>;
  role: GqlCompanyUserRole;
  updatedAt: Scalars['Date']['output'];
  userEmail?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
  userName?: Maybe<Scalars['String']['output']>;
}

export interface GqlCompanyProvisionInput {
  organizationNumber: Scalars['String']['input'];
}

export interface GqlCompanySetMeetingFrequencyInput {
  base: GqlMeetingBase;
  dayOfWeek: GqlDayOfWeek;
  frequency: Scalars['Int']['input'];
}

export interface GqlCompanySetProfileInput {
  email?: InputMaybe<Scalars['String']['input']>;
  web?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlCompanySetSharesAtFoundationInput {
  sharesAtFoundation: Scalars['String']['input'];
}

export interface GqlCompanyStatistics {
  issuedOptions: Scalars['Float']['output'];
}

export interface GqlCompanySubscription {
  canUseProFeatures: Scalars['Boolean']['output'];
  company: GqlCompany;
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  currentPeriodEnd?: Maybe<Scalars['Date']['output']>;
  currentPeriodStart?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  mainProduct: Scalars['String']['output'];
  mainProductName: Scalars['String']['output'];
  products: Scalars['JSON']['output'];
  status: GqlStripeSubscriptionStatus;
  stripeSubId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
}

export interface GqlCompanySuggestion {
  createdAt: Scalars['Date']['output'];
  functions: Array<GqlCompanySuggestionFunction>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organizationNumber: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  userId: Scalars['String']['output'];
}

export enum GqlCompanySuggestionFunction {
  Accountant = 'Accountant',
  BoardMember = 'BoardMember',
  Ceo = 'Ceo',
  Chairman = 'Chairman',
  DeputyAccountant = 'DeputyAccountant',
  DeputyBoardMember = 'DeputyBoardMember',
  DeputyCeo = 'DeputyCeo',
  DeputyLayAccountant = 'DeputyLayAccountant',
  ExternalCeo = 'ExternalCeo',
  ExternalDeputyCeo = 'ExternalDeputyCeo',
  ExternalSignatory = 'ExternalSignatory',
  HeadAccountant = 'HeadAccountant',
  LayAccountant = 'LayAccountant',
  Liquidator = 'Liquidator',
  RegisteredAgent = 'RegisteredAgent'
}

export interface GqlCompanyUser {
  company: GqlCompany;
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  role: GqlCompanyUserRole;
  updatedAt: Scalars['Date']['output'];
  user: GqlUser;
  userId: Scalars['ID']['output'];
}

export enum GqlCompanyUserRole {
  Admin = 'Admin',
  Butler = 'Butler',
  SupportAgent = 'SupportAgent'
}

export interface GqlCompleteShareCapitalChange {
  caseNumber?: Maybe<Scalars['String']['output']>;
  changedNumberOfShares?: Maybe<Scalars['Int']['output']>;
  changedNumberOfSharesSplitAdjusted?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<GqlCurrency>;
  decisionDate?: Maybe<Scalars['Date']['output']>;
  filingNumber: Scalars['String']['output'];
  filingYear: Scalars['String']['output'];
  foundersShareFraction?: Maybe<Scalars['Float']['output']>;
  /** Do not use this in place of id, instead use sccId */
  id: Scalars['ID']['output'];
  kind: GqlTransactionKind;
  name: Scalars['String']['output'];
  numberOfShares?: Maybe<Scalars['Int']['output']>;
  numberOfSharesSplitAdjusted?: Maybe<Scalars['Int']['output']>;
  paidAmount?: Maybe<Scalars['Float']['output']>;
  postMoney?: Maybe<Scalars['Float']['output']>;
  preMoney?: Maybe<Scalars['Float']['output']>;
  pricePerShare?: Maybe<Scalars['Float']['output']>;
  pricePerShareSplitAdjusted?: Maybe<Scalars['Float']['output']>;
  registrationDate?: Maybe<Scalars['Date']['output']>;
  /** Use this where you need the actual sccId */
  sccId: Scalars['ID']['output'];
  serialNumber: Scalars['String']['output'];
  shareCapitalAfter?: Maybe<Scalars['Float']['output']>;
  shareCapitalBefore?: Maybe<Scalars['Float']['output']>;
  shareCapitalChanged?: Maybe<Scalars['Float']['output']>;
  sharePriceFactor?: Maybe<Scalars['Float']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  splitFactor?: Maybe<Scalars['Float']['output']>;
}

export interface GqlCooptedMeetingParticipant {
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  identity: GqlIdentity;
  identityId: Scalars['ID']['output'];
  invited: Scalars['Boolean']['output'];
  updatedAt: Scalars['Date']['output'];
}

export interface GqlCreateCapTableInput {
  displayName: Scalars['String']['input'];
  fullyDiluted?: InputMaybe<Scalars['Boolean']['input']>;
  pricePerShare?: InputMaybe<Scalars['String']['input']>;
  recordDate: Scalars['Date']['input'];
  unregisteredShares?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlCreateCapTableStakeInput {
  acqCost?: InputMaybe<Scalars['String']['input']>;
  capTableId: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  identityInput: GqlCreateIdentityInput;
  kind: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  stake: Scalars['String']['input'];
}

export interface GqlCreateCapTableStakesInput {
  stakes: Array<GqlCreateCapTableStakeInput>;
}

export interface GqlCreateFolderInput {
  companyId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
}

export interface GqlCreateIdentityInput {
  address?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  identityNumber: Scalars['String']['input'];
  identityNumberKind: Scalars['Int']['input'];
  juridicalKind: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlCreateStripeMeetingConcernQuoteInput {
  meetingId: Scalars['ID']['input'];
  stripeCouponId?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlCreateStripeSubscriptionQuoteInput {
  meetingId?: InputMaybe<Scalars['ID']['input']>;
  stripeCouponId?: InputMaybe<Scalars['String']['input']>;
  subPriceId: Scalars['String']['input'];
  subProdId: Scalars['String']['input'];
}

export interface GqlCuCreateInput {
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  personalId: Scalars['ID']['input'];
  role: GqlCompanyUserRole;
}

export interface GqlCuDeletedResponse {
  id: Scalars['ID']['output'];
}

export enum GqlCurrency {
  Afn = 'AFN',
  All = 'ALL',
  Ang = 'ANG',
  Ars = 'ARS',
  Aud = 'AUD',
  Awg = 'AWG',
  Azn = 'AZN',
  Bam = 'BAM',
  Bbd = 'BBD',
  Bgn = 'BGN',
  Bmd = 'BMD',
  Bnd = 'BND',
  Bob = 'BOB',
  Brl = 'BRL',
  Bsd = 'BSD',
  Bwp = 'BWP',
  Byn = 'BYN',
  Bzd = 'BZD',
  Cad = 'CAD',
  Chf = 'CHF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Crc = 'CRC',
  Cup = 'CUP',
  Czk = 'CZK',
  Dkk = 'DKK',
  Dop = 'DOP',
  Egp = 'EGP',
  Eur = 'EUR',
  Fjd = 'FJD',
  Fkp = 'FKP',
  Gbp = 'GBP',
  Ggp = 'GGP',
  Ghs = 'GHS',
  Gip = 'GIP',
  Gtq = 'GTQ',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Hrk = 'HRK',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Imp = 'IMP',
  Inr = 'INR',
  Irr = 'IRR',
  Isk = 'ISK',
  Jep = 'JEP',
  Jmd = 'JMD',
  Jpy = 'JPY',
  Kgs = 'KGS',
  Khr = 'KHR',
  Kpw = 'KPW',
  Krw = 'KRW',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Lak = 'LAK',
  Lbp = 'LBP',
  Lkr = 'LKR',
  Lrd = 'LRD',
  Mkd = 'MKD',
  Mnt = 'MNT',
  Mur = 'MUR',
  Mxn = 'MXN',
  Myr = 'MYR',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nio = 'NIO',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pab = 'PAB',
  Pen = 'PEN',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pyg = 'PYG',
  Qar = 'QAR',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sek = 'SEK',
  Sgd = 'SGD',
  Shp = 'SHP',
  Sos = 'SOS',
  Srd = 'SRD',
  Svc = 'SVC',
  Syp = 'SYP',
  Thb = 'THB',
  Try = 'TRY',
  Ttd = 'TTD',
  Tvd = 'TVD',
  Twd = 'TWD',
  Uah = 'UAH',
  Usd = 'USD',
  Uyu = 'UYU',
  Uzs = 'UZS',
  Vef = 'VEF',
  Vnd = 'VND',
  Xcd = 'XCD',
  Yer = 'YER',
  Zar = 'ZAR',
  Zwd = 'ZWD'
}

export enum GqlDayOfWeek {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export enum GqlDecisionStatus {
  Failed = 'FAILED',
  Planned = 'PLANNED',
  Sent = 'SENT',
  Signed = 'SIGNED'
}

export interface GqlDeletable {
  deletable: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
}

export interface GqlDeleteStsInput {
  confirm: Scalars['Boolean']['input'];
  ids: Array<Scalars['ID']['input']>;
}

export enum GqlDigitalAgm {
  Allowed = 'Allowed',
  AllowedWithMailVote = 'AllowedWithMailVote',
  NotAllowed = 'NotAllowed'
}

export enum GqlDocGenState {
  Completed = 'Completed',
  Failed = 'Failed',
  InProgress = 'InProgress',
  NotApplicable = 'NotApplicable',
  Scheduled = 'Scheduled',
  Waiting = 'Waiting'
}

export enum GqlDocSystemTagKind {
  Agreement = 'Agreement',
  AnnualReport = 'AnnualReport',
  AppendixAuthConvertibleIssue = 'AppendixAuthConvertibleIssue',
  AppendixAuthShareIssue = 'AppendixAuthShareIssue',
  AppendixAuthWarrantIssue = 'AppendixAuthWarrantIssue',
  AppendixNiceTerms = 'AppendixNiceTerms',
  AppendixShareIssue = 'AppendixShareIssue',
  AppendixWarrantIssueDecision = 'AppendixWarrantIssueDecision',
  AppendixWarrantTerms = 'AppendixWarrantTerms',
  AppendixWarrantValuation = 'AppendixWarrantValuation',
  AppendixWiseTerms = 'AppendixWiseTerms',
  ArticlesOfAssoc = 'ArticlesOfAssoc',
  ArticlesOfAssocRegForm = 'ArticlesOfAssocRegForm',
  AuditorsStatement = 'AuditorsStatement',
  AuditorsStatementNonCash = 'AuditorsStatementNonCash',
  AuditorsStatementOffset = 'AuditorsStatementOffset',
  AuthorizationRegistrationForm = 'AuthorizationRegistrationForm',
  BoardsStatement = 'BoardsStatement',
  BoardsStatementNonCash = 'BoardsStatementNonCash',
  BoardsStatementOffset = 'BoardsStatementOffset',
  ConvertibleRegistrationForm = 'ConvertibleRegistrationForm',
  EmployeeOptionsAgreement = 'EmployeeOptionsAgreement',
  EmployeeOptionsShareholdersAgreement = 'EmployeeOptionsShareholdersAgreement',
  EmployeeOptionsSummary = 'EmployeeOptionsSummary',
  EmploymentAgreement = 'EmploymentAgreement',
  Folder = 'Folder',
  MeetingAppendix = 'MeetingAppendix',
  MeetingProtocol = 'MeetingProtocol',
  MeetingSummons = 'MeetingSummons',
  MeetingSummonsCoverSheet = 'MeetingSummonsCoverSheet',
  MeetingVotingList = 'MeetingVotingList',
  NiceAgreement = 'NiceAgreement',
  OneWayNda = 'OneWayNda',
  Other = 'Other',
  PowerOfAttorney = 'PowerOfAttorney',
  ShareIssueRegistrationForm = 'ShareIssueRegistrationForm',
  ShareSubscriptionList = 'ShareSubscriptionList',
  ShareholderAgreement = 'ShareholderAgreement',
  ShareholderWaiver = 'ShareholderWaiver',
  TransactionNote = 'TransactionNote',
  WarrantAgreement = 'WarrantAgreement',
  WarrantCertificate = 'WarrantCertificate',
  WarrantRegistrationForm = 'WarrantRegistrationForm',
  WarrantTodoList = 'WarrantTodoList',
  WiseAgreement = 'WiseAgreement'
}

export interface GqlDocumentGenReq {
  docGen: Scalars['JSONObject']['output'];
}

export interface GqlDocumentSignature {
  authMethodToSign?: Maybe<GqlScriveAuthMethod>;
  authMethodToView?: Maybe<GqlScriveAuthMethod>;
  createdAt: Scalars['Date']['output'];
  deliveryMethod?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  file: GqlBolagoFile;
  fileId: Scalars['ID']['output'];
  headerPrimaryLang?: Maybe<Scalars['String']['output']>;
  headerSecondaryLang?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  proxy?: Maybe<GqlIdentity>;
  proxyId?: Maybe<Scalars['ID']['output']>;
  scriveEmailDeliveryStatus?: Maybe<Scalars['String']['output']>;
  scriveReadInvitationTime?: Maybe<Scalars['String']['output']>;
  scriveRejectedTime?: Maybe<Scalars['String']['output']>;
  scriveRejectionReason?: Maybe<Scalars['String']['output']>;
  scriveSeenTime?: Maybe<Scalars['String']['output']>;
  scriveSignTime?: Maybe<Scalars['String']['output']>;
  signatory: GqlIdentity;
  signatoryId: Scalars['ID']['output'];
  signed: Scalars['Boolean']['output'];
  updatedAt: Scalars['Date']['output'];
  zignedParticipantRole?: Maybe<GqlZignedParticipantRole>;
  zignedParticipantSigningRoomLink?: Maybe<Scalars['String']['output']>;
  zignedParticipantStatus?: Maybe<GqlZignedParticipantStatus>;
}

export enum GqlDocumentSignatureMethod {
  Analogue = 'Analogue',
  Digital = 'Digital'
}

export interface GqlDocumentTemplate {
  id: Scalars['ID']['output'];
  latestRevisionId: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface GqlDsCreateInput {
  email?: InputMaybe<Scalars['String']['input']>;
  fileId: Scalars['ID']['input'];
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  proxyInput?: InputMaybe<GqlCreateIdentityInput>;
  signatoryInput: GqlCreateIdentityInput;
}

export interface GqlDsDeletedResponse {
  id: Scalars['ID']['output'];
}

export interface GqlDsSetAuthMethodToSignInput {
  authMethodToSign: Scalars['String']['input'];
  id: Scalars['ID']['input'];
}

export interface GqlDsSetEmailAndMobileInput {
  email: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlDsSetProxyInput {
  id: Scalars['ID']['input'];
  proxyInput: GqlCreateIdentityInput;
}

export interface GqlEmail {
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  emailFailReason?: Maybe<Scalars['String']['output']>;
  emailSimplifiedState: GqlEmailSimplifiedState;
  emailStatus?: Maybe<GqlEmailStatus>;
  id: Scalars['ID']['output'];
  jobState: GqlJobState;
  sendgridMessageId?: Maybe<Scalars['String']['output']>;
  toEmail: Scalars['String']['output'];
  toName: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
}

export enum GqlEmailSimplifiedState {
  Failed = 'failed',
  NotSent = 'notSent',
  Ok = 'ok',
  Pending = 'pending'
}

export enum GqlEmailStatus {
  Blocked = 'blocked',
  Bounce = 'bounce',
  Bounced = 'bounced',
  Deferred = 'deferred',
  Delivered = 'delivered',
  Dropped = 'dropped',
  Processed = 'processed',
  Queued = 'queued',
  Rejected = 'rejected',
  Sent = 'sent',
  SoftBounced = 'softBounced',
  Spam = 'spam',
  Unsub = 'unsub'
}

export interface GqlEoValidatorErrors {
  dates: GqlValidatorStatus;
  decision: GqlValidatorStatus;
  duration: GqlValidatorStatus;
  language: GqlValidatorStatus;
  maxNumberOfOptions: GqlValidatorStatus;
  shareClasses: GqlValidatorStatus;
  sharePrice: GqlValidatorStatus;
  valuation: GqlValidatorStatus;
}

export enum GqlFieldType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Identity = 'IDENTITY',
  MultipleChoice = 'MULTIPLE_CHOICE',
  VariableText = 'VARIABLE_TEXT'
}

export interface GqlFileDeletedResponse {
  affectedDocuments?: Maybe<Array<GqlBolagoFile>>;
  id: Scalars['ID']['output'];
}

export interface GqlFileFilterInput {
  includeIndirectChildren?: InputMaybe<Scalars['Boolean']['input']>;
  kinds?: InputMaybe<Array<GqlDocSystemTagKind>>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<GqlFileSignatoryStatus>>;
}

export interface GqlFileGenInput {
  genSchedRequest: Scalars['JSONObject']['input'];
}

export interface GqlFileGenMcValidatorErrorsResponse {
  mc: GqlMeetingConcern;
  validatorErrors: Array<GqlValidatorMultilangError>;
  validatorStatuses: Array<GqlValidatorStatus>;
}

export interface GqlFileGenMeetingValidatorErrorsResponse {
  appendices: Array<GqlFileGenMcValidatorErrorsResponse>;
  validatorErrors: GqlMeetingValidatorErrors;
}

export interface GqlFileIsSignedResponse {
  status?: Maybe<Scalars['String']['output']>;
}

/** File language */
export interface GqlFileLanguageInput {
  primary_lang?: Scalars['Boolean']['input'];
  secondary_lang?: Scalars['Boolean']['input'];
}

export interface GqlFilePagedResult {
  models: Array<GqlBolagoFile>;
  totalCount: Scalars['Int']['output'];
}

export interface GqlFileSendSignReminderInput {
  id: Scalars['ID']['input'];
}

export interface GqlFileSetTagsInput {
  id: Scalars['ID']['input'];
  userTags: Array<Scalars['String']['input']>;
}

export interface GqlFileSignStartInput {
  id: Scalars['ID']['input'];
}

export interface GqlFileSignStopInput {
  id: Scalars['ID']['input'];
}

export enum GqlFileSignatoryStatus {
  Closed = 'closed',
  Ongoing = 'ongoing',
  Pending = 'pending'
}

export interface GqlFileUserTagsResponse {
  tags: Array<Scalars['String']['output']>;
}

export enum GqlFiscalYear {
  AprToMar = 'AprToMar',
  AugToJul = 'AugToJul',
  DecToNov = 'DecToNov',
  FebToJan = 'FebToJan',
  JanToDec = 'JanToDec',
  JulToJun = 'JulToJun',
  JunToMay = 'JunToMay',
  MarToFeb = 'MarToFeb',
  MayToApr = 'MayToApr',
  NovToOct = 'NovToOct',
  OctToSep = 'OctToSep',
  SepToAug = 'SepToAug'
}

export interface GqlFullShareRegRow {
  address: Scalars['String']['output'];
  blockEnd: Scalars['String']['output'];
  blockName: Scalars['String']['output'];
  blockStart: Scalars['String']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  fullyTransferred: Scalars['Boolean']['output'];
  hasGuardian: Scalars['Boolean']['output'];
  hasShareCertificate: Scalars['Boolean']['output'];
  note: GqlFullShareRegRowNote;
  numberOfShares: Scalars['Float']['output'];
  registrationDate: Scalars['Date']['output'];
  shareClassName: Scalars['String']['output'];
  shareholderIdentity: GqlIdentity;
  strike: Scalars['Boolean']['output'];
}

export interface GqlFullShareRegRowNote {
  primaryLang: Scalars['String']['output'];
  secondaryLang: Scalars['String']['output'];
}

export interface GqlGetIndividualReportInput {
  date?: InputMaybe<Scalars['Date']['input']>;
  shareholderId: Scalars['ID']['input'];
}

export interface GqlGetIndividualReportResponse {
  shareClasses: Array<GqlIndividualReportShareClass>;
}

export interface GqlIdentity {
  address?: Maybe<Scalars['String']['output']>;
  capTableStakes: Array<GqlCapTableStake>;
  companyDirector?: Maybe<GqlCompanyDirector>;
  companyId: Scalars['ID']['output'];
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  email?: Maybe<Scalars['String']['output']>;
  emailMd5?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identityNumber: Scalars['String']['output'];
  identityNumberKind: Scalars['Int']['output'];
  isCurrentUser: Scalars['Boolean']['output'];
  isSwedish: Scalars['Boolean']['output'];
  juridicalKind: Scalars['Int']['output'];
  meetingParticipants: Array<GqlMeetingParticipant>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  shareIssueParticipants: Array<GqlShareIssueParticipant>;
  shareholder?: Maybe<GqlShareholder>;
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<GqlLimitedUser>;
  userId?: Maybe<Scalars['ID']['output']>;
}

export interface GqlIdentityFilterInput {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlIdentitySetEmailInput {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
}

export interface GqlIdentitySetPhoneInput {
  id: Scalars['ID']['input'];
  phone: Scalars['String']['input'];
}

export interface GqlIndividualReportLabelName {
  primaryLang: Scalars['String']['output'];
  secondaryLang: Scalars['String']['output'];
}

export interface GqlIndividualReportPrices {
  pricePerShare?: Maybe<Scalars['String']['output']>;
  totalSum?: Maybe<Scalars['String']['output']>;
}

export interface GqlIndividualReportShareClass {
  shareClassName: Scalars['String']['output'];
  splitExists: Scalars['Boolean']['output'];
  sums: Array<GqlIndividualReportSum>;
  transactions: Array<GqlIndividualReportTransaction>;
}

export interface GqlIndividualReportSum {
  averagePricePerDivested?: Maybe<Scalars['Float']['output']>;
  averagePricePerShareAcquired?: Maybe<Scalars['Float']['output']>;
  currency: GqlCurrency;
  totalPricePurchase?: Maybe<Scalars['Float']['output']>;
  totalPriceSale?: Maybe<Scalars['Float']['output']>;
}

export interface GqlIndividualReportTransaction {
  acquisition: Scalars['Boolean']['output'];
  blockEnd: Scalars['Float']['output'];
  blockStart: Scalars['Float']['output'];
  buy?: Maybe<GqlIndividualReportPrices>;
  currency: GqlCurrency;
  date: Scalars['String']['output'];
  name: GqlIndividualReportLabelName;
  numberOfShares: Scalars['Int']['output'];
  sell?: Maybe<GqlIndividualReportPrices>;
  sortOrder: Scalars['Float']['output'];
  totalNumberOfShares?: Maybe<Scalars['Int']['output']>;
}

export interface GqlInvestment {
  agreementStatus: GqlAgreementStatus;
  decisionStatus: GqlDecisionStatus;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  lastSubDate?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paymentStatus: Scalars['Int']['output'];
  registrationStatus: GqlRegistrationStatus;
}

export enum GqlJobState {
  Completed = 'Completed',
  Failed = 'Failed',
  InProgress = 'InProgress',
  Scheduled = 'Scheduled',
  Waiting = 'Waiting'
}

export interface GqlLimitedUser {
  admin: Scalars['Boolean']['output'];
  companyInvite: GqlCompanyInvite;
  createdAt: Scalars['Date']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  personalId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
}

export interface GqlListAgreement {
  companyId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  templateName: Scalars['String']['output'];
}

export enum GqlMpKind {
  Boardmember = 'Boardmember',
  Guest = 'Guest',
  Shareholder = 'Shareholder'
}

export interface GqlMatCreateInput {
  isDefault: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
}

export interface GqlMatDeletedResponse {
  id: Scalars['ID']['output'];
}

export interface GqlMatSetIsDefaultInput {
  id: Scalars['ID']['input'];
  isDefault: Scalars['Boolean']['input'];
}

export interface GqlMatSetNameInput {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}

export interface GqlMatiCreateInput {
  commentPrimaryLang?: InputMaybe<Scalars['String']['input']>;
  commentSecondaryLang?: InputMaybe<Scalars['String']['input']>;
  decisionPrimaryLang?: InputMaybe<Scalars['String']['input']>;
  decisionSecondaryLang?: InputMaybe<Scalars['String']['input']>;
  firstGroup: Scalars['Boolean']['input'];
  kind: GqlAgendaItemKind;
  lastGroup: Scalars['Boolean']['input'];
  mandatory: Scalars['Boolean']['input'];
  meetingAgendaTemplateId: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
  subjectPrimaryLang: Scalars['String']['input'];
  subjectSecondaryLang: Scalars['String']['input'];
}

export interface GqlMatiDeletedResponse {
  id: Scalars['ID']['output'];
  updatedMatis: Array<GqlMeetingAgendaTemplateItem>;
}

export interface GqlMatiSetOrderInput {
  id: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
}

export interface GqlMatiUpdateInput {
  commentPrimaryLang?: InputMaybe<Scalars['String']['input']>;
  commentSecondaryLang?: InputMaybe<Scalars['String']['input']>;
  decisionPrimaryLang?: InputMaybe<Scalars['String']['input']>;
  decisionSecondaryLang?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  mandatory: Scalars['Boolean']['input'];
  order: Scalars['Int']['input'];
  subjectPrimaryLang: Scalars['String']['input'];
  subjectSecondaryLang: Scalars['String']['input'];
}

export interface GqlMcDeletedResponse {
  id: Scalars['ID']['output'];
}

export interface GqlMcSetApprovedInput {
  approved: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
}

export interface GqlMeeting {
  agendaItems: Array<GqlAgendaItem>;
  agendaItemsDone: Scalars['Boolean']['output'];
  approvedByMeeting?: Maybe<Scalars['ID']['output']>;
  boardsRecommendation: Scalars['Boolean']['output'];
  company: GqlCompany;
  companyId: Scalars['ID']['output'];
  contactEmail?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  createdByMeeting?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['Date']['output']>;
  heldKind: GqlMeetingHeldKind;
  id: Scalars['ID']['output'];
  kind: GqlMeetingKind;
  latestMinutesDocument?: Maybe<GqlBolagoFile>;
  latestSummonsCoverSheet?: Maybe<GqlBolagoFile>;
  latestSummonsDocument?: Maybe<GqlBolagoFile>;
  meetingAppendices: Array<GqlBolagoFile>;
  meetingConcerns: Array<GqlMeetingConcern>;
  meetingDocuments: Array<GqlMeetingDocument>;
  meetingParticipants: Array<GqlMeetingParticipant>;
  meetingTodos: Array<GqlMeetingTodo>;
  number?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  place?: Maybe<Scalars['String']['output']>;
  postalVote: Scalars['Boolean']['output'];
  postalVoteDate?: Maybe<Scalars['Date']['output']>;
  postalVoteEmail?: Maybe<Scalars['String']['output']>;
  primaryLang: Scalars['Boolean']['output'];
  registerAttendance?: Maybe<Scalars['Boolean']['output']>;
  registerAttendanceDate?: Maybe<Scalars['Date']['output']>;
  secondaryLang: Scalars['Boolean']['output'];
  startTime: Scalars['Date']['output'];
  status: GqlMeetingStatus;
  summonStatus: GqlMeetingSummonStatus;
  summonsAttachments: Array<GqlBolagoFile>;
  updatedAt: Scalars['Date']['output'];
  usesStepper: Scalars['Boolean']['output'];
}

export interface GqlMeetingAgendaTemplate {
  company: GqlCompany;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  meetingAgendaTemplateItems: Array<GqlMeetingAgendaTemplateItem>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
}

export interface GqlMeetingAgendaTemplateItem {
  commentPrimaryLang?: Maybe<Scalars['String']['output']>;
  commentSecondaryLang?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  decisionPrimaryLang?: Maybe<Scalars['String']['output']>;
  decisionSecondaryLang?: Maybe<Scalars['String']['output']>;
  firstGroup: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  kind: GqlAgendaItemKind;
  lastGroup: Scalars['Boolean']['output'];
  mandatory: Scalars['Boolean']['output'];
  meetingAgendaTemplate: GqlMeetingAgendaTemplate;
  meetingAgendaTemplateId: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  subjectPrimaryLang: Scalars['String']['output'];
  subjectSecondaryLang: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
}

export enum GqlMeetingBase {
  Day = 'day',
  Halfyear = 'halfyear',
  Month = 'month',
  Quarter = 'quarter',
  Tertial = 'tertial',
  Week = 'week',
  Year = 'year'
}

export interface GqlMeetingBoardsRecommendationInput {
  boardsRecommendation: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
}

export interface GqlMeetingConcern {
  appendixNumber: Scalars['Int']['output'];
  approved?: Maybe<Scalars['Boolean']['output']>;
  articlesOfAssoc?: Maybe<GqlArticlesOfAssoc>;
  articlesOfAssocId?: Maybe<Scalars['ID']['output']>;
  authorizationGroup?: Maybe<GqlAuthorizationGroup>;
  authorizationGroupId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  meeting: GqlMeeting;
  meetingId: Scalars['String']['output'];
  shareIssue?: Maybe<GqlShareIssue>;
  shareIssueId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['Date']['output'];
  warrantProgram?: Maybe<GqlWarrantProgram>;
  warrantProgramId?: Maybe<Scalars['ID']['output']>;
}

export interface GqlMeetingCreateInput {
  createdByMeeting?: InputMaybe<Scalars['ID']['input']>;
  endTime?: InputMaybe<Scalars['Date']['input']>;
  heldKind: GqlMeetingHeldKind;
  kind: GqlMeetingKind;
  meetingTemplateId?: InputMaybe<Scalars['ID']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['Date']['input'];
  usesStepper: Scalars['Boolean']['input'];
}

export interface GqlMeetingDeleteInput {
  id: Scalars['ID']['input'];
  resetCreatorAgendaItem?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface GqlMeetingDeletedResponse {
  deletedMcs: Array<GqlMcDeletedResponse>;
  id: Scalars['ID']['output'];
}

export interface GqlMeetingDocument {
  createdAt: Scalars['Date']['output'];
  file?: Maybe<GqlBolagoFile>;
  fileId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  meeting: GqlMeeting;
  meetingId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
}

export interface GqlMeetingHasQesRegFormsInput {
  id: Scalars['ID']['input'];
  skipId: Scalars['String']['input'];
}

export enum GqlMeetingHeldKind {
  PerCapsulam = 'PerCapsulam',
  Phone = 'Phone',
  Physical = 'Physical',
  PhysicalAndPhone = 'PhysicalAndPhone'
}

export enum GqlMeetingKind {
  BoardMeeting = 'BoardMeeting',
  ExtraShareholdersMeeting = 'ExtraShareholdersMeeting',
  ShareholdersMeeting = 'ShareholdersMeeting'
}

export interface GqlMeetingMcCountsResponse {
  articlesOfAssocs: Scalars['Float']['output'];
  authorizationGroups: Scalars['Float']['output'];
  employeeOptions: Scalars['Float']['output'];
  shareIssues: Scalars['Float']['output'];
  warrantPrograms: Scalars['Float']['output'];
}

export interface GqlMeetingPaidForConcernsResponse {
  shareIssues: Array<GqlShareIssue>;
  warrantPrograms: Array<GqlWarrantProgram>;
}

export interface GqlMeetingParticipant {
  adjuster: Scalars['Boolean']['output'];
  chairman: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  identity: GqlIdentity;
  identityId: Scalars['String']['output'];
  initials?: Maybe<Scalars['String']['output']>;
  isShareholder: Scalars['Boolean']['output'];
  kind: GqlMpKind;
  latestMeetingParticipantEmail?: Maybe<GqlMeetingParticipantEmail>;
  latestPowerOfAttorney?: Maybe<GqlBolagoFile>;
  meeting: GqlMeeting;
  meetingId?: Maybe<Scalars['String']['output']>;
  meetingParticipantShares: Array<GqlMeetingParticipantShare>;
  position?: Maybe<Scalars['String']['output']>;
  present: Scalars['Boolean']['output'];
  proxy?: Maybe<GqlIdentity>;
  proxyId?: Maybe<Scalars['String']['output']>;
  secretary: Scalars['Boolean']['output'];
  summoned?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['Date']['output'];
}

export interface GqlMeetingParticipantDocument {
  createdAt: Scalars['Date']['output'];
  file: GqlBolagoFile;
  fileId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  meetingParticipantId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
}

export interface GqlMeetingParticipantEmail {
  createdAt: Scalars['Date']['output'];
  email: GqlEmail;
  emailId: Scalars['ID']['output'];
  fileId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  meetingParticipantId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
}

export interface GqlMeetingParticipantFilterInput {
  failedEmailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  hasProxy?: InputMaybe<Scalars['Boolean']['input']>;
  identity?: InputMaybe<GqlIdentityFilterInput>;
  isShareholder?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface GqlMeetingParticipantShare {
  id: Scalars['ID']['output'];
  meetingParticipant?: Maybe<GqlMeetingParticipant>;
  meetingParticipantId: Scalars['ID']['output'];
  numberOfShares?: Maybe<Scalars['String']['output']>;
  numberOfVotes?: Maybe<Scalars['String']['output']>;
  shareClass?: Maybe<GqlShareClass>;
}

/** Create meeting participant share */
export interface GqlMeetingParticipantShareCreateInput {
  meetingParticipantId: Scalars['String']['input'];
  numberOfShares: Scalars['String']['input'];
  numberOfVotes: Scalars['String']['input'];
  shareClass: GqlShareClassInput;
}

export interface GqlMeetingParticipantShareDeletedResponse {
  affectedDocuments: Array<GqlBolagoFile>;
  id: Scalars['ID']['output'];
  mpDeletedResponse?: Maybe<GqlMpDeletedResponse>;
}

/** Update meeting participant share */
export interface GqlMeetingParticipantShareUpdateInput {
  id: Scalars['ID']['input'];
  numberOfShares?: InputMaybe<Scalars['String']['input']>;
  numberOfVotes?: InputMaybe<Scalars['String']['input']>;
  shareClass?: InputMaybe<GqlShareClassInput>;
}

export interface GqlMeetingParticipantShareUpdatedResponse {
  affectedDocuments: Array<GqlBolagoFile>;
  meetingParticipantShare: GqlMeetingParticipantShare;
}

export interface GqlMeetingParticipantsPagedResult {
  models: Array<GqlMeetingParticipant>;
  totalCount: Scalars['Int']['output'];
}

export interface GqlMeetingPostalVoteInput {
  id: Scalars['ID']['input'];
  postalVote: Scalars['Boolean']['input'];
  postalVoteDate?: InputMaybe<Scalars['Date']['input']>;
  postalVoteEmail?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlMeetingSetApprovedByMeetingInput {
  approvedByMeeting: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  setApproved: Scalars['Boolean']['input'];
}

export interface GqlMeetingSetContactEmailInput {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  registerAttendanceDate?: InputMaybe<Scalars['Date']['input']>;
}

export interface GqlMeetingSetDetailsInput {
  endTime?: InputMaybe<Scalars['Date']['input']>;
  heldKind: GqlMeetingHeldKind;
  id: Scalars['ID']['input'];
  number?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['Date']['input'];
}

export interface GqlMeetingSetFunctionsInput {
  id: Scalars['ID']['input'];
  mpCreate: GqlMpCreateInput;
}

export interface GqlMeetingSetFunctionsResponse {
  meeting: GqlMeeting;
  meetingParticipants: Array<GqlMeetingParticipant>;
}

export interface GqlMeetingSetLanguageInput {
  id: Scalars['ID']['input'];
  primaryLang: Scalars['Boolean']['input'];
  secondaryLang: Scalars['Boolean']['input'];
}

export enum GqlMeetingStatus {
  Finished = 'Finished',
  InProgress = 'InProgress',
  Scheduled = 'Scheduled'
}

export enum GqlMeetingSummonStatus {
  Never = 'never',
  Pending = 'pending',
  Sent = 'sent'
}

export interface GqlMeetingTodo {
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  meeting: GqlMeeting;
  meetingId: Scalars['ID']['output'];
  todo: GqlTodo;
  todoId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
}

export interface GqlMeetingValidatorErrors {
  agenda: GqlValidatorStatus;
  details: GqlValidatorStatus;
  emailSummons: GqlValidatorStatus;
  language: GqlValidatorStatus;
  participants: GqlValidatorStatus;
  postalVote: GqlValidatorStatus;
  protocol: GqlValidatorStatus;
  registerAttendance: GqlValidatorStatus;
  summons: GqlValidatorStatus;
  votingList: GqlValidatorStatus;
}

export interface GqlMeetingsPagedResult {
  models: Array<GqlMeeting>;
  totalCount: Scalars['Int']['output'];
}

export interface GqlMinAndMaxOfSharesResponse {
  max?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['String']['output']>;
}

export interface GqlMoveFileInput {
  id: Scalars['ID']['input'];
  targetId?: InputMaybe<Scalars['ID']['input']>;
}

/** Create warrant participant */
export interface GqlMpCreateInput {
  adjuster: Scalars['Boolean']['input'];
  chairman: Scalars['Boolean']['input'];
  identityInput: GqlCreateIdentityInput;
  isShareholder: Scalars['Boolean']['input'];
  kind: GqlMpKind;
  meetingId: Scalars['ID']['input'];
  present: Scalars['Boolean']['input'];
  secretary: Scalars['Boolean']['input'];
}

export interface GqlMpDeletedResponse {
  aiSetDoneResponse?: Maybe<GqlAiSetDoneResponse>;
  id: Scalars['ID']['output'];
}

export interface GqlMpDeletedShareholdersResponse {
  aiSetDoneResponse: GqlAiSetDoneResponse;
  meetingId: Scalars['ID']['output'];
}

/** Import share state to meeting voting list */
export interface GqlMpImportShareStateInput {
  date: Scalars['Date']['input'];
  meetingId: Scalars['ID']['input'];
}

export interface GqlMpImportShareStateResponse {
  added: Array<GqlMeetingParticipant>;
  affectedDocuments: Array<GqlBolagoFile>;
  aiSetDoneResponse?: Maybe<GqlAiSetDoneResponse>;
  removed: Array<GqlMpDeletedResponse>;
  updated: Array<GqlMeetingParticipant>;
}

export interface GqlMpSetFunctionsInput {
  adjuster?: InputMaybe<Scalars['Boolean']['input']>;
  chairman?: InputMaybe<Scalars['Boolean']['input']>;
  ids: Array<Scalars['ID']['input']>;
  secretary?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface GqlMpSetPresentInput {
  id: Scalars['ID']['input'];
  present: Scalars['Boolean']['input'];
}

/** set proxy */
export interface GqlMpSetProxyInput {
  id: Scalars['ID']['input'];
  proxyInput: GqlCreateIdentityInput;
}

/** Create meeting todo */
export interface GqlMtCreateInput {
  meetingId: Scalars['ID']['input'];
  todoCreate: GqlTodoCreateInput;
}

export interface GqlMtDeletedResponse {
  id: Scalars['ID']['output'];
}

/** Update meeting todo */
export interface GqlMtSetDoneInput {
  id: Scalars['ID']['input'];
  todoDone: GqlTodoSetDoneInput;
}

export interface GqlMutation {
  adminZignedDocSendSignReminder: GqlBolagoFile;
  adminZignedDocSignRefresh: GqlBolagoFile;
  agConnectMeeting: GqlAgConnectMeetingResponse;
  agCreateMeeting: GqlAgConnectMeetingResponse;
  agDisconnectMeeting: GqlAgDisconnectMeetingResponse;
  agSetNoBoardStatement: GqlAuthorizationGroup;
  agSetSnrAuthId: GqlAuthorizationGroup;
  agSetSnrCaseId: GqlAuthorizationGroup;
  agSetValidThru: GqlAuthorizationGroup;
  agUpdate: GqlAuthorizationGroup;
  aoaConnectMeeting: GqlArticlesOfAssoc;
  aoaCreateMeeting: GqlArticlesOfAssoc;
  aoaDisconnectMeeting: GqlAoaDisconnectMeetingResponse;
  aoaSetShareChange: GqlArticlesOfAssoc;
  aoaToggleShareChange: GqlArticlesOfAssoc;
  aoaUpdate: GqlArticlesOfAssoc;
  capTableStakeDelete: GqlCapTableStake;
  capTableStakeSetEnabled: GqlCapTableStake;
  capTableStakeUpdate: GqlCapTableStake;
  cdSetInvited: GqlCompanyDirector;
  cirAccept?: Maybe<Scalars['Void']['output']>;
  cirReject?: Maybe<Scalars['Void']['output']>;
  cmpCreate: GqlCooptedMeetingParticipant;
  cmpDelete: GqlCmpDeletedResponse;
  cmpSetInvited: GqlCooptedMeetingParticipant;
  companyDelete?: Maybe<Scalars['Void']['output']>;
  companyProvision: GqlProvisionedCompany;
  companyRefresh?: Maybe<Scalars['Void']['output']>;
  companySetMeetingFrequency: GqlCompany;
  companySetProfile: GqlCompany;
  companySetSharesAtFoundation: GqlCompany;
  companySyncToHubspot: GqlCompany;
  createAgreement: GqlAgreement;
  createAi: Array<GqlAgendaItem>;
  createAid: GqlAgendaItemDecision;
  createArticlesOfAssoc: GqlArticlesOfAssoc;
  createAuthorization: GqlAuthorization;
  createAuthorizationGroup: GqlAuthorizationGroup;
  createCapTable: GqlCapTable;
  createCapTableStake: GqlCapTableStake;
  createCapTableStakes: Array<GqlCapTableStake>;
  createCompanyInvite: GqlCompanyInvite;
  createCompanyInviteRequest?: Maybe<Scalars['Void']['output']>;
  createCompanyUser: GqlCompanyUser;
  createDocumentSignature: GqlDocumentSignature;
  createFolder: GqlBolagoFile;
  createIdentity: GqlIdentity;
  createMeeting: GqlMeeting;
  createMeetingParticipant: GqlMeetingParticipant;
  createMeetingParticipantShare: GqlMeetingParticipantShare;
  createMeetingTodo: GqlMeetingTodo;
  createNiceFounder: GqlNiceFounderCreatedResponse;
  createOptionsRegistration: GqlOptionsRegistration;
  createOptionsSharesRegistration: GqlOptionsSharesRegistration;
  createOptionsSharesSubscriberRepresentative: GqlOptionsSharesSubscriberRepresentative;
  createOptionsSubscriberRepresentative: GqlOptionsSubscriberRepresentative;
  createShareIssue: GqlShareIssue;
  createShareIssueBoardMember: GqlShareIssueBoardMember;
  createShareIssueParticipant: GqlShareIssueParticipant;
  createShareIssueRegistration: GqlShareIssueRegistration;
  createShareTransactionGroup: GqlStgCreatedResponse;
  createShareholder: GqlShareholder;
  createWarrantBoardMember: GqlWarrantBoardMember;
  createWarrantProgram: GqlWarrantProgram;
  createWarrantShareholder: GqlWarrantShareholder;
  createWdbFromBond: GqlWiseDependencyBond;
  createWiseDepBond: GqlWiseDependencyBond;
  createWpFromSnrBond: GqlWarrantProgram;
  deleteAi: GqlAiDeletedResponse;
  deleteAid: GqlAidDeletedResponse;
  deleteArticlesOfAssoc: GqlAoaDeletedResponse;
  deleteAuthorization: GqlAuthDeletedResponse;
  deleteAuthorizationGroup: GqlAgDeletedResponse;
  deleteCapTable?: Maybe<Scalars['Void']['output']>;
  deleteCompanyInvite?: Maybe<Scalars['Void']['output']>;
  deleteCompanyUser: GqlCuDeletedResponse;
  deleteDocumentSignature: GqlDsDeletedResponse;
  deleteEmptyShareTransactionGroup: GqlStsMutationResponse;
  deleteFile: GqlFileDeletedResponse;
  deleteMeeting: GqlMeetingDeletedResponse;
  deleteMeetingParticipant: GqlMpDeletedResponse;
  deleteMeetingParticipantShare: GqlMeetingParticipantShareDeletedResponse;
  deleteMeetingShareholders: GqlMpDeletedShareholdersResponse;
  deleteMeetingSummonsAttachment: Scalars['Void']['output'];
  deleteMeetingTodo: GqlMtDeletedResponse;
  deleteNiceFounder: GqlNiceFounderDeletedResponse;
  deleteOptionsSharesSubscriberRepresentative: GqlOptionsSharesSubscriberRepresentativeDeletedResponse;
  deleteOptionsSubscriberRepresentative: GqlOptionsSubscriberRepresentativeDeletedResponse;
  deletePasskey: GqlPasskeyDeletedResponse;
  deleteShareIssue: GqlSiDeletedResponse;
  deleteShareIssueBoardMember: GqlSibmDeletedResponse;
  deleteShareIssueParticipant: GqlSipDeletedResponse;
  deleteShareTransactionGroup: GqlStsMutationResponse;
  deleteShareTransactions: GqlStsMutationResponse;
  deleteShareholder: GqlShDeletedResponse;
  deleteWarrantBoardMember: GqlWpbmDeletedResponse;
  deleteWarrantProgram: GqlWpDeletedResponse;
  deleteWarrantShareholder: GqlWshDeletedResponse;
  deleteWiseDependencyBond: GqlWdbDeletedResponse;
  docGenAgRegistrationForm: GqlBolagoFile;
  docGenAoaRegistrationForm: GqlBolagoFile;
  docGenConvertibleRegistrationForm: GqlBolagoFile;
  docGenIndividualReport: GqlDocumentGenReq;
  docGenIndividualReportSh: GqlDocumentGenReq;
  docGenNiceAgreement: GqlBolagoFile;
  docGenOptionsShareSubscriptionList: GqlBolagoFile;
  docGenPowerOfAttorney: GqlBolagoFile;
  docGenQesoAgreement: GqlBolagoFile;
  docGenScheduleDocGen: GqlBolagoFile;
  docGenShareCertificate: GqlDocumentGenReq;
  docGenShareSubscriptionList: GqlBolagoFile;
  docGenSiRegistrationForm: GqlBolagoFile;
  docGenTransactionNote: GqlDocumentGenReq;
  docGenTransactionNoteSh: GqlDocumentGenReq;
  docGenWarrantAgreement: GqlBolagoFile;
  docGenWarrantRegistrationForm: GqlBolagoFile;
  docGenWarrantSharesRegistrationForm: GqlBolagoFile;
  docGenWiseAgreement: GqlBolagoFile;
  docGenerateMeetingMinutes: GqlBolagoFile;
  docGenerateMeetingSummons: GqlBolagoFile;
  docGenerateMeetingSummonsDirect: GqlBolagoFile;
  dsSetAuthMethodToSign: GqlDocumentSignature;
  dsSetEmailAndMobile: GqlDocumentSignature;
  dsSetProxy: GqlDocumentSignature;
  duplicateCapTable: GqlCapTable;
  editWiseDependencyBond: GqlWiseDependencyBond;
  fileSendSignReminder: GqlBolagoFile;
  fileSetTags: GqlBolagoFile;
  fileSignRefresh: GqlBolagoFile;
  fileSignStart: GqlBolagoFile;
  fileSignStop: GqlBolagoFile;
  fileSoftDelete: GqlFileDeletedResponse;
  generateAgreementPdf: GqlAgreement;
  matCreate: Array<GqlMeetingAgendaTemplate>;
  matDelete: GqlMatDeletedResponse;
  matSetIsDefault: Array<GqlMeetingAgendaTemplate>;
  matSetName: GqlMeetingAgendaTemplate;
  matiCreate?: Maybe<Scalars['Void']['output']>;
  matiDelete: GqlMatiDeletedResponse;
  matiSetOrder: Array<GqlMeetingAgendaTemplateItem>;
  matiUpdate?: Maybe<Scalars['Void']['output']>;
  mcSetApproved: GqlMeetingConcern;
  meetingSetApprovedByMeeting: GqlMeeting;
  meetingSetFunctions: GqlMeetingSetFunctionsResponse;
  moveFile: GqlBolagoFile;
  mpImportShareState: GqlMpImportShareStateResponse;
  mpSetFunctions: Array<GqlMeetingParticipant>;
  mpSetPresent: GqlMeetingParticipant;
  mpSetProxy: GqlMeetingParticipant;
  mtSetDone: GqlMeetingTodo;
  niceFounderImportFounders: GqlNiceFounderImportFoundersResponse;
  orDelete: GqlOrDeletedResponse;
  orSetPayBeforeDate: GqlOrUpdateResponse;
  orSetPayment: GqlOrUpdateResponse;
  orSetSnrCase: GqlOptionsRegistration;
  orSignatoryCreate: GqlOrSignatoryCreateResponse;
  orSignatoryDelete: GqlOrSignatoryDeletedResponse;
  orUpdate: GqlOrUpdateResponse;
  osrDelete: GqlOsrDeletedResponse;
  osrSetPayBeforeDate: GqlOsrUpdateResponse;
  osrSetPayment: GqlOsrUpdateResponse;
  osrSetRecordDay: GqlOsrUpdateResponse;
  osrSetRegDetails: GqlOsrUpdateResponse;
  osrSetSnrCase: GqlOptionsSharesRegistration;
  osrUpdate: GqlOsrUpdateResponse;
  ossCreate: GqlOptionsSharesSubscriber;
  ossDelete: GqlOssDeletedResponse;
  ossSetPaymentStatus: GqlOssUpdateResponse;
  ossUpdate: GqlOssUpdateResponse;
  refreshCapTable: GqlCapTable;
  refreshIdentity: GqlIdentity;
  resetAis: Array<GqlAgendaItem>;
  sendMailMeetingSummonsToAll: Array<GqlMeetingParticipant>;
  sendMailMeetingSummonsToOne: GqlMeetingParticipant;
  sendPromoInvite: Scalars['Boolean']['output'];
  setAiDone: GqlAiSetDoneResponse;
  setAiOrder: Array<GqlAgendaItem>;
  setIdentityEmail: GqlIdentity;
  setIdentityPhone: GqlIdentity;
  setMeetingBoardsRecommendation: GqlMeeting;
  setMeetingContactEmail: GqlMeeting;
  setMeetingDetails: GqlMeeting;
  setMeetingLanguage: GqlMeeting;
  setMeetingPostalVote: GqlMeeting;
  siConnectAuthorization: GqlShareIssue;
  siConnectMeeting: GqlSiConnectMeetingResponse;
  siCreateMeeting: GqlSiConnectMeetingResponse;
  siDisconnectAuthorization: GqlShareIssue;
  siDisconnectMeeting: GqlSiDisconnectMeetingResponse;
  siSetBoardStatement: GqlSiSetBoardsStatementResponse;
  siSetDescription: GqlShareIssue;
  siSetLanguage: GqlShareIssue;
  siSetNewShares: GqlShareIssue;
  siSetNonCashStatement: GqlShareIssue;
  siSetPaymentKind: GqlSiSetPaymentKindResponse;
  siSetShareClass: GqlShareIssue;
  siSetSubscriptionDates: GqlShareIssue;
  siUpdate: GqlShareIssue;
  sipEdit: GqlShareIssueParticipant;
  sipSetPaymentStatus: GqlSipUpdateResponse;
  sipSetProxy: GqlSipUpdateResponse;
  sirSetCurrencyExchangeRate: GqlSirUpdateResponse;
  sirSetPayment: GqlSirUpdateResponse;
  sirSetPaymentDueDate: GqlSirUpdateResponse;
  sirSetSnrCase: GqlShareIssueRegistration;
  sirUpdate: GqlSirUpdateResponse;
  stCreateIssue: Array<GqlShareTransaction>;
  stCreateTransfer: GqlStsMutationResponse;
  stCreateUnissue: GqlStsMutationResponse;
  stImportTransfers?: Maybe<Scalars['Void']['output']>;
  stSetComment: GqlShareTransaction;
  stSetPricePerShare: GqlShareTransaction;
  stSetShareCertificateDate: GqlShareTransaction;
  stgSetSccId: GqlShareTransactionGroup;
  stgSetup: Array<GqlShareTransactionGroup>;
  stripeAcceptQuote: GqlStripeInvoice;
  stripeCreateBillingPortalSession: GqlStripeBillingPortalSession;
  stripeCreateCustomer: GqlCompany;
  stripeCreateMeetingConcernsPaymentQuote: GqlStripeQuote;
  stripeCreateSetupCheckoutSession: GqlStripeCheckoutSession;
  stripeCreateSubscriptionCheckoutSession: GqlStripeCheckoutSession;
  stripeCreateSubscriptionQuote: GqlStripeQuote;
  stripeDeletePaymentMethod: GqlStripePaymentMethod;
  stripeEstablishInvitePromo: GqlStripePromotionCode;
  stripePayInvoice: GqlStripeInvoice;
  stripePreviewSubUpdate: GqlStripeUpcomingInvoice;
  stripeQuoteSetPromo: GqlStripeQuote;
  stripeSetDefaultPaymentMethod: GqlStripeCustomer;
  stripeUpgradeSubscription: GqlStripeSubscription;
  todoSetDone: GqlTodo;
  toggleRegistrationTodo?: Maybe<GqlRegistrationTodoCompletion>;
  updateAid: GqlAgendaItemDecision;
  updateAuthorization: GqlAuthorization;
  updateCapTable: GqlCapTable;
  updateFile: GqlBolagoFile;
  updateIdentity: GqlIdentity;
  updateMeetingParticipantShare: GqlMeetingParticipantShareUpdatedResponse;
  updateTodo: GqlTodo;
  updateWarrantProgram: GqlWarrantProgram;
  upsertValue: GqlAgreementValue;
  userSetContactDetails: GqlUser;
  userSetFeaturePreference: GqlUser;
  userSyncToHubspot: GqlUser;
  wpConnectAuthorization: GqlWarrantProgram;
  wpConnectMeeting: GqlWpConnectMeetingResponse;
  wpCreateMeeting: GqlWpConnectMeetingResponse;
  wpDisconnectAuthorization: GqlWarrantProgram;
  wpDisconnectMeeting: GqlWpDisconnectMeetingResponse;
  wpRefreshInterestRate: GqlWarrantProgram;
  wpSetBoardsStatement: GqlWpSetBoardsStatementResponse;
  wpSetDates: GqlWarrantProgram;
  wpSetDescription: GqlWarrantProgram;
  wpSetLanguage: GqlWarrantProgram;
  wpSetMaxNumberOfOptions: GqlWarrantProgram;
  wpSetNicePrice: GqlWarrantProgram;
  wpSetNonCashStatement: GqlWarrantProgram;
  wpSetNumberOfShares: GqlWarrantProgram;
  wpSetPaymentKind: GqlWpSetPaymentKindResponse;
  wpSetPlayground: GqlWarrantProgram;
  wpSetReason: GqlWarrantProgram;
  wpSetShareClass: GqlWarrantProgram;
  wpSetStrikePrice: GqlWarrantProgram;
  wpSetValuation: GqlWarrantProgram;
  wpSetVolatility: GqlWarrantProgram;
  wpSetWiseFullyDiluted: GqlWdbResetResponse;
  wpSetWisePrice: GqlWarrantProgram;
  wpSetWiseRecordDay: GqlWdbResetResponse;
  wpaSetDuration: GqlWarrantProgram;
  wpaSetStrikePrice: GqlWarrantProgram;
  wppAddCustomVestingOccasion: GqlWarrantParticipant;
  wppCreate: GqlWarrantParticipant;
  wppDelete: GqlWppDeletedResponse;
  wppDeleteCustomVestingOccasion: GqlWarrantParticipant;
  wppExplainVestingSchedule: GqlWarrantParticipant;
  wppUpdate: GqlWppUpdateResponse;
  wppUpdateCustomVestingOccasion: GqlWarrantParticipant;
  wshImportShareState: GqlWshImportShareStateResponse;
  wshRemoveProxy: GqlWshUpdateResponse;
  wshSetProxy: GqlWshUpdateResponse;
}


export interface GqlMutationAdminZignedDocSendSignReminderArgs {
  input: GqlFileSendSignReminderInput;
}


export interface GqlMutationAdminZignedDocSignRefreshArgs {
  id: Scalars['ID']['input'];
}


export interface GqlMutationAgConnectMeetingArgs {
  companyId: Scalars['ID']['input'];
  input: GqlAgConnectMeetingInput;
}


export interface GqlMutationAgCreateMeetingArgs {
  companyId: Scalars['ID']['input'];
  input: GqlAgCreateMeetingInput;
}


export interface GqlMutationAgDisconnectMeetingArgs {
  companyId: Scalars['ID']['input'];
  input: GqlAgDisconnectMeetingInput;
}


export interface GqlMutationAgSetNoBoardStatementArgs {
  companyId: Scalars['ID']['input'];
  input: GqlAgSetNoBoardStatementInput;
}


export interface GqlMutationAgSetSnrAuthIdArgs {
  companyId: Scalars['ID']['input'];
  input: GqlAgSetSnrAuthIdInput;
}


export interface GqlMutationAgSetSnrCaseIdArgs {
  companyId: Scalars['ID']['input'];
  input: GqlAgSetSnrCaseIdInput;
}


export interface GqlMutationAgSetValidThruArgs {
  companyId: Scalars['ID']['input'];
  input: GqlAgSetValidThruInput;
}


export interface GqlMutationAgUpdateArgs {
  companyId: Scalars['ID']['input'];
  input: GqlAgUpdateInput;
}


export interface GqlMutationAoaConnectMeetingArgs {
  companyId: Scalars['ID']['input'];
  input: GqlAoaConnectMeetingInput;
}


export interface GqlMutationAoaCreateMeetingArgs {
  companyId: Scalars['ID']['input'];
  input: GqlAoaCreateMeetingInput;
}


export interface GqlMutationAoaDisconnectMeetingArgs {
  companyId: Scalars['ID']['input'];
  input: GqlAoaDisconnectMeetingInput;
}


export interface GqlMutationAoaSetShareChangeArgs {
  companyId: Scalars['ID']['input'];
  input: GqlAoaSetShareChangeInput;
}


export interface GqlMutationAoaToggleShareChangeArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationAoaUpdateArgs {
  companyId: Scalars['ID']['input'];
  input: GqlAoaUpdateInput;
}


export interface GqlMutationCapTableStakeDeleteArgs {
  companyId: Scalars['ID']['input'];
  input: GqlCapTableStakeDeleteInput;
}


export interface GqlMutationCapTableStakeSetEnabledArgs {
  companyId: Scalars['ID']['input'];
  input: GqlCapTableStakeSetEnabledInput;
}


export interface GqlMutationCapTableStakeUpdateArgs {
  companyId: Scalars['ID']['input'];
  input: GqlCapTableStakeUpdateInput;
}


export interface GqlMutationCdSetInvitedArgs {
  companyId: Scalars['ID']['input'];
  input: GqlCdSetInvitedInput;
}


export interface GqlMutationCirAcceptArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationCirRejectArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationCmpCreateArgs {
  companyId: Scalars['ID']['input'];
  input: GqlCmpCreateInput;
}


export interface GqlMutationCmpDeleteArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationCmpSetInvitedArgs {
  companyId: Scalars['ID']['input'];
  input: GqlCmpSetInvitedInput;
}


export interface GqlMutationCompanyDeleteArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlMutationCompanyProvisionArgs {
  input: GqlCompanyProvisionInput;
}


export interface GqlMutationCompanyRefreshArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlMutationCompanySetMeetingFrequencyArgs {
  companyId: Scalars['ID']['input'];
  input: GqlCompanySetMeetingFrequencyInput;
}


export interface GqlMutationCompanySetProfileArgs {
  companyId: Scalars['ID']['input'];
  input: GqlCompanySetProfileInput;
}


export interface GqlMutationCompanySetSharesAtFoundationArgs {
  companyId: Scalars['ID']['input'];
  input: GqlCompanySetSharesAtFoundationInput;
}


export interface GqlMutationCompanySyncToHubspotArgs {
  id: Scalars['ID']['input'];
}


export interface GqlMutationCreateAgreementArgs {
  companyId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  templateRevisionId: Scalars['String']['input'];
}


export interface GqlMutationCreateAiArgs {
  companyId: Scalars['ID']['input'];
  input: GqlAiCreateInput;
}


export interface GqlMutationCreateAidArgs {
  companyId: Scalars['ID']['input'];
  input: GqlAidCreateInput;
}


export interface GqlMutationCreateArticlesOfAssocArgs {
  companyId: Scalars['ID']['input'];
  input: GqlAoaCreateInput;
}


export interface GqlMutationCreateAuthorizationArgs {
  companyId: Scalars['ID']['input'];
  input: GqlAuthCreateInput;
}


export interface GqlMutationCreateAuthorizationGroupArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlMutationCreateCapTableArgs {
  companyId: Scalars['ID']['input'];
  input: GqlCreateCapTableInput;
}


export interface GqlMutationCreateCapTableStakeArgs {
  companyId: Scalars['ID']['input'];
  input: GqlCreateCapTableStakeInput;
}


export interface GqlMutationCreateCapTableStakesArgs {
  companyId: Scalars['ID']['input'];
  input: GqlCreateCapTableStakesInput;
}


export interface GqlMutationCreateCompanyInviteArgs {
  companyId: Scalars['ID']['input'];
  input: GqlCiCreateInput;
}


export interface GqlMutationCreateCompanyInviteRequestArgs {
  companyId: Scalars['ID']['input'];
  role: GqlCompanyUserRole;
}


export interface GqlMutationCreateCompanyUserArgs {
  companyId: Scalars['ID']['input'];
  input: GqlCuCreateInput;
}


export interface GqlMutationCreateDocumentSignatureArgs {
  companyId: Scalars['ID']['input'];
  input: GqlDsCreateInput;
}


export interface GqlMutationCreateFolderArgs {
  input: GqlCreateFolderInput;
}


export interface GqlMutationCreateIdentityArgs {
  companyId: Scalars['ID']['input'];
  input: GqlCreateIdentityInput;
}


export interface GqlMutationCreateMeetingArgs {
  companyId: Scalars['ID']['input'];
  input: GqlMeetingCreateInput;
}


export interface GqlMutationCreateMeetingParticipantArgs {
  companyId: Scalars['ID']['input'];
  input: GqlMpCreateInput;
}


export interface GqlMutationCreateMeetingParticipantShareArgs {
  companyId: Scalars['ID']['input'];
  input: GqlMeetingParticipantShareCreateInput;
}


export interface GqlMutationCreateMeetingTodoArgs {
  companyId: Scalars['ID']['input'];
  input: GqlMtCreateInput;
}


export interface GqlMutationCreateNiceFounderArgs {
  companyId: Scalars['ID']['input'];
  input: GqlNiceFounderCreateInput;
}


export interface GqlMutationCreateOptionsRegistrationArgs {
  companyId: Scalars['ID']['input'];
  input: GqlOrCreateInput;
}


export interface GqlMutationCreateOptionsSharesRegistrationArgs {
  companyId: Scalars['ID']['input'];
  input: GqlOsrCreateInput;
}


export interface GqlMutationCreateOptionsSharesSubscriberRepresentativeArgs {
  companyId: Scalars['ID']['input'];
  input: GqlOptionsSharesSubscriberRepresentativeCreateInput;
}


export interface GqlMutationCreateOptionsSubscriberRepresentativeArgs {
  companyId: Scalars['ID']['input'];
  input: GqlOptionsSubscriberRepresentativeCreateInput;
}


export interface GqlMutationCreateShareIssueArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSiCreateInput;
}


export interface GqlMutationCreateShareIssueBoardMemberArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSibmCreateInput;
}


export interface GqlMutationCreateShareIssueParticipantArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSipCreateInput;
}


export interface GqlMutationCreateShareIssueRegistrationArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSirCreateInput;
}


export interface GqlMutationCreateShareTransactionGroupArgs {
  companyId: Scalars['ID']['input'];
  input: GqlStgCreateInput;
}


export interface GqlMutationCreateShareholderArgs {
  companyId: Scalars['ID']['input'];
  input: GqlShCreateInput;
}


export interface GqlMutationCreateWarrantBoardMemberArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWpbmCreateInput;
}


export interface GqlMutationCreateWarrantProgramArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWpCreateInput;
}


export interface GqlMutationCreateWarrantShareholderArgs {
  input: GqlWshCreateInput;
}


export interface GqlMutationCreateWdbFromBondArgs {
  companyId: Scalars['ID']['input'];
  snrBondId: Scalars['ID']['input'];
  warrantProgramId: Scalars['ID']['input'];
}


export interface GqlMutationCreateWiseDepBondArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWdbCreateInput;
}


export interface GqlMutationCreateWpFromSnrBondArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWpFromSnrBondInput;
}


export interface GqlMutationDeleteAiArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationDeleteAidArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationDeleteArticlesOfAssocArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationDeleteAuthorizationArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationDeleteAuthorizationGroupArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationDeleteCapTableArgs {
  companyId: Scalars['ID']['input'];
  input: Scalars['ID']['input'];
}


export interface GqlMutationDeleteCompanyInviteArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationDeleteCompanyUserArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationDeleteDocumentSignatureArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationDeleteEmptyShareTransactionGroupArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationDeleteFileArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationDeleteMeetingArgs {
  companyId: Scalars['ID']['input'];
  input: GqlMeetingDeleteInput;
}


export interface GqlMutationDeleteMeetingParticipantArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationDeleteMeetingParticipantShareArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationDeleteMeetingShareholdersArgs {
  companyId: Scalars['ID']['input'];
  meetingId: Scalars['ID']['input'];
}


export interface GqlMutationDeleteMeetingSummonsAttachmentArgs {
  companyId: Scalars['ID']['input'];
  docId: Scalars['ID']['input'];
}


export interface GqlMutationDeleteMeetingTodoArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationDeleteNiceFounderArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationDeleteOptionsSharesSubscriberRepresentativeArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationDeleteOptionsSubscriberRepresentativeArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationDeletePasskeyArgs {
  id: Scalars['ID']['input'];
}


export interface GqlMutationDeleteShareIssueArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationDeleteShareIssueBoardMemberArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationDeleteShareIssueParticipantArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationDeleteShareTransactionGroupArgs {
  companyId: Scalars['ID']['input'];
  input: GqlStgDeleteInput;
}


export interface GqlMutationDeleteShareTransactionsArgs {
  companyId: Scalars['ID']['input'];
  input: GqlDeleteStsInput;
}


export interface GqlMutationDeleteShareholderArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationDeleteWarrantBoardMemberArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationDeleteWarrantProgramArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationDeleteWarrantShareholderArgs {
  id: Scalars['String']['input'];
}


export interface GqlMutationDeleteWiseDependencyBondArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationDocGenAgRegistrationFormArgs {
  agId: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
  signatureMethod: GqlDocumentSignatureMethod;
}


export interface GqlMutationDocGenAoaRegistrationFormArgs {
  aoaId: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
  signatureMethod: GqlDocumentSignatureMethod;
}


export interface GqlMutationDocGenConvertibleRegistrationFormArgs {
  companyId: Scalars['ID']['input'];
  optionsRegistrationId: Scalars['ID']['input'];
  signatureMethod: GqlDocumentSignatureMethod;
}


export interface GqlMutationDocGenIndividualReportArgs {
  companyId: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
  docLanguage: GqlFileLanguageInput;
  shareholderId: Scalars['ID']['input'];
}


export interface GqlMutationDocGenIndividualReportShArgs {
  companyId: Scalars['ID']['input'];
  docLanguage: GqlFileLanguageInput;
  shareholderId: Scalars['ID']['input'];
}


export interface GqlMutationDocGenNiceAgreementArgs {
  companyId: Scalars['ID']['input'];
  signatureMethod: GqlDocumentSignatureMethod;
  warrantParticipantId: Scalars['ID']['input'];
}


export interface GqlMutationDocGenOptionsShareSubscriptionListArgs {
  companyId: Scalars['ID']['input'];
  optionsSharesSubscriberId: Scalars['ID']['input'];
  signatureMethod: GqlDocumentSignatureMethod;
}


export interface GqlMutationDocGenPowerOfAttorneyArgs {
  companyId: Scalars['ID']['input'];
  meetingParticipantId: Scalars['ID']['input'];
  signatureMethod: GqlDocumentSignatureMethod;
}


export interface GqlMutationDocGenQesoAgreementArgs {
  companyId: Scalars['ID']['input'];
  signatureMethod: GqlDocumentSignatureMethod;
  warrantParticipantId: Scalars['ID']['input'];
}


export interface GqlMutationDocGenScheduleDocGenArgs {
  companyId: Scalars['ID']['input'];
  input: GqlFileGenInput;
}


export interface GqlMutationDocGenShareCertificateArgs {
  blockNumber: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  docLanguage: GqlFileLanguageInput;
  shareholderId: Scalars['ID']['input'];
  transactionId: Scalars['ID']['input'];
}


export interface GqlMutationDocGenShareSubscriptionListArgs {
  companyId: Scalars['ID']['input'];
  shareIssueParticipantId: Scalars['ID']['input'];
  signatureMethod: GqlDocumentSignatureMethod;
}


export interface GqlMutationDocGenSiRegistrationFormArgs {
  companyId: Scalars['ID']['input'];
  signatureMethod: GqlDocumentSignatureMethod;
  sirId: Scalars['ID']['input'];
}


export interface GqlMutationDocGenTransactionNoteArgs {
  companyId: Scalars['ID']['input'];
  docLanguage: GqlFileLanguageInput;
  shareTransactionId: Scalars['ID']['input'];
}


export interface GqlMutationDocGenTransactionNoteShArgs {
  companyId: Scalars['ID']['input'];
  docLanguage: GqlFileLanguageInput;
  shareTransactionId: Scalars['ID']['input'];
  shareholderId: Scalars['ID']['input'];
}


export interface GqlMutationDocGenWarrantAgreementArgs {
  companyId: Scalars['ID']['input'];
  signatureMethod: GqlDocumentSignatureMethod;
  warrantParticipantId: Scalars['ID']['input'];
}


export interface GqlMutationDocGenWarrantRegistrationFormArgs {
  companyId: Scalars['ID']['input'];
  optionsRegistrationId: Scalars['ID']['input'];
  signatureMethod: GqlDocumentSignatureMethod;
}


export interface GqlMutationDocGenWarrantSharesRegistrationFormArgs {
  companyId: Scalars['ID']['input'];
  optionsSharesRegistrationId: Scalars['ID']['input'];
  signatureMethod: GqlDocumentSignatureMethod;
}


export interface GqlMutationDocGenWiseAgreementArgs {
  companyId: Scalars['ID']['input'];
  signatureMethod: GqlDocumentSignatureMethod;
  warrantParticipantId: Scalars['ID']['input'];
}


export interface GqlMutationDocGenerateMeetingMinutesArgs {
  companyId: Scalars['ID']['input'];
  meetingId: Scalars['ID']['input'];
  signatureMethod: GqlDocumentSignatureMethod;
}


export interface GqlMutationDocGenerateMeetingSummonsArgs {
  companyId: Scalars['ID']['input'];
  meetingId: Scalars['ID']['input'];
}


export interface GqlMutationDocGenerateMeetingSummonsDirectArgs {
  companyId: Scalars['ID']['input'];
  meetingId: Scalars['ID']['input'];
}


export interface GqlMutationDsSetAuthMethodToSignArgs {
  companyId: Scalars['ID']['input'];
  input: GqlDsSetAuthMethodToSignInput;
}


export interface GqlMutationDsSetEmailAndMobileArgs {
  companyId: Scalars['ID']['input'];
  input: GqlDsSetEmailAndMobileInput;
}


export interface GqlMutationDsSetProxyArgs {
  companyId: Scalars['ID']['input'];
  input: GqlDsSetProxyInput;
}


export interface GqlMutationDuplicateCapTableArgs {
  companyId: Scalars['ID']['input'];
  input: Scalars['ID']['input'];
}


export interface GqlMutationEditWiseDependencyBondArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWdbEditInput;
}


export interface GqlMutationFileSendSignReminderArgs {
  companyId: Scalars['ID']['input'];
  input: GqlFileSendSignReminderInput;
}


export interface GqlMutationFileSetTagsArgs {
  companyId: Scalars['ID']['input'];
  input: GqlFileSetTagsInput;
}


export interface GqlMutationFileSignRefreshArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationFileSignStartArgs {
  companyId: Scalars['ID']['input'];
  input: GqlFileSignStartInput;
}


export interface GqlMutationFileSignStopArgs {
  companyId: Scalars['ID']['input'];
  input: GqlFileSignStopInput;
}


export interface GqlMutationFileSoftDeleteArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationGenerateAgreementPdfArgs {
  companyId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  signatureMethod: GqlDocumentSignatureMethod;
}


export interface GqlMutationMatCreateArgs {
  companyId: Scalars['ID']['input'];
  input: GqlMatCreateInput;
}


export interface GqlMutationMatDeleteArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationMatSetIsDefaultArgs {
  companyId: Scalars['ID']['input'];
  input: GqlMatSetIsDefaultInput;
}


export interface GqlMutationMatSetNameArgs {
  companyId: Scalars['ID']['input'];
  input: GqlMatSetNameInput;
}


export interface GqlMutationMatiCreateArgs {
  companyId: Scalars['ID']['input'];
  input: GqlMatiCreateInput;
}


export interface GqlMutationMatiDeleteArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationMatiSetOrderArgs {
  companyId: Scalars['ID']['input'];
  input: GqlMatiSetOrderInput;
}


export interface GqlMutationMatiUpdateArgs {
  companyId: Scalars['ID']['input'];
  input: GqlMatiUpdateInput;
}


export interface GqlMutationMcSetApprovedArgs {
  companyId: Scalars['ID']['input'];
  input: GqlMcSetApprovedInput;
}


export interface GqlMutationMeetingSetApprovedByMeetingArgs {
  companyId: Scalars['ID']['input'];
  input: GqlMeetingSetApprovedByMeetingInput;
}


export interface GqlMutationMeetingSetFunctionsArgs {
  companyId: Scalars['ID']['input'];
  input: GqlMeetingSetFunctionsInput;
}


export interface GqlMutationMoveFileArgs {
  input: GqlMoveFileInput;
}


export interface GqlMutationMpImportShareStateArgs {
  companyId: Scalars['ID']['input'];
  input: GqlMpImportShareStateInput;
}


export interface GqlMutationMpSetFunctionsArgs {
  companyId: Scalars['ID']['input'];
  input: GqlMpSetFunctionsInput;
}


export interface GqlMutationMpSetPresentArgs {
  companyId: Scalars['ID']['input'];
  input: GqlMpSetPresentInput;
}


export interface GqlMutationMpSetProxyArgs {
  companyId: Scalars['ID']['input'];
  input: GqlMpSetProxyInput;
}


export interface GqlMutationMtSetDoneArgs {
  companyId: Scalars['ID']['input'];
  input: GqlMtSetDoneInput;
}


export interface GqlMutationNiceFounderImportFoundersArgs {
  companyId: Scalars['ID']['input'];
  input: GqlNiceFounderImportFoundersInput;
}


export interface GqlMutationOrDeleteArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationOrSetPayBeforeDateArgs {
  companyId: Scalars['ID']['input'];
  input: GqlOrSetPayBeforeDateInput;
}


export interface GqlMutationOrSetPaymentArgs {
  companyId: Scalars['ID']['input'];
  input: GqlOrSetPaymentInput;
}


export interface GqlMutationOrSetSnrCaseArgs {
  companyId: Scalars['ID']['input'];
  input: GqlOrSetSnrCaseInput;
}


export interface GqlMutationOrSignatoryCreateArgs {
  companyId: Scalars['ID']['input'];
  input: GqlOrSignatoryCreateInput;
}


export interface GqlMutationOrSignatoryDeleteArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationOrUpdateArgs {
  companyId: Scalars['ID']['input'];
  input: GqlOrUpdateInput;
}


export interface GqlMutationOsrDeleteArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationOsrSetPayBeforeDateArgs {
  companyId: Scalars['ID']['input'];
  input: GqlOsrSetPayBeforeDateInput;
}


export interface GqlMutationOsrSetPaymentArgs {
  companyId: Scalars['ID']['input'];
  input: GqlOsrSetPaymentInput;
}


export interface GqlMutationOsrSetRecordDayArgs {
  companyId: Scalars['ID']['input'];
  input: GqlOsrSetRecordDayInput;
}


export interface GqlMutationOsrSetRegDetailsArgs {
  companyId: Scalars['ID']['input'];
  input: GqlOsrSetDetailsInput;
}


export interface GqlMutationOsrSetSnrCaseArgs {
  companyId: Scalars['ID']['input'];
  input: GqlOsrSetSnrCaseInput;
}


export interface GqlMutationOsrUpdateArgs {
  companyId: Scalars['ID']['input'];
  input: GqlOsrUpdateInput;
}


export interface GqlMutationOssCreateArgs {
  companyId: Scalars['ID']['input'];
  input: GqlOssCreateInput;
}


export interface GqlMutationOssDeleteArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationOssSetPaymentStatusArgs {
  companyId: Scalars['ID']['input'];
  input: GqlOssSetPaymentStatusInput;
}


export interface GqlMutationOssUpdateArgs {
  companyId: Scalars['ID']['input'];
  input: GqlOssUpdateInput;
}


export interface GqlMutationRefreshCapTableArgs {
  companyId: Scalars['ID']['input'];
  input: GqlRefreshCapTableInput;
}


export interface GqlMutationRefreshIdentityArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationResetAisArgs {
  companyId: Scalars['ID']['input'];
  meetingId: Scalars['ID']['input'];
}


export interface GqlMutationSendMailMeetingSummonsToAllArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSendMailMeetingSummonsToAllInput;
}


export interface GqlMutationSendMailMeetingSummonsToOneArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSendMailMeetingSummonsToOneInput;
}


export interface GqlMutationSendPromoInviteArgs {
  input: GqlUserSendPromoInviteInput;
}


export interface GqlMutationSetAiDoneArgs {
  companyId: Scalars['ID']['input'];
  input: GqlAiSetDoneInput;
}


export interface GqlMutationSetAiOrderArgs {
  companyId: Scalars['ID']['input'];
  input: GqlAiSetOrderInput;
}


export interface GqlMutationSetIdentityEmailArgs {
  companyId: Scalars['ID']['input'];
  input: GqlIdentitySetEmailInput;
}


export interface GqlMutationSetIdentityPhoneArgs {
  companyId: Scalars['ID']['input'];
  input: GqlIdentitySetPhoneInput;
}


export interface GqlMutationSetMeetingBoardsRecommendationArgs {
  companyId: Scalars['ID']['input'];
  input: GqlMeetingBoardsRecommendationInput;
}


export interface GqlMutationSetMeetingContactEmailArgs {
  companyId: Scalars['ID']['input'];
  input: GqlMeetingSetContactEmailInput;
}


export interface GqlMutationSetMeetingDetailsArgs {
  companyId: Scalars['ID']['input'];
  input: GqlMeetingSetDetailsInput;
}


export interface GqlMutationSetMeetingLanguageArgs {
  companyId: Scalars['ID']['input'];
  input: GqlMeetingSetLanguageInput;
}


export interface GqlMutationSetMeetingPostalVoteArgs {
  companyId: Scalars['ID']['input'];
  input: GqlMeetingPostalVoteInput;
}


export interface GqlMutationSiConnectAuthorizationArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSiConnectAuthorizationInput;
}


export interface GqlMutationSiConnectMeetingArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSiConnectMeetingInput;
}


export interface GqlMutationSiCreateMeetingArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSiCreateMeetingInput;
}


export interface GqlMutationSiDisconnectAuthorizationArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSiDisconnectAuthorizationInput;
}


export interface GqlMutationSiDisconnectMeetingArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSiDisconnectMeetingInput;
}


export interface GqlMutationSiSetBoardStatementArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSiSetBoardsStatementInput;
}


export interface GqlMutationSiSetDescriptionArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSiSetDescriptionInput;
}


export interface GqlMutationSiSetLanguageArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSiSetLanguageInput;
}


export interface GqlMutationSiSetNewSharesArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSiSetNewSharesInput;
}


export interface GqlMutationSiSetNonCashStatementArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSiSetNonCashStatementInput;
}


export interface GqlMutationSiSetPaymentKindArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSiSetPaymentKindInput;
}


export interface GqlMutationSiSetShareClassArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSetShareClassInput;
}


export interface GqlMutationSiSetSubscriptionDatesArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSiSetSubscriptionDatesInput;
}


export interface GqlMutationSiUpdateArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSiUpdateInput;
}


export interface GqlMutationSipEditArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSipEditInput;
}


export interface GqlMutationSipSetPaymentStatusArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSipSetPaymentStatusInput;
}


export interface GqlMutationSipSetProxyArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSipSetProxyInput;
}


export interface GqlMutationSirSetCurrencyExchangeRateArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSirSetCurrencyExchangeRateInput;
}


export interface GqlMutationSirSetPaymentArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSirSetPaymentInput;
}


export interface GqlMutationSirSetPaymentDueDateArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSirSetPaymentDueDateInput;
}


export interface GqlMutationSirSetSnrCaseArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSirSetSnrCaseInput;
}


export interface GqlMutationSirUpdateArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSirUpdateInput;
}


export interface GqlMutationStCreateIssueArgs {
  companyId: Scalars['ID']['input'];
  input: GqlStCreateIssueInput;
}


export interface GqlMutationStCreateTransferArgs {
  companyId: Scalars['ID']['input'];
  input: GqlStCreateTransferInput;
}


export interface GqlMutationStCreateUnissueArgs {
  companyId: Scalars['ID']['input'];
  input: GqlStCreateUnissueInput;
}


export interface GqlMutationStImportTransfersArgs {
  companyId: Scalars['ID']['input'];
  input: GqlStImportTransfersInput;
}


export interface GqlMutationStSetCommentArgs {
  companyId: Scalars['ID']['input'];
  input: GqlStSetCommentInput;
}


export interface GqlMutationStSetPricePerShareArgs {
  companyId: Scalars['ID']['input'];
  input: GqlStSetPricePerShareInput;
}


export interface GqlMutationStSetShareCertificateDateArgs {
  companyId: Scalars['ID']['input'];
  input: GqlStSetShareCertificateDateInput;
}


export interface GqlMutationStgSetSccIdArgs {
  companyId: Scalars['ID']['input'];
  input: GqlStgSetSccIdInput;
}


export interface GqlMutationStgSetupArgs {
  companyId: Scalars['ID']['input'];
  input: GqlStgSetupInput;
}


export interface GqlMutationStripeAcceptQuoteArgs {
  companyId: Scalars['ID']['input'];
  pmId?: InputMaybe<Scalars['String']['input']>;
  quoteId: Scalars['String']['input'];
}


export interface GqlMutationStripeCreateBillingPortalSessionArgs {
  companyId: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
}


export interface GqlMutationStripeCreateCustomerArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlMutationStripeCreateMeetingConcernsPaymentQuoteArgs {
  companyId: Scalars['ID']['input'];
  input: GqlCreateStripeMeetingConcernQuoteInput;
}


export interface GqlMutationStripeCreateSetupCheckoutSessionArgs {
  companyId: Scalars['ID']['input'];
  input: GqlStripeCreateSetupCheckoutSessionInput;
}


export interface GqlMutationStripeCreateSubscriptionCheckoutSessionArgs {
  companyId: Scalars['ID']['input'];
  input: GqlStripeCreateSubscriptionCheckoutSessionInput;
}


export interface GqlMutationStripeCreateSubscriptionQuoteArgs {
  companyId: Scalars['ID']['input'];
  input: GqlCreateStripeSubscriptionQuoteInput;
}


export interface GqlMutationStripeDeletePaymentMethodArgs {
  companyId: Scalars['ID']['input'];
  pmId: Scalars['ID']['input'];
}


export interface GqlMutationStripeEstablishInvitePromoArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlMutationStripePayInvoiceArgs {
  companyId: Scalars['ID']['input'];
  invoiceId: Scalars['String']['input'];
  pmId?: InputMaybe<Scalars['String']['input']>;
}


export interface GqlMutationStripePreviewSubUpdateArgs {
  companyId: Scalars['ID']['input'];
  priceId: Scalars['ID']['input'];
}


export interface GqlMutationStripeQuoteSetPromoArgs {
  companyId: Scalars['ID']['input'];
  input: GqlStripeQuoteSetPromoInput;
}


export interface GqlMutationStripeSetDefaultPaymentMethodArgs {
  companyId: Scalars['ID']['input'];
  pmId: Scalars['ID']['input'];
}


export interface GqlMutationStripeUpgradeSubscriptionArgs {
  companyId: Scalars['ID']['input'];
  priceId: Scalars['ID']['input'];
}


export interface GqlMutationTodoSetDoneArgs {
  companyId: Scalars['ID']['input'];
  input: GqlTodoSetDoneInput;
}


export interface GqlMutationToggleRegistrationTodoArgs {
  companyId: Scalars['ID']['input'];
  input: GqlUpdateRegistrationTodoItem;
}


export interface GqlMutationUpdateAidArgs {
  companyId: Scalars['ID']['input'];
  input: GqlAidUpdateInput;
}


export interface GqlMutationUpdateAuthorizationArgs {
  companyId: Scalars['ID']['input'];
  input: GqlAuthUpdateInput;
}


export interface GqlMutationUpdateCapTableArgs {
  companyId: Scalars['ID']['input'];
  input: GqlUpdateCapTableInput;
}


export interface GqlMutationUpdateFileArgs {
  companyId: Scalars['ID']['input'];
  input: GqlUpdateFileInput;
}


export interface GqlMutationUpdateIdentityArgs {
  companyId: Scalars['ID']['input'];
  input: GqlUpdateIdentityInput;
}


export interface GqlMutationUpdateMeetingParticipantShareArgs {
  companyId: Scalars['ID']['input'];
  input: GqlMeetingParticipantShareUpdateInput;
}


export interface GqlMutationUpdateTodoArgs {
  companyId: Scalars['ID']['input'];
  input: GqlTodoUpdateInput;
}


export interface GqlMutationUpdateWarrantProgramArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWpUpdateInput;
}


export interface GqlMutationUpsertValueArgs {
  agreementId: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  fieldId: Scalars['String']['input'];
  valueBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  valueDate?: InputMaybe<Scalars['Date']['input']>;
  valueIdentity?: InputMaybe<GqlCreateIdentityInput>;
  valueString?: InputMaybe<Scalars['String']['input']>;
}


export interface GqlMutationUserSetContactDetailsArgs {
  input: GqlUserSetContactDetailsInput;
}


export interface GqlMutationUserSetFeaturePreferenceArgs {
  feature: Scalars['String']['input'];
  optedIn: Scalars['Boolean']['input'];
}


export interface GqlMutationUserSyncToHubspotArgs {
  id: Scalars['ID']['input'];
}


export interface GqlMutationWpConnectAuthorizationArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWpConnectAuthorizationInput;
}


export interface GqlMutationWpConnectMeetingArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWpConnectMeetingInput;
}


export interface GqlMutationWpCreateMeetingArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWpCreateMeetingInput;
}


export interface GqlMutationWpDisconnectAuthorizationArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWpDisconnectAuthorizationInput;
}


export interface GqlMutationWpDisconnectMeetingArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWpDisconnectMeetingInput;
}


export interface GqlMutationWpRefreshInterestRateArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlMutationWpSetBoardsStatementArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWpSetBoardsStatementInput;
}


export interface GqlMutationWpSetDatesArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWpSetDatesInput;
}


export interface GqlMutationWpSetDescriptionArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWpSetDescriptionInput;
}


export interface GqlMutationWpSetLanguageArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWpSetLanguageInput;
}


export interface GqlMutationWpSetMaxNumberOfOptionsArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWpSetMaxNumberOfOptionsInput;
}


export interface GqlMutationWpSetNicePriceArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWpSetNicePriceInput;
}


export interface GqlMutationWpSetNonCashStatementArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWpSetNonCashStatementInput;
}


export interface GqlMutationWpSetNumberOfSharesArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWpSetNumberOfSharesInput;
}


export interface GqlMutationWpSetPaymentKindArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWpSetPaymentKindInput;
}


export interface GqlMutationWpSetPlaygroundArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWpSetPlaygroundInput;
}


export interface GqlMutationWpSetReasonArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWpSetReasonInput;
}


export interface GqlMutationWpSetShareClassArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSetShareClassInput;
}


export interface GqlMutationWpSetStrikePriceArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWpSetStrikePriceInput;
}


export interface GqlMutationWpSetValuationArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWpSetValuationInput;
}


export interface GqlMutationWpSetVolatilityArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWpSetVolatilityInput;
}


export interface GqlMutationWpSetWiseFullyDilutedArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWpSetWiseFullyDilutedInput;
}


export interface GqlMutationWpSetWisePriceArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWpSetWisePriceInput;
}


export interface GqlMutationWpSetWiseRecordDayArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWpSetWiseRecordDayInput;
}


export interface GqlMutationWpaSetDurationArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWpaSetDurationInput;
}


export interface GqlMutationWpaSetStrikePriceArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWpSetStrikePriceInput;
}


export interface GqlMutationWppAddCustomVestingOccasionArgs {
  vestingOccasion: GqlWppVestingOccasionCreateInput;
}


export interface GqlMutationWppCreateArgs {
  companyId: Scalars['String']['input'];
  input: GqlWppCreateInput;
}


export interface GqlMutationWppDeleteArgs {
  companyId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}


export interface GqlMutationWppDeleteCustomVestingOccasionArgs {
  vestingOccasionId: Scalars['ID']['input'];
}


export interface GqlMutationWppExplainVestingScheduleArgs {
  id: Scalars['ID']['input'];
}


export interface GqlMutationWppUpdateArgs {
  companyId: Scalars['String']['input'];
  input: GqlWppUpdateInput;
}


export interface GqlMutationWppUpdateCustomVestingOccasionArgs {
  vestingOccasion: GqlWppVestingOccasionUpdateInput;
}


export interface GqlMutationWshImportShareStateArgs {
  input: GqlWshImportShareStateInput;
}


export interface GqlMutationWshRemoveProxyArgs {
  id: Scalars['String']['input'];
}


export interface GqlMutationWshSetProxyArgs {
  input: GqlWshSetProxyInput;
}

export interface GqlNextShareCapitalChanges {
  afterNext?: Maybe<GqlCompleteShareCapitalChange>;
  inSync: Scalars['Boolean']['output'];
  next?: Maybe<GqlCompleteShareCapitalChange>;
  prev?: Maybe<GqlCompleteShareCapitalChange>;
}

export interface GqlNiceFounder {
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  identity: GqlIdentity;
  identityId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['Date']['output'];
  warrantProgram: GqlWarrantProgram;
  warrantProgramId: Scalars['ID']['output'];
}

export interface GqlNiceFounderCreateInput {
  identityInput: GqlCreateIdentityInput;
  warrantProgramId: Scalars['ID']['input'];
}

export interface GqlNiceFounderCreatedResponse {
  documents: Array<GqlBolagoFile>;
  niceFounder: GqlNiceFounder;
}

export interface GqlNiceFounderDeletedResponse {
  documents: Array<GqlBolagoFile>;
  id: Scalars['ID']['output'];
}

export interface GqlNiceFounderImportFoundersInput {
  warrantProgramId: Scalars['ID']['input'];
}

export interface GqlNiceFounderImportFoundersResponse {
  added: Array<GqlNiceFounder>;
  documents: Array<GqlBolagoFile>;
  removed: Array<GqlNiceFounderDeletedResponse>;
}

export interface GqlOptionalAisAidCreate {
  decisionPrimaryLang?: Maybe<Scalars['String']['output']>;
  decisionSecondaryLang?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
}

export interface GqlOptionsRegistration {
  contact?: Maybe<GqlIdentity>;
  contactId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['ID']['output']>;
  ibanAddress?: Maybe<Scalars['String']['output']>;
  ibanBank?: Maybe<Scalars['String']['output']>;
  ibanBic?: Maybe<Scalars['String']['output']>;
  ibanNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latestRegistrationForm?: Maybe<GqlBolagoFile>;
  orSignatories: Array<GqlOptionsRegistrationSignatory>;
  participants: Array<GqlWarrantParticipant>;
  payBeforeDate?: Maybe<Scalars['Date']['output']>;
  paymentAccountKind?: Maybe<GqlPaymentAccountKind>;
  paymentAccountNumber?: Maybe<Scalars['String']['output']>;
  paymentName?: Maybe<Scalars['String']['output']>;
  regFormPaymentThroughBolago: Scalars['Boolean']['output'];
  signatory?: Maybe<GqlIdentity>;
  signatoryId?: Maybe<Scalars['ID']['output']>;
  snrCase?: Maybe<GqlSnrCase>;
  snrCaseId?: Maybe<Scalars['ID']['output']>;
  todoCompletions: Array<GqlRegistrationTodoCompletion>;
  todos: Array<GqlRegistrationTodoItemKind>;
  updatedAt: Scalars['Date']['output'];
  validatorErrors: GqlOrValidatorErrors;
  warrantProgram: GqlWarrantProgram;
  warrantProgramId: Scalars['ID']['output'];
}

export interface GqlOptionsRegistrationDocument {
  createdAt: Scalars['Date']['output'];
  file: GqlBolagoFile;
  fileId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  optionsRegistrationId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
}

export interface GqlOptionsRegistrationSignatory {
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  identity: GqlIdentity;
  identityId: Scalars['ID']['output'];
  optionsRegistration: GqlOptionsRegistration;
  optionsRegistrationId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
}

export interface GqlOptionsSharesRegistration {
  contact?: Maybe<GqlIdentity>;
  contactId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  ibanAddress?: Maybe<Scalars['String']['output']>;
  ibanBank?: Maybe<Scalars['String']['output']>;
  ibanBic?: Maybe<Scalars['String']['output']>;
  ibanNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latestRegistrationForm?: Maybe<GqlBolagoFile>;
  payBeforeDate?: Maybe<Scalars['Date']['output']>;
  paymentAccountKind?: Maybe<GqlPaymentAccountKind>;
  paymentAccountNumber?: Maybe<Scalars['String']['output']>;
  paymentName?: Maybe<Scalars['String']['output']>;
  recordDay?: Maybe<Scalars['Date']['output']>;
  regFormPaymentThroughBolago: Scalars['Boolean']['output'];
  signatory?: Maybe<GqlIdentity>;
  signatoryId?: Maybe<Scalars['ID']['output']>;
  snrCase?: Maybe<GqlSnrCase>;
  snrCaseId?: Maybe<Scalars['ID']['output']>;
  splitFactor: Scalars['String']['output'];
  subscribers: Array<GqlOptionsSharesSubscriber>;
  todoCompletions: Array<GqlRegistrationTodoCompletion>;
  todos: Array<GqlRegistrationTodoItemKind>;
  updatedAt: Scalars['Date']['output'];
  warrantProgram: GqlWarrantProgram;
  warrantProgramId: Scalars['ID']['output'];
}

export interface GqlOptionsSharesSubscriber {
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  identity: GqlIdentity;
  identityId: Scalars['ID']['output'];
  latestShareSubscriptionListDoc?: Maybe<GqlBolagoFile>;
  optionsSharesRegistration: GqlOptionsSharesRegistration;
  optionsSharesRegistrationId: Scalars['ID']['output'];
  paymentStatus: Scalars['Int']['output'];
  quantity: Scalars['String']['output'];
  representatives: Array<GqlOptionsSharesSubscriberRepresentative>;
  shareClass: GqlShareClass;
  updatedAt: Scalars['Date']['output'];
}

export interface GqlOptionsSharesSubscriberRepresentative {
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  identity: GqlIdentity;
  identityId: Scalars['ID']['output'];
  optionsSharesSubscriber: GqlOptionsSharesSubscriber;
  optionsSharesSubscriberId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
}

export interface GqlOptionsSharesSubscriberRepresentativeCreateInput {
  identityInput: GqlCreateIdentityInput;
  optionsSharesSubscriberId: Scalars['ID']['input'];
}

export interface GqlOptionsSharesSubscriberRepresentativeDeletedResponse {
  id: Scalars['ID']['output'];
}

export interface GqlOptionsSubscriberRepresentative {
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  identity: GqlIdentity;
  identityId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
  warrantParticipant: GqlWarrantParticipant;
  warrantParticipantId: Scalars['ID']['output'];
}

/** Create share issue participant */
export interface GqlOptionsSubscriberRepresentativeCreateInput {
  identityInput: GqlCreateIdentityInput;
  warrantParticipantId: Scalars['ID']['input'];
}

export interface GqlOptionsSubscriberRepresentativeDeletedResponse {
  id: Scalars['ID']['output'];
}

export interface GqlOrCreateInput {
  description: Scalars['String']['input'];
  warrantProgramId: Scalars['ID']['input'];
}

export interface GqlOrDeletedResponse {
  id: Scalars['ID']['output'];
  wppDeletedResponses: Array<GqlWppDeletedResponse>;
}

export interface GqlOrSetPayBeforeDateInput {
  id: Scalars['ID']['input'];
  payBeforeDate: Scalars['Date']['input'];
}

export interface GqlOrSetPaymentInput {
  ibanAddress?: InputMaybe<Scalars['String']['input']>;
  ibanBank?: InputMaybe<Scalars['String']['input']>;
  ibanBic?: InputMaybe<Scalars['String']['input']>;
  ibanNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  payBeforeDate?: InputMaybe<Scalars['Date']['input']>;
  paymentAccountKind?: InputMaybe<GqlPaymentAccountKind>;
  paymentAccountNumber?: InputMaybe<Scalars['String']['input']>;
  paymentName?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlOrSetSnrCaseInput {
  id: Scalars['ID']['input'];
  snrCaseId?: InputMaybe<Scalars['ID']['input']>;
}

export interface GqlOrSignatoryCreateInput {
  identityInput: GqlCreateIdentityInput;
  optionsRegistrationId: Scalars['ID']['input'];
}

export interface GqlOrSignatoryCreateResponse {
  documents: Array<GqlBolagoFile>;
  sig: GqlOptionsRegistrationSignatory;
}

export interface GqlOrSignatoryDeletedResponse {
  documents: Array<GqlBolagoFile>;
  id: Scalars['ID']['output'];
}

export interface GqlOrUpdateInput {
  contact?: InputMaybe<GqlCreateIdentityInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  regFormPaymentThroughBolago?: InputMaybe<Scalars['Boolean']['input']>;
  signatory?: InputMaybe<GqlCreateIdentityInput>;
}

export interface GqlOrUpdateResponse {
  documents: Array<GqlBolagoFile>;
  or: GqlOptionsRegistration;
}

export interface GqlOrValidatorErrors {
  decision: GqlValidatorStatus;
  options: GqlValidatorStatus;
  participants: GqlValidatorStatus;
  payBeforeDate: GqlValidatorStatus;
  signatories: GqlValidatorStatus;
  signsRegForm: GqlValidatorStatus;
  todos: GqlValidatorStatus;
}

export interface GqlOsrCreateInput {
  description: Scalars['String']['input'];
  warrantProgramId: Scalars['ID']['input'];
}

export interface GqlOsrDeletedResponse {
  id: Scalars['ID']['output'];
  ossDeletedResponses: Array<GqlOssDeletedResponse>;
}

export interface GqlOsrSetDetailsInput {
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
}

export interface GqlOsrSetPayBeforeDateInput {
  id: Scalars['ID']['input'];
  payBeforeDate: Scalars['Date']['input'];
}

export interface GqlOsrSetPaymentInput {
  ibanAddress?: InputMaybe<Scalars['String']['input']>;
  ibanBank?: InputMaybe<Scalars['String']['input']>;
  ibanBic?: InputMaybe<Scalars['String']['input']>;
  ibanNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  payBeforeDate: Scalars['Date']['input'];
  paymentAccountKind?: InputMaybe<GqlPaymentAccountKind>;
  paymentAccountNumber?: InputMaybe<Scalars['String']['input']>;
  paymentName?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlOsrSetRecordDayInput {
  id: Scalars['ID']['input'];
  recordDay: Scalars['Date']['input'];
}

export interface GqlOsrSetSnrCaseInput {
  id: Scalars['ID']['input'];
  snrCaseId?: InputMaybe<Scalars['ID']['input']>;
}

export interface GqlOsrUpdateInput {
  contact?: InputMaybe<GqlCreateIdentityInput>;
  id: Scalars['ID']['input'];
  regFormPaymentThroughBolago?: InputMaybe<Scalars['Boolean']['input']>;
  signatory?: InputMaybe<GqlCreateIdentityInput>;
}

export interface GqlOsrUpdateResponse {
  documents: Array<GqlBolagoFile>;
  osr: GqlOptionsSharesRegistration;
}

export interface GqlOsrValidatorErrors {
  decision: GqlValidatorStatus;
  options: GqlValidatorStatus;
  participants: GqlValidatorStatus;
  payBeforeDate: GqlValidatorStatus;
  recordDay: GqlValidatorStatus;
  signsRegForm: GqlValidatorStatus;
  todos: GqlValidatorStatus;
}

export interface GqlOssCreateInput {
  identityInput: GqlCreateIdentityInput;
  optionsSharesRegistrationId: Scalars['ID']['input'];
  quantity: Scalars['String']['input'];
  shareClass: GqlShareClassInput;
}

export interface GqlOssDeletedResponse {
  documents: Array<GqlBolagoFile>;
  id: Scalars['ID']['output'];
}

export interface GqlOssSetPaymentStatusInput {
  id: Scalars['ID']['input'];
  paymentStatus: Scalars['Int']['input'];
}

export interface GqlOssUpdateInput {
  id: Scalars['ID']['input'];
  identityInput: GqlCreateIdentityInput;
  quantity?: InputMaybe<Scalars['String']['input']>;
  shareClass?: InputMaybe<GqlShareClassInput>;
}

export interface GqlOssUpdateResponse {
  documents: Array<GqlBolagoFile>;
  optionsSharesSubscriber: GqlOptionsSharesSubscriber;
}

export interface GqlOssValidatorErrors {
  paymentStatus: GqlValidatorStatus;
  proxy: GqlValidatorStatus;
}

export interface GqlOwnerState {
  averagePrice: Array<GqlOwnerStateAvgPrice>;
  identityId: Scalars['ID']['output'];
  numberOfShares: Scalars['Float']['output'];
  ranges: Array<GqlShareRange>;
  shareholder: GqlShareholder;
  shareholderId: Scalars['ID']['output'];
  sums: Array<GqlOwnerStateSums>;
}

export interface GqlOwnerStateAvgPrice {
  currency: GqlCurrency;
  price: Scalars['Float']['output'];
}

export interface GqlOwnerStateSums {
  currency: GqlCurrency;
  numberOfShares: Scalars['Float']['output'];
  totalPaid: Scalars['Float']['output'];
}

export interface GqlPasskey {
  attestationType: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  signCount: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
  userId: Scalars['String']['output'];
}

export interface GqlPasskeyDeletedResponse {
  id: Scalars['ID']['output'];
}

export enum GqlPaymentAccountKind {
  BankAccount = 'BankAccount',
  Bankgiro = 'Bankgiro',
  Iban = 'IBAN',
  Other = 'Other'
}

export interface GqlProvisionedCompany {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
}

export interface GqlQuery {
  activeCompanyStripeSubscription: GqlSutSubscription;
  adminCompany: GqlCompany;
  adminUsers: Array<GqlUser>;
  adminZignedDocuments: Array<GqlBolagoFile>;
  agendaItem: GqlAgendaItem;
  agendaItems: Array<GqlAgendaItem>;
  agreement: GqlAgreement;
  agreements: Array<GqlListAgreement>;
  aoaGetAffected: GqlAoaGetAffectedResponse;
  aoaMinAndMaxOfShares: GqlMinAndMaxOfSharesResponse;
  articlesOfAssoc: GqlArticlesOfAssoc;
  articlesOfAssocDocument: GqlArticlesOfAssocDocument;
  articlesOfAssocErrors: GqlAoaValidatorErrors;
  articlesOfAssocs: Array<GqlArticlesOfAssoc>;
  authorizationGroup: GqlAuthorizationGroup;
  authorizationGroupDocument: GqlAuthorizationGroupDocument;
  authorizationGroupErrors: GqlAgValidatorErrors;
  authorizationGroups: Array<GqlAuthorizationGroup>;
  capTable: GqlCapTable;
  capTableStake: GqlCapTableStake;
  capTableStakes: Array<GqlCapTableStake>;
  capTables: Array<GqlCapTable>;
  companies: Array<GqlCompany>;
  company: GqlCompany;
  companyConnections: Array<GqlCompanyConnection>;
  companyDirectors: Array<GqlCompanyDirector>;
  companyInviteRequests: Array<GqlCompanyInviteRequest>;
  companyInvites: Array<GqlCompanyInvite>;
  companyStatistics: GqlCompanyStatistics;
  /** Fetches the current known company subscription. If you need to also refetch from Stripe, use stripeCompanySubscription instead */
  companySubscription?: Maybe<GqlCompanySubscription>;
  companySubscriptions: Array<GqlCompanySubscription>;
  companySuggestions: Array<GqlCompanySuggestion>;
  companyUsers: Array<GqlCompanyUser>;
  completeSccs: Array<GqlCompleteShareCapitalChange>;
  cooptedMeetingParticipants: Array<GqlCooptedMeetingParticipant>;
  currentUser: GqlUser;
  docGenFullShareReg: GqlDocumentGenReq;
  docGenValidateMeeting: GqlFileGenMeetingValidatorErrorsResponse;
  documentSignatures: Array<GqlDocumentSignature>;
  documentTemplates: Array<GqlDocumentTemplate>;
  employeeOptionsErrors: GqlEoValidatorErrors;
  file: GqlBolagoFile;
  fileUserTags: GqlFileUserTagsResponse;
  filesByIds: Array<GqlBolagoFile>;
  fullShareReg: Array<GqlFullShareRegRow>;
  getShareTransactionDocuments: Array<GqlBolagoFile>;
  identity: GqlIdentity;
  identityByUserId: GqlIdentity;
  individualReport: GqlGetIndividualReportResponse;
  investments: Array<GqlInvestment>;
  meeting: GqlMeeting;
  meetingAgendaTemplates: Array<GqlMeetingAgendaTemplate>;
  meetingByNumber?: Maybe<GqlMeeting>;
  meetingConcerns: Array<GqlMeetingConcern>;
  meetingDocument: GqlMeetingDocument;
  meetingErrors: GqlMeetingValidatorErrors;
  /** check if the meeting has any reg forms, send the id to skip checking for that particular id */
  meetingHasQesRegForms: Scalars['Boolean']['output'];
  meetingMcCounts: GqlMeetingMcCountsResponse;
  meetingPaidForConcerns: GqlMeetingPaidForConcernsResponse;
  meetingParticipant: GqlMeetingParticipant;
  meetingParticipantShare: GqlMeetingParticipantShare;
  meetingParticipantShares: GqlMeetingParticipantShare;
  meetingParticipants: GqlMeetingParticipantsPagedResult;
  meetingParticipantsByIds: Array<GqlMeetingParticipant>;
  meetingTodos: Array<GqlMeetingTodo>;
  meetings: GqlMeetingsPagedResult;
  nextShareCapitalChanges: GqlNextShareCapitalChanges;
  niceFounders: Array<GqlNiceFounder>;
  optionsRegistration: GqlOptionsRegistration;
  optionsRegistrationErrors: GqlOrValidatorErrors;
  optionsRegistrations: Array<GqlOptionsRegistration>;
  optionsSharesRegistration: GqlOptionsSharesRegistration;
  optionsSharesRegistrationErrors: GqlOsrValidatorErrors;
  optionsSharesRegistrations: Array<GqlOptionsSharesRegistration>;
  optionsSharesSubscriber: GqlOptionsSharesSubscriber;
  optionsSharesSubscriberErrors: GqlOssValidatorErrors;
  optionsSharesSubscribers: Array<GqlOptionsSharesSubscriber>;
  orDocumentLatest?: Maybe<GqlOptionsRegistrationDocument>;
  orSignatories: Array<GqlOptionsRegistrationSignatory>;
  osrVestedAndAllocated: Array<GqlVestedAndAllocated>;
  passkeys: Array<GqlPasskey>;
  ratsitCompanies: Array<GqlRatsitIdentity>;
  ratsitCompany: GqlRatsitIdentity;
  ratsitCompanyBoard: Array<GqlRatsitIdentity>;
  ratsitSearch: Array<GqlRatsitIdentity>;
  scriveStatusMeetingMinutesByMeetingId: GqlFileIsSignedResponse;
  searchIdentities: Array<GqlIdentity>;
  sellableShareState: GqlSellableShareResponse;
  shCount: GqlShCountResponse;
  shSellableShares: GqlShSellableSharesResponse;
  shareClasses: Array<GqlShareClass>;
  shareCount: GqlShareCountResponse;
  shareIssue: GqlShareIssue;
  shareIssueDocument: GqlShareIssueDocument;
  shareIssueErrors: GqlShareIssueValidatorErrors;
  shareIssueRegistration: GqlShareIssueRegistration;
  shareIssueRegistrationErrors: GqlSirValidatorErrors;
  shareIssueRegistrations: Array<GqlShareIssueRegistration>;
  shareIssues: Array<GqlShareIssue>;
  shareState: GqlShareStateResponse;
  shareStateIsValid: Scalars['Boolean']['output'];
  shareTransactionDocument: GqlShareTransactionDocument;
  shareTransactionDocuments: Array<GqlShareTransactionDocument>;
  shareTransactionGroup: GqlShareTransactionGroup;
  shareTransactionGroups: Array<GqlShareTransactionGroup>;
  shareTransactions: Array<GqlShareTransaction>;
  shareholder: GqlShareholder;
  shareholders: Array<GqlShareholder>;
  shareholdersShareState: GqlShareStateResponse;
  siConnectedWps?: Maybe<Array<GqlWarrantProgram>>;
  siCount: Scalars['Int']['output'];
  siSharesLeft: Scalars['Float']['output'];
  sipValidatorErrors: GqlSipValidatorErrors;
  snrAuthNoBoardStatement: Scalars['Boolean']['output'];
  snrAuthorizations: Array<GqlSnrAuthorization>;
  snrBonds: Array<GqlSnrBond>;
  snrCases: GqlSnrCasePagedResult;
  snrNumberOfSharesAtDate?: Maybe<Scalars['Int']['output']>;
  snrQuotaValueAtDate?: Maybe<Scalars['Float']['output']>;
  snrShareCapitalChanges: Array<GqlSnrShareCapitalChange>;
  stripeCompanyProducts: Array<GqlStripeProduct>;
  /** Fetches the current company subscription with up to date data from stripe. If you do not need to also refetch from Stripe, use companySubscription instead */
  stripeCompanySubscription?: Maybe<GqlStripeSubscription>;
  stripeCustomer?: Maybe<GqlStripeCustomer>;
  stripeInvoice: GqlStripeInvoice;
  stripeInvoices: Array<GqlStripeInvoice>;
  stripeMeetingConcernsInvoices: Array<GqlStripeInvoice>;
  stripePaymentIntent: GqlStripePaymentIntent;
  stripePaymentMethods: Array<GqlStripePaymentMethod>;
  stripePrices: Array<GqlStripePrice>;
  stripeProduct: GqlStripeProduct;
  stripeProducts: Array<GqlStripeProduct>;
  stripePromoCode: GqlStripePromotionCode;
  stripeQuote: GqlStripeQuote;
  stripeSubscriptions: Array<GqlStripeSubscription>;
  todos: Array<GqlTodo>;
  todosUnfinished: Array<GqlTodo>;
  user: GqlUser;
  userHubspotIdentityToken?: Maybe<Scalars['String']['output']>;
  userIdentity: GqlIdentity;
  warrantBoardMembers: Array<GqlWarrantBoardMember>;
  warrantDocument: GqlWarrantDocument;
  warrantParticipant: GqlWarrantParticipant;
  warrantParticipantErrors: GqlWppValidatorErrors;
  warrantProgram: GqlWarrantProgram;
  warrantProgramErrors: GqlWpValidatorErrors;
  warrantPrograms: GqlWarrantProgramsPagedResult;
  warrantShareholders: Array<GqlWarrantShareholder>;
  wiseDependencyBonds: Array<GqlWiseDependencyBond>;
  wiseErrors: GqlWiseValidatorErrors;
  wpCount: Scalars['Int']['output'];
  wpOptionsLeft: Scalars['Float']['output'];
  wppDefaults: GqlWppDefaults;
}


export interface GqlQueryActiveCompanyStripeSubscriptionArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlQueryAdminCompanyArgs {
  id: Scalars['String']['input'];
}


export interface GqlQueryAdminUsersArgs {
  input: GqlASearchUsersInput;
}


export interface GqlQueryAdminZignedDocumentsArgs {
  input: GqlASearchZignedDocumentsInput;
}


export interface GqlQueryAgendaItemArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQueryAgendaItemsArgs {
  companyId: Scalars['ID']['input'];
  meetingId: Scalars['ID']['input'];
}


export interface GqlQueryAgreementArgs {
  companyId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}


export interface GqlQueryAgreementsArgs {
  companyId: Scalars['String']['input'];
}


export interface GqlQueryAoaGetAffectedArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQueryAoaMinAndMaxOfSharesArgs {
  companyId: Scalars['ID']['input'];
  meetingId: Scalars['ID']['input'];
}


export interface GqlQueryArticlesOfAssocArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQueryArticlesOfAssocDocumentArgs {
  companyId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
}


export interface GqlQueryArticlesOfAssocErrorsArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQueryArticlesOfAssocsArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlQueryAuthorizationGroupArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQueryAuthorizationGroupDocumentArgs {
  companyId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
}


export interface GqlQueryAuthorizationGroupErrorsArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQueryAuthorizationGroupsArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlQueryCapTableArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQueryCapTableStakeArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQueryCapTableStakesArgs {
  capTableId: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
}


export interface GqlQueryCapTablesArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlQueryCompaniesArgs {
  filter?: InputMaybe<Scalars['String']['input']>;
}


export interface GqlQueryCompanyArgs {
  id: Scalars['ID']['input'];
}


export interface GqlQueryCompanyConnectionsArgs {
  connectionType?: InputMaybe<GqlCompanyConnectionEnum>;
}


export interface GqlQueryCompanyDirectorsArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlQueryCompanyInviteRequestsArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlQueryCompanyInvitesArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlQueryCompanyStatisticsArgs {
  id: Scalars['ID']['input'];
}


export interface GqlQueryCompanySubscriptionArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlQueryCompanySubscriptionsArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlQueryCompanyUsersArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlQueryCompleteSccsArgs {
  companyId: Scalars['ID']['input'];
  sort?: InputMaybe<GqlSortOrder>;
}


export interface GqlQueryCooptedMeetingParticipantsArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlQueryDocGenFullShareRegArgs {
  companyId: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
  docLanguage: GqlFileLanguageInput;
}


export interface GqlQueryDocGenValidateMeetingArgs {
  companyId: Scalars['ID']['input'];
  meetingId: Scalars['ID']['input'];
}


export interface GqlQueryDocumentSignaturesArgs {
  companyId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
}


export interface GqlQueryDocumentTemplatesArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlQueryEmployeeOptionsErrorsArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQueryFileArgs {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface GqlQueryFileUserTagsArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlQueryFilesByIdsArgs {
  companyId: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']>;
}


export interface GqlQueryFullShareRegArgs {
  companyId: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
}


export interface GqlQueryGetShareTransactionDocumentsArgs {
  companyId: Scalars['String']['input'];
}


export interface GqlQueryIdentityArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQueryIdentityByUserIdArgs {
  companyId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}


export interface GqlQueryIndividualReportArgs {
  companyId: Scalars['ID']['input'];
  input: GqlGetIndividualReportInput;
}


export interface GqlQueryInvestmentsArgs {
  companyId: Scalars['ID']['input'];
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
}


export interface GqlQueryMeetingArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQueryMeetingAgendaTemplatesArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlQueryMeetingByNumberArgs {
  companyId: Scalars['ID']['input'];
  number: Scalars['String']['input'];
}


export interface GqlQueryMeetingConcernsArgs {
  companyId: Scalars['ID']['input'];
  meetingId: Scalars['ID']['input'];
}


export interface GqlQueryMeetingDocumentArgs {
  companyId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
}


export interface GqlQueryMeetingErrorsArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQueryMeetingHasQesRegFormsArgs {
  companyId: Scalars['ID']['input'];
  input: GqlMeetingHasQesRegFormsInput;
}


export interface GqlQueryMeetingMcCountsArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQueryMeetingPaidForConcernsArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQueryMeetingParticipantArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQueryMeetingParticipantShareArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQueryMeetingParticipantSharesArgs {
  companyId: Scalars['ID']['input'];
  meetingParticipantId: Scalars['ID']['input'];
}


export interface GqlQueryMeetingParticipantsArgs {
  companyId: Scalars['ID']['input'];
  filter?: InputMaybe<GqlMeetingParticipantFilterInput>;
  limit?: Scalars['Int']['input'];
  meetingId: Scalars['ID']['input'];
  offset?: Scalars['Int']['input'];
}


export interface GqlQueryMeetingParticipantsByIdsArgs {
  companyId: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']>;
  meetingId: Scalars['ID']['input'];
}


export interface GqlQueryMeetingTodosArgs {
  companyId: Scalars['ID']['input'];
  meetingId: Scalars['ID']['input'];
}


export interface GqlQueryMeetingsArgs {
  companyId: Scalars['ID']['input'];
  kinds?: InputMaybe<Array<GqlMeetingKind>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  sortDirection?: InputMaybe<GqlSortOrder>;
  sortField?: InputMaybe<Scalars['String']['input']>;
}


export interface GqlQueryNextShareCapitalChangesArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlQueryNiceFoundersArgs {
  companyId: Scalars['ID']['input'];
  warrantProgramId: Scalars['ID']['input'];
}


export interface GqlQueryOptionsRegistrationArgs {
  id: Scalars['ID']['input'];
}


export interface GqlQueryOptionsRegistrationErrorsArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQueryOptionsRegistrationsArgs {
  companyId: Scalars['ID']['input'];
  warrantProgramId: Scalars['ID']['input'];
}


export interface GqlQueryOptionsSharesRegistrationArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQueryOptionsSharesRegistrationErrorsArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQueryOptionsSharesRegistrationsArgs {
  warrantProgramId: Scalars['ID']['input'];
}


export interface GqlQueryOptionsSharesSubscriberArgs {
  ossId: Scalars['ID']['input'];
}


export interface GqlQueryOptionsSharesSubscriberErrorsArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQueryOptionsSharesSubscribersArgs {
  osrId: Scalars['ID']['input'];
}


export interface GqlQueryOrDocumentLatestArgs {
  companyId: Scalars['ID']['input'];
  optionsRegistrationId: Scalars['ID']['input'];
}


export interface GqlQueryOrSignatoriesArgs {
  companyId: Scalars['ID']['input'];
  optionsRegistrationId: Scalars['ID']['input'];
}


export interface GqlQueryOsrVestedAndAllocatedArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQueryRatsitCompaniesArgs {
  includeCompanyCode?: InputMaybe<Array<GqlRatsitCompanyCode>>;
  name: Scalars['String']['input'];
}


export interface GqlQueryRatsitCompanyArgs {
  orgNumber: Scalars['String']['input'];
}


export interface GqlQueryRatsitCompanyBoardArgs {
  orgNumber: Scalars['String']['input'];
}


export interface GqlQueryRatsitSearchArgs {
  juridicalKinds: Array<Scalars['Int']['input']>;
  searchString: Scalars['String']['input'];
}


export interface GqlQueryScriveStatusMeetingMinutesByMeetingIdArgs {
  companyId: Scalars['ID']['input'];
  meetingId: Scalars['ID']['input'];
}


export interface GqlQuerySearchIdentitiesArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSearchIdentitiesInput;
}


export interface GqlQuerySellableShareStateArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSellableSharesInput;
}


export interface GqlQueryShCountArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlQueryShSellableSharesArgs {
  companyId: Scalars['ID']['input'];
  input: GqlShSellableSharesInput;
}


export interface GqlQueryShareClassesArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlQueryShareCountArgs {
  companyId: Scalars['ID']['input'];
  input?: InputMaybe<GqlShareCountInput>;
}


export interface GqlQueryShareIssueArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQueryShareIssueDocumentArgs {
  companyId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
}


export interface GqlQueryShareIssueErrorsArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQueryShareIssueRegistrationArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQueryShareIssueRegistrationErrorsArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQueryShareIssueRegistrationsArgs {
  companyId: Scalars['ID']['input'];
  shareIssueId: Scalars['ID']['input'];
}


export interface GqlQueryShareIssuesArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlQueryShareStateArgs {
  companyId: Scalars['ID']['input'];
  input?: InputMaybe<GqlShareStateInput>;
}


export interface GqlQueryShareStateIsValidArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlQueryShareTransactionDocumentArgs {
  fileId: Scalars['String']['input'];
}


export interface GqlQueryShareTransactionGroupArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQueryShareTransactionGroupsArgs {
  companyId: Scalars['ID']['input'];
  filter?: InputMaybe<GqlStgFilterInput>;
  identityId?: InputMaybe<Scalars['ID']['input']>;
}


export interface GqlQueryShareTransactionsArgs {
  companyId: Scalars['ID']['input'];
  shareTransactionGroupId: Scalars['ID']['input'];
}


export interface GqlQueryShareholderArgs {
  companyId: Scalars['ID']['input'];
  identityId: Scalars['ID']['input'];
}


export interface GqlQueryShareholdersArgs {
  companyId: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}


export interface GqlQueryShareholdersShareStateArgs {
  companyId: Scalars['ID']['input'];
  identityId: Scalars['ID']['input'];
}


export interface GqlQuerySiConnectedWpsArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQuerySiCountArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlQuerySiSharesLeftArgs {
  companyId: Scalars['ID']['input'];
  input: GqlSiSharesLeftInput;
}


export interface GqlQuerySipValidatorErrorsArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQuerySnrAuthNoBoardStatementArgs {
  companyId: Scalars['ID']['input'];
  snrAuthId: Scalars['ID']['input'];
}


export interface GqlQuerySnrAuthorizationsArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlQuerySnrBondsArgs {
  companyId: Scalars['ID']['input'];
  kind?: InputMaybe<GqlBondKind>;
  nonRegistered?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface GqlQuerySnrCasesArgs {
  companyId: Scalars['ID']['input'];
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
}


export interface GqlQuerySnrNumberOfSharesAtDateArgs {
  companyId: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
}


export interface GqlQuerySnrQuotaValueAtDateArgs {
  companyId: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
}


export interface GqlQuerySnrShareCapitalChangesArgs {
  companyId: Scalars['ID']['input'];
  filter?: InputMaybe<GqlSnrSccFilterInput>;
}


export interface GqlQueryStripeCompanyProductsArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlQueryStripeCompanySubscriptionArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlQueryStripeCustomerArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlQueryStripeInvoiceArgs {
  companyId: Scalars['ID']['input'];
  invoiceId: Scalars['ID']['input'];
}


export interface GqlQueryStripeInvoicesArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlQueryStripeMeetingConcernsInvoicesArgs {
  companyId: Scalars['ID']['input'];
  meetingId: Scalars['ID']['input'];
}


export interface GqlQueryStripePaymentIntentArgs {
  companyId: Scalars['ID']['input'];
  paymentIntentId: Scalars['ID']['input'];
}


export interface GqlQueryStripePaymentMethodsArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlQueryStripeProductArgs {
  id: Scalars['String']['input'];
}


export interface GqlQueryStripePromoCodeArgs {
  code: Scalars['String']['input'];
}


export interface GqlQueryStripeQuoteArgs {
  companyId: Scalars['ID']['input'];
  quoteId: Scalars['String']['input'];
}


export interface GqlQueryStripeSubscriptionsArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlQueryTodosArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlQueryTodosUnfinishedArgs {
  companyId: Scalars['ID']['input'];
}


export interface GqlQueryUserArgs {
  id: Scalars['ID']['input'];
}


export interface GqlQueryUserIdentityArgs {
  companyId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}


export interface GqlQueryWarrantBoardMembersArgs {
  companyId: Scalars['ID']['input'];
  warrantProgramId: Scalars['ID']['input'];
}


export interface GqlQueryWarrantDocumentArgs {
  companyId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
}


export interface GqlQueryWarrantParticipantArgs {
  id: Scalars['ID']['input'];
}


export interface GqlQueryWarrantParticipantErrorsArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQueryWarrantProgramArgs {
  id: Scalars['ID']['input'];
}


export interface GqlQueryWarrantProgramErrorsArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQueryWarrantProgramsArgs {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  companyId: Scalars['ID']['input'];
  kinds: Array<GqlWarrantProgramKind>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
}


export interface GqlQueryWarrantShareholdersArgs {
  companyId: Scalars['ID']['input'];
  warrantProgramId: Scalars['ID']['input'];
}


export interface GqlQueryWiseDependencyBondsArgs {
  companyId: Scalars['ID']['input'];
  warrantProgramId: Scalars['ID']['input'];
}


export interface GqlQueryWiseErrorsArgs {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}


export interface GqlQueryWpCountArgs {
  companyId: Scalars['ID']['input'];
  kind: Array<Scalars['Int']['input']>;
}


export interface GqlQueryWpOptionsLeftArgs {
  companyId: Scalars['ID']['input'];
  input: GqlWpOptionsLeftInput;
}


export interface GqlQueryWppDefaultsArgs {
  identityId?: InputMaybe<Scalars['ID']['input']>;
  warrantProgramId: Scalars['ID']['input'];
}

export interface GqlQuoteComputed {
  recurring?: Maybe<GqlQuoteComputedRecurring>;
  upfront: GqlQuoteComputedUpfront;
}

export interface GqlQuoteComputedRecurring {
  amount_subtotal: Scalars['Float']['output'];
  amount_total: Scalars['Float']['output'];
  interval: Scalars['String']['output'];
  interval_count: Scalars['Float']['output'];
  total_details: GqlQuoteComputedTotalDetails;
}

export interface GqlQuoteComputedTotalDetails {
  amount_discount: Scalars['Float']['output'];
  amount_tax: Scalars['Float']['output'];
}

export interface GqlQuoteComputedUpfront {
  amount_subtotal: Scalars['Float']['output'];
  amount_total: Scalars['Float']['output'];
  line_items?: Maybe<GqlStripeLineItemList>;
  total_details: GqlQuoteComputedTotalDetails;
}

export interface GqlQuoteTotalDetails {
  amount_discount: Scalars['Float']['output'];
  amount_tax: Scalars['Float']['output'];
}

export enum GqlRatsitCompanyCode {
  LimitedCompany = 'LimitedCompany',
  SoleProprietorship = 'SoleProprietorship'
}

export interface GqlRatsitIdentity {
  address?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  functionCode?: Maybe<Scalars['String']['output']>;
  functionText?: Maybe<Scalars['String']['output']>;
  identityNumber: Scalars['String']['output'];
  identityNumberKind: Scalars['Int']['output'];
  juridicalKind: Scalars['Int']['output'];
  name: Scalars['String']['output'];
}

/** How the user heard about the service */
export enum GqlReferralSource {
  Bolago = 'BOLAGO',
  Event = 'EVENT',
  Friend = 'FRIEND',
  Google = 'GOOGLE',
  Linkedin = 'LINKEDIN',
  Marketing = 'MARKETING',
  Other = 'OTHER',
  Startuptools = 'STARTUPTOOLS'
}

export interface GqlRefreshCapTableInput {
  clearEdits: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
}

export enum GqlRegistrationStatus {
  NotApplicable = 'NOT_APPLICABLE',
  NotRegistered = 'NOT_REGISTERED',
  Registered = 'REGISTERED'
}

export interface GqlRegistrationTodoCompletion {
  id: Scalars['ID']['output'];
  kind: GqlRegistrationTodoItemKind;
}

export enum GqlRegistrationTodoItemKind {
  BankNote = 'BankNote',
  PrintMeetingProtocol = 'PrintMeetingProtocol',
  PrintRegistrationForm = 'PrintRegistrationForm',
  SendToBolagsverket = 'SendToBolagsverket',
  UpdateShareRegister = 'UpdateShareRegister'
}

export interface GqlRiksbankenObservations {
  date: Scalars['String']['output'];
  value: Scalars['Float']['output'];
}

export enum GqlStRounded {
  Down = 'Down',
  None = 'None',
  Up = 'Up'
}

export enum GqlScriveAuthMethod {
  SeBankid = 'se_bankid',
  Standard = 'standard',
  ZealId = 'zeal_id'
}

export enum GqlScriveDocumentStatus {
  Canceled = 'canceled',
  Closed = 'closed',
  DocumentError = 'document_error',
  Pending = 'pending',
  Preparation = 'preparation',
  Rejected = 'rejected',
  Timedout = 'timedout'
}

export interface GqlSearchIdentitiesInput {
  juridicalKinds: Array<Scalars['Int']['input']>;
  pageOffset: Scalars['Float']['input'];
  pageSize: Scalars['Float']['input'];
  relations?: InputMaybe<GqlSearchIdentitiesRelations>;
  searchString: Scalars['String']['input'];
  similarity?: InputMaybe<Scalars['Float']['input']>;
}

export interface GqlSearchIdentitiesRelations {
  companyDirector?: InputMaybe<Scalars['Boolean']['input']>;
  meetingParticipant?: InputMaybe<Scalars['Boolean']['input']>;
  shareholder?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface GqlSellableShareResponse {
  sellableShares: Array<GqlSellableShares>;
  shareRegisterIsValid: Scalars['Boolean']['output'];
}

export interface GqlSellableShares {
  shareClasses: Array<GqlShareClass>;
  shareholder: GqlSellableSharesShareholder;
  shares: Scalars['JSONObject']['output'];
}

export interface GqlSellableSharesInput {
  date: Scalars['Date']['input'];
  sortOrder: Scalars['Int']['input'];
}

export interface GqlSellableSharesShareholder {
  companyId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  identity: GqlIdentity;
  identityId: Scalars['String']['output'];
  ownerCompanyId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
}

export interface GqlSendMailMeetingSummonsToAllInput {
  fileId: Scalars['ID']['input'];
  meetingId: Scalars['ID']['input'];
}

export interface GqlSendMailMeetingSummonsToOneInput {
  fileId: Scalars['ID']['input'];
  meetingId: Scalars['ID']['input'];
  meetingParticipantId: Scalars['ID']['input'];
}

export interface GqlSetShareClassInput {
  id: Scalars['ID']['input'];
  max?: InputMaybe<Scalars['String']['input']>;
  min?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  voteWeight?: InputMaybe<Scalars['String']['input']>;
}

export enum GqlSeverity {
  Error = 'error',
  Warning = 'warning'
}

export interface GqlShCountResponse {
  count: Scalars['Float']['output'];
}

export interface GqlShCreateInput {
  companyId: Scalars['ID']['input'];
  identityInput: GqlCreateIdentityInput;
}

export interface GqlShDeletedResponse {
  id: Scalars['ID']['output'];
}

export interface GqlShSellableShares {
  shareClasses: Array<GqlShareClass>;
  shares: Scalars['JSONObject']['output'];
}

export interface GqlShSellableSharesInput {
  date: Scalars['Date']['input'];
  id: Scalars['ID']['input'];
  sortOrder: Scalars['Int']['input'];
}

export interface GqlShSellableSharesResponse {
  sellableShares: GqlShSellableShares;
}

export interface GqlShareClass {
  name: Scalars['String']['output'];
  quantity?: Maybe<Scalars['String']['output']>;
  voteWeight: Scalars['String']['output'];
}

export interface GqlShareClassInput {
  name: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['String']['input']>;
  voteWeight: Scalars['String']['input'];
}

export interface GqlShareClassWithMinMax {
  max: Scalars['String']['output'];
  min: Scalars['String']['output'];
  name: Scalars['String']['output'];
  quantity?: Maybe<Scalars['String']['output']>;
  voteWeight: Scalars['String']['output'];
}

export interface GqlShareClassWithMinMaxInput {
  max: Scalars['String']['input'];
  min: Scalars['String']['input'];
  name: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['String']['input']>;
  voteWeight: Scalars['String']['input'];
}

export interface GqlShareCountInput {
  date: Scalars['Date']['input'];
  sortOrder: Scalars['Int']['input'];
}

export interface GqlShareCountResponse {
  shareRegisterLastUpdate?: Maybe<Scalars['Date']['output']>;
  shareRegisterShareCount: Scalars['String']['output'];
  snrLastUpdate: Scalars['Date']['output'];
  snrShareCount: Scalars['String']['output'];
}

export interface GqlShareIssue {
  approvedByMeeting?: Maybe<Scalars['Boolean']['output']>;
  articlesOfAssoc?: Maybe<GqlArticlesOfAssoc>;
  boardMembers: Array<GqlShareIssueBoardMember>;
  boardsStatementDate?: Maybe<Scalars['Date']['output']>;
  boardsStatementEn?: Maybe<Scalars['String']['output']>;
  boardsStatementOption?: Maybe<GqlBoardsStatementOption>;
  boardsStatementSv?: Maybe<Scalars['String']['output']>;
  company: GqlCompany;
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  currency: GqlCurrency;
  decisionKind?: Maybe<GqlDecisionKind>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  latestAuditorStatement?: Maybe<GqlBolagoFile>;
  latestAuditorStatementNonCash?: Maybe<GqlBolagoFile>;
  latestAuditorStatementOffset?: Maybe<GqlBolagoFile>;
  maxNumberOfShares?: Maybe<Scalars['String']['output']>;
  maxPaidAmount?: Maybe<Scalars['String']['output']>;
  meetingConcern?: Maybe<GqlMeetingConcern>;
  minNumberOfShares?: Maybe<Scalars['String']['output']>;
  nonCashStatementPl?: Maybe<Scalars['String']['output']>;
  nonCashStatementSl?: Maybe<Scalars['String']['output']>;
  numberOfSharesBefore?: Maybe<Scalars['String']['output']>;
  otherIncreasesOfShares: Scalars['String']['output'];
  paidForAt?: Maybe<Scalars['Date']['output']>;
  paymentCount: GqlSiPaymentCountResponse;
  paymentKindCash: Scalars['Boolean']['output'];
  paymentKindNonCash: Scalars['Boolean']['output'];
  paymentKindOffset: Scalars['Boolean']['output'];
  paymentMethodsCount: GqlSiPaymentMethodsCountResponse;
  preferentialRights: Scalars['Boolean']['output'];
  pricePerShare?: Maybe<Scalars['String']['output']>;
  primaryLang: Scalars['Boolean']['output'];
  published?: Maybe<Scalars['Boolean']['output']>;
  purpose: GqlShareIssuePurpose;
  quotaValue?: Maybe<Scalars['String']['output']>;
  requiresShareLimitChange: Scalars['Boolean']['output'];
  restrictedToParticipants?: Maybe<Scalars['Boolean']['output']>;
  secondaryLang: Scalars['Boolean']['output'];
  shareClasses: Array<GqlShareClassWithMinMax>;
  shareIssueDocuments: Array<GqlShareIssueDocument>;
  shareIssueRegistrations: Array<GqlShareIssueRegistration>;
  snrAuthorization?: Maybe<GqlSnrAuthorization>;
  snrAuthorizationId?: Maybe<Scalars['ID']['output']>;
  snrShareCapitalChangeId?: Maybe<Scalars['ID']['output']>;
  stripeInvoiceId?: Maybe<Scalars['String']['output']>;
  subscriptionEndDate?: Maybe<Scalars['Date']['output']>;
  subscriptionStartDate?: Maybe<Scalars['Date']['output']>;
  updatedAt: Scalars['Date']['output'];
  validatorErrors: GqlShareIssueValidatorErrors;
}

export interface GqlShareIssueBoardMember {
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  identity: GqlIdentity;
  identityId: Scalars['ID']['output'];
  shareIssue: GqlShareIssue;
  shareIssueId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
}

export interface GqlShareIssueDocument {
  createdAt: Scalars['Date']['output'];
  file: GqlBolagoFile;
  fileId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  shareIssue: GqlShareIssue;
  shareIssueId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
}

export interface GqlShareIssueParticipant {
  claim?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  identity: GqlIdentity;
  identityId: Scalars['ID']['output'];
  latestShareSubscriptionList?: Maybe<GqlBolagoFile>;
  numberOfShares?: Maybe<Scalars['String']['output']>;
  numberOfSharesMax?: Maybe<Scalars['String']['output']>;
  paymentKind: Scalars['Int']['output'];
  paymentStatus: Scalars['Int']['output'];
  proxy?: Maybe<GqlIdentity>;
  proxyId?: Maybe<Scalars['ID']['output']>;
  shareClass?: Maybe<GqlShareClass>;
  shareIssueRegistration: GqlShareIssueRegistration;
  shareIssueRegistrationId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
}

export enum GqlShareIssuePurpose {
  Capital = 'Capital',
  Qeso = 'QESO'
}

export interface GqlShareIssueRegistration {
  contact?: Maybe<GqlIdentity>;
  contactId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Date']['output'];
  currencyExchangeRate?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  ibanAddress?: Maybe<Scalars['String']['output']>;
  ibanBank?: Maybe<Scalars['String']['output']>;
  ibanBic?: Maybe<Scalars['String']['output']>;
  ibanNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latestRegistrationForm?: Maybe<GqlBolagoFile>;
  participants: Array<GqlShareIssueParticipant>;
  paymentAccountKind?: Maybe<GqlPaymentAccountKind>;
  paymentAccountNumber?: Maybe<Scalars['String']['output']>;
  paymentDueDate?: Maybe<Scalars['Date']['output']>;
  paymentName?: Maybe<Scalars['String']['output']>;
  regFormPaymentThroughBolago: Scalars['Boolean']['output'];
  shareIssue: GqlShareIssue;
  shareIssueId: Scalars['String']['output'];
  signatory?: Maybe<GqlIdentity>;
  signatoryId?: Maybe<Scalars['ID']['output']>;
  snrCase?: Maybe<GqlSnrCase>;
  snrCaseId?: Maybe<Scalars['String']['output']>;
  todoCompletions: Array<GqlRegistrationTodoCompletion>;
  todos: Array<GqlRegistrationTodoItemKind>;
  updatedAt: Scalars['Date']['output'];
  validatorErrors: GqlSirValidatorErrors;
}

export interface GqlShareIssueRegistrationDocument {
  createdAt: Scalars['Date']['output'];
  file: GqlBolagoFile;
  fileId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  shareIssueRegistrationId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
}

export interface GqlShareIssueValidatorErrors {
  boardsStatement: GqlValidatorStatus;
  decision: GqlValidatorStatus;
  language: GqlValidatorStatus;
  newShares: GqlValidatorStatus;
  nonCash: GqlValidatorStatus;
  payByOffset: GqlValidatorStatus;
  paymentKind: GqlValidatorStatus;
  preferentialRights: GqlValidatorStatus;
  shareClasses: GqlValidatorStatus;
  subscriptionDate: GqlValidatorStatus;
}

export interface GqlShareRange {
  currency: GqlCurrency;
  end: Scalars['Float']['output'];
  pricePerShare?: Maybe<Scalars['String']['output']>;
  shareCertificateDate?: Maybe<Scalars['Date']['output']>;
  shareClass: GqlShareClass;
  snrSccId?: Maybe<Scalars['String']['output']>;
  splitFactor?: Maybe<Scalars['String']['output']>;
  start: Scalars['Float']['output'];
  stgId: Scalars['String']['output'];
  stgSortOrder: Scalars['Float']['output'];
  transactionDate: Scalars['Date']['output'];
  transactionId: Scalars['String']['output'];
  transactionKind: GqlTransactionKind;
}

export interface GqlShareStateInput {
  keepFormer?: InputMaybe<Scalars['Boolean']['input']>;
  untilDate?: InputMaybe<Scalars['Date']['input']>;
  untilStgId?: InputMaybe<Scalars['ID']['input']>;
  untilTransactionId?: InputMaybe<Scalars['ID']['input']>;
}

export interface GqlShareStateResponse {
  isValid: Scalars['Boolean']['output'];
  ownerStates: Array<GqlOwnerState>;
  totalNumberOfShares: Scalars['Int']['output'];
}

export interface GqlShareTransaction {
  blockEnd: Scalars['String']['output'];
  blockStart: Scalars['String']['output'];
  buyer?: Maybe<GqlShareholder>;
  buyerId?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  currency: GqlCurrency;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  pricePerShare?: Maybe<Scalars['String']['output']>;
  rounded: GqlStRounded;
  seller?: Maybe<GqlShareholder>;
  sellerId?: Maybe<Scalars['String']['output']>;
  shareCertificateDate?: Maybe<Scalars['Date']['output']>;
  shareClassFrom?: Maybe<GqlShareClass>;
  shareClassTo?: Maybe<GqlShareClass>;
  shareTransactionDocuments: Array<GqlShareTransactionDocument>;
  shareTransactionGroup: GqlShareTransactionGroup;
  shareTransactionGroupId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['Date']['output'];
}

export interface GqlShareTransactionDocument {
  createdAt: Scalars['Date']['output'];
  file: GqlBolagoFile;
  fileId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  shareTransaction: GqlShareTransaction;
  shareTransactionId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
}

export interface GqlShareTransactionGroup {
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  kind: GqlTransactionKind;
  shareIssueId?: Maybe<Scalars['ID']['output']>;
  shareTransactions: Array<GqlShareTransaction>;
  snrShareCapitalChange?: Maybe<GqlSnrShareCapitalChange>;
  snrShareCapitalChangeId?: Maybe<Scalars['ID']['output']>;
  sortOrder: Scalars['Int']['output'];
  splitFactor?: Maybe<Scalars['String']['output']>;
  transactionDate: Scalars['Date']['output'];
  updatedAt: Scalars['Date']['output'];
  warrantProgramId?: Maybe<Scalars['ID']['output']>;
}

export interface GqlShareholder {
  company: GqlCompany;
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  identity: GqlIdentity;
  identityId: Scalars['ID']['output'];
  ownerCompanyId?: Maybe<Scalars['ID']['output']>;
  shareState?: Maybe<GqlOwnerState>;
  shareTransactions: Array<GqlShareTransaction>;
  updatedAt: Scalars['Date']['output'];
}


export interface GqlShareholderShareStateArgs {
  date?: InputMaybe<Scalars['Date']['input']>;
}

export interface GqlShareholderOverviewShareholder {
  company: GqlCompany;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  identity: GqlIdentity;
  identityId: Scalars['String']['output'];
  numberOfShares: Scalars['Float']['output'];
  ownerCompanyId?: Maybe<Scalars['String']['output']>;
  ranges: Array<GqlShareRange>;
  shareTransactions: Array<GqlShareTransaction>;
  sums: Array<GqlOwnerStateSums>;
  updatedAt: Scalars['Date']['output'];
}

export interface GqlSharesLeftToAllocate {
  allocated: Scalars['Float']['output'];
  left: Scalars['Float']['output'];
  name: Scalars['String']['output'];
}

/** Connect auth */
export interface GqlSiConnectAuthorizationInput {
  id: Scalars['ID']['input'];
  snrAuthorizationId: Scalars['ID']['input'];
}

/** Connect meeting */
export interface GqlSiConnectMeetingInput {
  id: Scalars['ID']['input'];
  meetingId: Scalars['ID']['input'];
  snrAuthorizationId?: InputMaybe<Scalars['ID']['input']>;
}

export interface GqlSiConnectMeetingResponse {
  shareIssue: GqlShareIssue;
}

/** Create share issue */
export interface GqlSiCreateInput {
  description: Scalars['String']['input'];
  preferentialRights: Scalars['Boolean']['input'];
  primaryLang: Scalars['Boolean']['input'];
  secondaryLang: Scalars['Boolean']['input'];
  shareClasses: Array<GqlShareClassWithMinMaxInput>;
}

/** Create and connect meeting */
export interface GqlSiCreateMeetingInput {
  id: Scalars['ID']['input'];
  meetingCreate: GqlMeetingCreateInput;
  snrAuthorizationId?: InputMaybe<Scalars['ID']['input']>;
}

export interface GqlSiDeletedResponse {
  aiDeletedResponses?: Maybe<Array<GqlAiDeletedResponse>>;
  aiSetDoneResponse?: Maybe<GqlAiSetDoneResponse>;
  id: Scalars['ID']['output'];
  mcDeletedResponse?: Maybe<GqlMcDeletedResponse>;
}

/** Disconnect authorization, will also disconnect meeting if there is one connected */
export interface GqlSiDisconnectAuthorizationInput {
  id: Scalars['ID']['input'];
}

/** Disconnect meeting */
export interface GqlSiDisconnectMeetingInput {
  id: Scalars['ID']['input'];
}

export interface GqlSiDisconnectMeetingResponse {
  aiDeletedResponses?: Maybe<Array<GqlAiDeletedResponse>>;
  aiSetDoneResponse?: Maybe<GqlAiSetDoneResponse>;
  mcDeletedResponse?: Maybe<GqlMcDeletedResponse>;
  shareIssue: GqlShareIssue;
}

export interface GqlSiPaymentCountResponse {
  notPaid: Scalars['Float']['output'];
  paid: Scalars['Float']['output'];
  waiting: Scalars['Float']['output'];
}

export interface GqlSiPaymentMethodsCountResponse {
  cash: Scalars['Float']['output'];
  nonCash: Scalars['Float']['output'];
  offset: Scalars['Float']['output'];
}

export interface GqlSiSetBoardsStatementInput {
  boardsStatementDate?: InputMaybe<Scalars['Date']['input']>;
  boardsStatementEn?: InputMaybe<Scalars['String']['input']>;
  boardsStatementOption: GqlBoardsStatementOption;
  boardsStatementSv?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
}

export interface GqlSiSetBoardsStatementResponse {
  shareIssue: GqlShareIssue;
}

export interface GqlSiSetDescriptionInput {
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
}

export interface GqlSiSetLanguageInput {
  id: Scalars['ID']['input'];
  primaryLang: Scalars['Boolean']['input'];
  secondaryLang: Scalars['Boolean']['input'];
}

export interface GqlSiSetNewSharesInput {
  currency: GqlCurrency;
  id: Scalars['ID']['input'];
  maxNumberOfShares: Scalars['String']['input'];
  minNumberOfShares: Scalars['String']['input'];
  numberOfSharesBefore: Scalars['String']['input'];
  pricePerShare: Scalars['String']['input'];
  quotaValue: Scalars['String']['input'];
}

export interface GqlSiSetNonCashStatementInput {
  id: Scalars['ID']['input'];
  nonCashStatementPl?: InputMaybe<Scalars['String']['input']>;
  nonCashStatementSl?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlSiSetPaymentKindInput {
  id: Scalars['ID']['input'];
  paymentKindCash: Scalars['Boolean']['input'];
  paymentKindNonCash: Scalars['Boolean']['input'];
  paymentKindOffset: Scalars['Boolean']['input'];
}

export interface GqlSiSetPaymentKindResponse {
  documents: Array<GqlBolagoFile>;
  shareIssue: GqlShareIssue;
  sipDeletedResponses: Array<GqlSipDeletedResponse>;
}

/** Set si subscription dates */
export interface GqlSiSetSubscriptionDatesInput {
  id: Scalars['ID']['input'];
  subscriptionEndDate: Scalars['Date']['input'];
  subscriptionStartDate: Scalars['Date']['input'];
}

export interface GqlSiSharesLeftInput {
  id: Scalars['ID']['input'];
  shareClassName: Scalars['String']['input'];
}

export interface GqlSiUpdateInput {
  id: Scalars['ID']['input'];
  preferentialRights?: InputMaybe<Scalars['Boolean']['input']>;
  purpose?: InputMaybe<GqlShareIssuePurpose>;
  subscriptionEndDate?: InputMaybe<Scalars['Date']['input']>;
}

/** Create share issue participant */
export interface GqlSibmCreateInput {
  identityInput: GqlCreateIdentityInput;
  shareIssueId: Scalars['ID']['input'];
}

export interface GqlSibmDeletedResponse {
  id: Scalars['ID']['output'];
}

export enum GqlSignAllowedAction {
  None = 'None',
  Restart = 'Restart',
  Start = 'Start',
  Stop = 'Stop'
}

/** Create share issue participant */
export interface GqlSipCreateInput {
  claim?: InputMaybe<Scalars['String']['input']>;
  identityInput: GqlCreateIdentityInput;
  numberOfShares?: InputMaybe<Scalars['String']['input']>;
  paymentKind: Scalars['Int']['input'];
  shareClass?: InputMaybe<GqlShareClassInput>;
  shareIssueRegistrationId: Scalars['ID']['input'];
}

export interface GqlSipDeletedResponse {
  id: Scalars['ID']['output'];
}

export interface GqlSipEditInput {
  claim?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  numberOfShares: Scalars['String']['input'];
  shareClass: GqlShareClassInput;
}

/** Set sip payment status */
export interface GqlSipSetPaymentStatusInput {
  id: Scalars['ID']['input'];
  paymentStatus: Scalars['Int']['input'];
}

export interface GqlSipSetProxyInput {
  id: Scalars['ID']['input'];
  proxyInput: GqlCreateIdentityInput;
}

export interface GqlSipUpdateResponse {
  documents: Array<GqlBolagoFile>;
  shareIssueParticipant: GqlShareIssueParticipant;
}

export interface GqlSipValidatorErrors {
  paymentStatus: GqlValidatorStatus;
  proxy: GqlValidatorStatus;
}

export interface GqlSirCreateInput {
  description: Scalars['String']['input'];
  shareIssueId: Scalars['ID']['input'];
}

export interface GqlSirSetCurrencyExchangeRateInput {
  currencyExchangeRate: Scalars['String']['input'];
  id: Scalars['ID']['input'];
}

export interface GqlSirSetPaymentDueDateInput {
  id: Scalars['ID']['input'];
  paymentDueDate: Scalars['Date']['input'];
}

export interface GqlSirSetPaymentInput {
  ibanAddress?: InputMaybe<Scalars['String']['input']>;
  ibanBank?: InputMaybe<Scalars['String']['input']>;
  ibanBic?: InputMaybe<Scalars['String']['input']>;
  ibanNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  paymentAccountKind?: InputMaybe<GqlPaymentAccountKind>;
  paymentAccountNumber?: InputMaybe<Scalars['String']['input']>;
  paymentDueDate: Scalars['Date']['input'];
  paymentName?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlSirSetSnrCaseInput {
  id: Scalars['ID']['input'];
  snrCaseId?: InputMaybe<Scalars['ID']['input']>;
}

export interface GqlSirUpdateInput {
  contact?: InputMaybe<GqlCreateIdentityInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  regFormPaymentThroughBolago?: InputMaybe<Scalars['Boolean']['input']>;
  signatory?: InputMaybe<GqlCreateIdentityInput>;
}

export interface GqlSirUpdateResponse {
  affectedDocuments: Array<GqlBolagoFile>;
  sir: GqlShareIssueRegistration;
}

export interface GqlSirValidatorErrors {
  currencyExchangeRate: GqlValidatorStatus;
  decision: GqlValidatorStatus;
  options: GqlValidatorStatus;
  participants: GqlValidatorStatus;
  payment: GqlValidatorStatus;
  paymentDueDate: GqlValidatorStatus;
  paymentStatus: GqlValidatorStatus;
  signsRegForm: GqlValidatorStatus;
  todos: GqlValidatorStatus;
}

export interface GqlSnrAuthorization {
  auths: Array<GqlSnrAuthorizationAuth>;
  company: GqlCompany;
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  filingNumber: Scalars['String']['output'];
  filingYear: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  noBoardStatement: Scalars['Boolean']['output'];
  registrationDate: Scalars['Date']['output'];
  serialNumber: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
}

export interface GqlSnrAuthorizationAuth {
  before: Scalars['String']['output'];
  before_year?: Maybe<Scalars['String']['output']>;
  date: Scalars['String']['output'];
  kind: Scalars['String']['output'];
}

export interface GqlSnrBond {
  bondType: Scalars['String']['output'];
  company: GqlCompany;
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  decisionBy?: Maybe<Scalars['String']['output']>;
  decisionDate?: Maybe<Scalars['Date']['output']>;
  filingNumber: Scalars['String']['output'];
  filingYear: Scalars['String']['output'];
  freetext?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  numberOfOptions?: Maybe<Scalars['String']['output']>;
  numberOfOptionsMax?: Maybe<Scalars['String']['output']>;
  numberOfOptionsMin?: Maybe<Scalars['String']['output']>;
  numberOfSharesMax?: Maybe<Scalars['String']['output']>;
  partRegistration: Scalars['Boolean']['output'];
  registrationDate: Scalars['Date']['output'];
  serialNumber: Scalars['String']['output'];
  shareCapitalCanBeIncreaseBy?: Maybe<Scalars['String']['output']>;
  shareCapitalCanBeIncreaseByCurrency?: Maybe<Scalars['String']['output']>;
  shareClass?: Maybe<Scalars['String']['output']>;
  shareSubEndDate?: Maybe<Scalars['Date']['output']>;
  shareSubStartDate?: Maybe<Scalars['Date']['output']>;
  updatedAt: Scalars['Date']['output'];
  warrantProgram?: Maybe<GqlWarrantProgram>;
  warrantSubFrom?: Maybe<Scalars['Date']['output']>;
  warrantSubTo?: Maybe<Scalars['Date']['output']>;
  withoutLoan?: Maybe<Scalars['Boolean']['output']>;
}

export interface GqlSnrCase {
  arrivalDate?: Maybe<Scalars['Date']['output']>;
  company: GqlCompany;
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  filingNumber: Scalars['String']['output'];
  filingYear: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  registrationDate?: Maybe<Scalars['Date']['output']>;
  shareIssueRegistrations: Array<GqlShareIssueRegistration>;
  status: Array<GqlSnrCaseStatus>;
  subjects: Array<GqlSnrCaseSubject>;
  updatedAt: Scalars['Date']['output'];
}

export interface GqlSnrCasePagedResult {
  models: Array<GqlSnrCase>;
  totalCount: Scalars['Int']['output'];
}

export interface GqlSnrCaseStatus {
  kod: Scalars['String']['output'];
  value: Scalars['String']['output'];
}

export interface GqlSnrCaseSubject {
  kind: GqlSnrCaseSubjectKind;
  value: Scalars['String']['output'];
}

export enum GqlSnrCaseSubjectKind {
  Aabf = 'AABF',
  Aaf = 'AAF',
  Aahf = 'AAHF',
  Aapf = 'AAPF',
  Akt = 'AKT',
  Aktiebok = 'AKTIEBOK',
  Ar = 'AR',
  Arslut = 'ARSLUT',
  Arsred = 'ARSRED',
  As = 'AS',
  Auar = 'AUAR',
  Avf = 'AVF',
  Avffu = 'AVFFU',
  Avford = 'AVFORD',
  Avg = 'AVG',
  Avrfly = 'AVRFLY',
  Avsdat = 'AVSDAT',
  Avt = 'AVT',
  Beny = 'BENY',
  Besk = 'BESK',
  Bestrid = 'BESTRID',
  Bevak = 'BEVAK',
  Bfu = 'BFU',
  Bif = 'BIF',
  Bifu = 'BIFU',
  Bve = 'BVE',
  Bvear = 'BVEAR',
  Bveft = 'BVEFT',
  Bvejur = 'BVEJUR',
  Bvemfa = 'BVEMFA',
  Bvemfe = 'BVEMFE',
  Bveovr = 'BVEOVR',
  Bvepa = 'BVEPA',
  Bverev = 'BVEREV',
  Bvevak = 'BVEVAK',
  De = 'DE',
  Del = 'DEL',
  Delan = 'DELAN',
  Delang = 'DELANG',
  Delar = 'DELAR',
  Delat = 'DELAT',
  Delbesg = 'DELBESG',
  Dele = 'DELE',
  Delfo = 'DELFO',
  Delfog = 'DELFOG',
  Delg = 'DELG',
  Delgp = 'DELGP',
  Delgr = 'DELGR',
  Delgu = 'DELGU',
  Delkalg = 'DELKALG',
  Delkall = 'DELKALL',
  Delotr = 'DELOTR',
  Delotrg = 'DELOTRG',
  Delovrg = 'DELOVRG',
  Delp = 'DELP',
  Delpkall = 'DELPKALL',
  Delpl = 'DELPL',
  Delplg = 'DELPLG',
  Delti = 'DELTI',
  Deltig = 'DELTIG',
  Deltp = 'DELTP',
  Deovr = 'DEOVR',
  Dfi = 'DFI',
  Disp = 'DISP',
  Eftg = 'EFTG',
  Epa = 'EPA',
  Fax = 'FAX',
  Felu = 'FELU',
  Ffan = 'FFAN',
  Ffny = 'FFNY',
  Ffrv = 'FFRV',
  Ffua = 'FFUA',
  Firm = 'FIRM',
  Fobo = 'FOBO',
  For = 'FOR',
  Forav = 'FORAV',
  Forgr = 'FORGR',
  Forin = 'FORIN',
  Formed = 'FORMED',
  Forp = 'FORP',
  Foru = 'FORU',
  Fram = 'FRAM',
  Frammed = 'FRAMMED',
  Fri = 'FRI',
  Frtst = 'FRTST',
  Fu = 'FU',
  Fuaat = 'FUAAT',
  Fuan = 'FUAN',
  Fuang = 'FUANG',
  Fuank = 'FUANK',
  Fuat = 'FUAT',
  Fuav = 'FUAV',
  Fube = 'FUBE',
  Fubestr = 'FUBESTR',
  Fufo = 'FUFO',
  Fufog = 'FUFOG',
  Fufok = 'FUFOK',
  Fukall = 'FUKALL',
  Fukallg = 'FUKALLG',
  Fukallk = 'FUKALLK',
  Fukomb = 'FUKOMB',
  Fuol = 'FUOL',
  Fuot = 'FUOT',
  Fuotr = 'FUOTR',
  Fuovr = 'FUOVR',
  Fupl = 'FUPL',
  Fuplg = 'FUPLG',
  Fuplk = 'FUPLK',
  Fuplkall = 'FUPLKALL',
  Fuplti = 'FUPLTI',
  Fuplve = 'FUPLVE',
  Fusfo = 'FUSFO',
  Fuskv = 'FUSKV',
  Fusve = 'FUSVE',
  Futi = 'FUTI',
  Futig = 'FUTIG',
  Futik = 'FUTIK',
  Futst = 'FUTST',
  Fuve = 'FUVE',
  Fuvil = 'FUVIL',
  Garatr = 'GARATR',
  Garbet = 'GARBET',
  Gr = 'GR',
  Kapgrans = 'KAPGRANS',
  Kk = 'KK',
  Kkand = 'KKAND',
  Kkavmo = 'KKAVMO',
  Kkavsl = 'KKAVSL',
  Kkfort = 'KKFORT',
  Kkfv = 'KKFV',
  Kkuha = 'KKUHA',
  Ko = 'KO',
  Konc = 'KONC',
  Koncfo = 'KONCFO',
  Konv = 'KONV',
  Konvm = 'KONVM',
  Konvt = 'KONVT',
  Lager = 'LAGER',
  Lan = 'LAN',
  Li = 'LI',
  Lia = 'LIA',
  Liavsl = 'LIAVSL',
  Lifort = 'LIFORT',
  Likall = 'LIKALL',
  Likallo = 'LIKALLO',
  Likv = 'LIKV',
  Likvp = 'LIKVP',
  Liokl = 'LIOKL',
  Lioklu = 'LIOKLU',
  Litr = 'LITR',
  Liuha = 'LIUHA',
  Liupav = 'LIUPAV',
  Mpa = 'MPA',
  Mrevf = 'MREVF',
  Mrevu = 'MREVU',
  Nk = 'NK',
  Nkfo = 'NKFO',
  Nkkall = 'NKKALL',
  Nkotr = 'NKOTR',
  Nktst = 'NKTST',
  Nyb = 'NYB',
  Ok = 'OK',
  Okbet = 'OKBET',
  Okfo = 'OKFO',
  Okfoe = 'OKFOE',
  Okla = 'OKLA',
  Okny = 'OKNY',
  Oksk = 'OKSK',
  Oktat = 'OKTAT',
  Ombang = 'OMBANG',
  Ombestg = 'OMBESTG',
  Ombfog = 'OMBFOG',
  Ombg = 'OMBG',
  Ombkalg = 'OMBKALG',
  Ombotrg = 'OMBOTRG',
  Ombovrg = 'OMBOVRG',
  Ombplg = 'OMBPLG',
  Ombtig = 'OMBTIG',
  Omp = 'OMP',
  Omrak = 'OMRAK',
  Ordn = 'ORDN',
  Ordnabl = 'ORDNABL',
  Os = 'OS',
  Pa = 'PA',
  Parf = 'PARF',
  Parfu = 'PARFU',
  Period = 'PERIOD',
  Pra = 'PRA',
  Priv = 'PRIV',
  Prot = 'PROT',
  Prvefg = 'PRVEFG',
  Prvfor = 'PRVFOR',
  Prvli = 'PRVLI',
  Prvnf = 'PRVNF',
  Prvomp = 'PRVOMP',
  Prvpers = 'PRVPERS',
  Prvpkk = 'PRVPKK',
  Prvrev = 'PRVREV',
  Ptr = 'PTR',
  Publ = 'PUBL',
  Rak = 'RAK',
  Rakp = 'RAKP',
  Rappbet = 'RAPPBET',
  Re = 'RE',
  Refa = 'REFA',
  Regfu = 'REGFU',
  Regovr = 'REGOVR',
  Rek = 'REK',
  Rekand = 'REKAND',
  Rekplan = 'REKPLAN',
  Rekuha = 'REKUHA',
  Rekuho = 'REKUHO',
  Rest = 'REST',
  Rev = 'REV',
  Reva = 'REVA',
  Revb = 'REVB',
  Reve = 'REVE',
  Revf = 'REVF',
  Revp = 'REVP',
  Revu = 'REVU',
  Rfu = 'RFU',
  Rpa = 'RPA',
  Sate = 'SATE',
  Sk = 'SK',
  Skkon = 'SKKON',
  Skkonvm = 'SKKONVM',
  Skyddreg = 'SKYDDREG',
  Spa = 'SPA',
  St = 'ST',
  Ste = 'STE',
  Stg = 'STG',
  Stp = 'STP',
  Tel = 'TEL',
  Tikall = 'TIKALL',
  Tillatk = 'TILLATK',
  Tillst = 'TILLST',
  Tiotr = 'TIOTR',
  Tivum = 'TIVUM',
  Topt = 'TOPT',
  Toptvm = 'TOPTVM',
  Tr = 'TR',
  Typbab = 'TYPBAB',
  Typfab = 'TYPFAB',
  Typtpab = 'TYPTPAB',
  Ub = 'UB',
  Up = 'UP',
  Utd = 'UTD',
  Utlfor = 'UTLFOR',
  Utlforp = 'UTLFORP',
  Valuta = 'VALUTA',
  Vd = 'VD',
  Vite = 'VITE',
  Vpcreg = 'VPCREG',
  Vpo = 'VPO'
}

export interface GqlSnrSccFilterInput {
  excludeAtQuotaValue?: InputMaybe<Scalars['Boolean']['input']>;
  names?: InputMaybe<Array<GqlSnrSccName>>;
  sort?: InputMaybe<GqlSortOrder>;
}

export enum GqlSnrSccName {
  Fondemission = 'FONDEMISSION',
  Minskning = 'MINSKNING',
  MinsknForf = 'MINSKN_FORF',
  Nybildning = 'NYBILDNING',
  Nyemission = 'NYEMISSION',
  TecknOption = 'TECKN_OPTION',
  UtbyteKonv = 'UTBYTE_KONV',
  ValutaOmvl = 'VALUTA_OMVL'
}

export interface GqlSnrShareCapitalChange {
  amountChange: Scalars['String']['output'];
  amountTotal: Scalars['String']['output'];
  amountTotalBeforeChange: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  companyValue?: Maybe<Scalars['String']['output']>;
  companyValuePreMoney?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  currency: GqlCurrency;
  decisionDate?: Maybe<Scalars['Date']['output']>;
  decisionDateWarning: Scalars['Boolean']['output'];
  done: Scalars['Boolean']['output'];
  filingNumber: Scalars['String']['output'];
  filingYear: Scalars['String']['output'];
  foundersShareFraction?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  registrationDate: Scalars['Date']['output'];
  serialNumber: Scalars['String']['output'];
  shareClasses: Array<GqlShareClass>;
  sharePriceFactor?: Maybe<Scalars['String']['output']>;
  shareValue?: Maybe<Scalars['String']['output']>;
  shareValueSplitAdjusted?: Maybe<Scalars['String']['output']>;
  sharesChange?: Maybe<Scalars['String']['output']>;
  sharesChangeSplitAdjusted?: Maybe<Scalars['String']['output']>;
  sharesLeftToAllocate: Scalars['Float']['output'];
  sharesLeftToAllocateByShareClass: Array<GqlSharesLeftToAllocate>;
  sharesTotal?: Maybe<Scalars['String']['output']>;
  sharesTotalAfterChange?: Maybe<Scalars['String']['output']>;
  sharesTotalSplitAdjusted?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  sortOrderOverride?: Maybe<Scalars['Float']['output']>;
  sortOrderSnr?: Maybe<Scalars['Float']['output']>;
  splitFactor: Scalars['String']['output'];
  splitSharesChange: Scalars['String']['output'];
  transactionValue?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
}

export enum GqlSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export interface GqlStCreateIssueInput {
  buyerId: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  currency: GqlCurrency;
  numberOfShares: Scalars['Int']['input'];
  pricePerShare?: InputMaybe<Scalars['String']['input']>;
  shareClassTo: GqlShareClassInput;
  shareTransactionGroupId: Scalars['ID']['input'];
}

export interface GqlStCreateTransferInput {
  buyerId: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  currency: GqlCurrency;
  numberOfShares: Scalars['Int']['input'];
  pricePerShare?: InputMaybe<Scalars['String']['input']>;
  sellerId: Scalars['ID']['input'];
  shareClassFrom: GqlShareClassInput;
  shareClassTo: GqlShareClassInput;
  shareTransactionGroupId: Scalars['ID']['input'];
}

export interface GqlStCreateUnissueInput {
  comment?: InputMaybe<Scalars['String']['input']>;
  currency: GqlCurrency;
  numberOfShares: Scalars['Int']['input'];
  pricePerShare?: InputMaybe<Scalars['String']['input']>;
  sellerId: Scalars['ID']['input'];
  shareClassFrom: GqlShareClassInput;
  shareTransactionGroupId: Scalars['ID']['input'];
}

export interface GqlStImportTransfersInput {
  csvInput: Scalars['String']['input'];
  shareTransactionGroupId: Scalars['ID']['input'];
}

export interface GqlStSetCommentInput {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
}

export interface GqlStSetPricePerShareInput {
  currency: GqlCurrency;
  id: Scalars['ID']['input'];
  pricePerShare?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlStSetShareCertificateDateInput {
  id: Scalars['ID']['input'];
  shareCertificateDate: Scalars['Date']['input'];
}

export interface GqlStgCreateInput {
  beforeStgId?: InputMaybe<Scalars['ID']['input']>;
  kind: GqlTransactionKind;
  roundupShareholderId?: InputMaybe<Scalars['String']['input']>;
  shareIssueId?: InputMaybe<Scalars['ID']['input']>;
  snrShareCapitalChangeId?: InputMaybe<Scalars['ID']['input']>;
  splitFactor?: InputMaybe<Scalars['String']['input']>;
  transactionDate: Scalars['Date']['input'];
  warrantProgramId?: InputMaybe<Scalars['ID']['input']>;
}

export interface GqlStgCreatedResponse {
  next?: Maybe<GqlCompleteShareCapitalChange>;
  transactions: Array<GqlShareTransactionGroup>;
}

export interface GqlStgDeleteInput {
  confirm: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
}

export interface GqlStgDeletedResponse {
  id: Scalars['ID']['output'];
}

export interface GqlStgFilterInput {
  maxDate: Scalars['Date']['input'];
}

export interface GqlStgSetSccIdInput {
  id: Scalars['ID']['input'];
  snrShareCapitalChangeId?: InputMaybe<Scalars['ID']['input']>;
}

export interface GqlStgSetupInput {
  split?: InputMaybe<GqlStgSetupSplitInput>;
  transferDate: Scalars['Date']['input'];
  transfers: Array<GqlStgSetupTransferInput>;
}

export interface GqlStgSetupSplitInput {
  sortOrder: Scalars['Int']['input'];
  splitDate: Scalars['Date']['input'];
  splitFactor: Scalars['String']['input'];
}

export interface GqlStgSetupTransferInput {
  buyerId: Scalars['ID']['input'];
  numberOfShares: Scalars['Int']['input'];
}

export interface GqlStripeAddress {
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
}

export interface GqlStripeBillingPortalSession {
  configuration: Scalars['String']['output'];
  created: Scalars['Float']['output'];
  customer: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  livemode: Scalars['Boolean']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  object: Scalars['String']['output'];
  on_behalf_of?: Maybe<Scalars['String']['output']>;
  return_url: Scalars['String']['output'];
  url: Scalars['String']['output'];
}

export interface GqlStripeCheckoutSession {
  after_expiration?: Maybe<Scalars['JSON']['output']>;
  allow_promotion_codes?: Maybe<Scalars['Boolean']['output']>;
  amount_subtotal?: Maybe<Scalars['Float']['output']>;
  amount_total?: Maybe<Scalars['Float']['output']>;
  billing_address_collection?: Maybe<Scalars['String']['output']>;
  cancel_url: Scalars['String']['output'];
  client_reference_id?: Maybe<Scalars['String']['output']>;
  consent?: Maybe<Scalars['JSON']['output']>;
  consent_collection?: Maybe<Scalars['JSON']['output']>;
  created: Scalars['Float']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  currency_conversion?: Maybe<Scalars['JSON']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  customer_creation?: Maybe<Scalars['String']['output']>;
  customer_details?: Maybe<Scalars['JSON']['output']>;
  customer_email?: Maybe<Scalars['String']['output']>;
  expires_at: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  line_items?: Maybe<Array<Scalars['JSON']['output']>>;
  livemode: Scalars['Boolean']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  mode: Scalars['String']['output'];
  object: Scalars['String']['output'];
  payment_intent?: Maybe<Scalars['String']['output']>;
  payment_link?: Maybe<Scalars['String']['output']>;
  payment_method_options?: Maybe<Scalars['JSON']['output']>;
  payment_method_types: Array<Scalars['String']['output']>;
  payment_status: Scalars['String']['output'];
  phone_number_collection?: Maybe<Scalars['JSON']['output']>;
  recovered_from?: Maybe<Scalars['String']['output']>;
  setup_intent?: Maybe<Scalars['String']['output']>;
  shipping_address_collection?: Maybe<Scalars['JSON']['output']>;
  shipping_options: Scalars['JSON']['output'];
  shipping_rate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  submit_type?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<Scalars['String']['output']>;
  success_url: Scalars['String']['output'];
  total_details?: Maybe<Scalars['JSON']['output']>;
  url?: Maybe<Scalars['String']['output']>;
}

export interface GqlStripeCoupon {
  amount_off?: Maybe<Scalars['Float']['output']>;
  applies_to?: Maybe<GqlStripeCouponAppliesTo>;
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  object: Scalars['String']['output'];
  percent_off?: Maybe<Scalars['Float']['output']>;
}

export interface GqlStripeCouponAppliesTo {
  products: Array<Scalars['String']['output']>;
}

export interface GqlStripeCreateSetupCheckoutSessionInput {
  cancelUrl: Scalars['String']['input'];
  successUrl: Scalars['String']['input'];
}

export interface GqlStripeCreateSubscriptionCheckoutSessionInput {
  cancelUrl: Scalars['String']['input'];
  price: Scalars['String']['input'];
  successUrl: Scalars['String']['input'];
}

export interface GqlStripeCustomer {
  address?: Maybe<GqlStripeAddress>;
  balance: Scalars['Float']['output'];
  created: Scalars['Float']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  default_source?: Maybe<Scalars['String']['output']>;
  delinquent?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['JSONObject']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoice_prefix?: Maybe<Scalars['String']['output']>;
  invoice_settings: GqlStripeCustomerInvoiceSettings;
  livemode: Scalars['Boolean']['output'];
  metadata: Scalars['JSONObject']['output'];
  name?: Maybe<Scalars['String']['output']>;
  next_invoice_sequence?: Maybe<Scalars['Float']['output']>;
  object: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  preferred_locales?: Maybe<Array<Scalars['String']['output']>>;
  shipping?: Maybe<Scalars['JSONObject']['output']>;
  sources?: Maybe<Scalars['JSONObject']['output']>;
  subscriptions?: Maybe<Scalars['JSONObject']['output']>;
  tax_exempt?: Maybe<Scalars['String']['output']>;
  tax_ids?: Maybe<Scalars['JSONObject']['output']>;
}

export interface GqlStripeCustomerInvoiceSettings {
  default_payment_method?: Maybe<Scalars['String']['output']>;
}

export interface GqlStripeDiscount {
  coupon: GqlStripeCoupon;
  customer?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  invoice?: Maybe<Scalars['String']['output']>;
  invoice_item?: Maybe<Scalars['String']['output']>;
  object: Scalars['String']['output'];
  promotion_code?: Maybe<Scalars['String']['output']>;
  start: Scalars['Float']['output'];
  subscription?: Maybe<Scalars['String']['output']>;
}

export interface GqlStripeInvoice {
  account_country?: Maybe<Scalars['String']['output']>;
  account_name?: Maybe<Scalars['String']['output']>;
  amount_due: Scalars['Float']['output'];
  amount_paid: Scalars['Float']['output'];
  amount_remaining: Scalars['Float']['output'];
  application?: Maybe<Scalars['String']['output']>;
  application_fee_amount?: Maybe<Scalars['Float']['output']>;
  attempt_count: Scalars['Float']['output'];
  attempted: Scalars['Boolean']['output'];
  auto_advance?: Maybe<Scalars['Boolean']['output']>;
  automatically_finalizes_at?: Maybe<Scalars['Float']['output']>;
  created: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  customer?: Maybe<Scalars['String']['output']>;
  customer_address?: Maybe<GqlStripeAddress>;
  customer_email?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_phone?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['Float']['output']>;
  effective_at?: Maybe<Scalars['Float']['output']>;
  ending_balance?: Maybe<Scalars['Float']['output']>;
  footer?: Maybe<Scalars['String']['output']>;
  hosted_invoice_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoice_pdf?: Maybe<Scalars['String']['output']>;
  last_finalization_error?: Maybe<Scalars['JSON']['output']>;
  lineItems: Array<GqlStripeInvoiceLineItem>;
  livemode: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  next_payment_attempt?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  object: Scalars['String']['output'];
  paid: Scalars['Boolean']['output'];
  paid_out_of_band: Scalars['Boolean']['output'];
  payment_intent?: Maybe<Scalars['String']['output']>;
  period_end: Scalars['Float']['output'];
  period_start: Scalars['Float']['output'];
  post_payment_credit_notes_amount: Scalars['Float']['output'];
  pre_payment_credit_notes_amount: Scalars['Float']['output'];
  quote?: Maybe<Scalars['String']['output']>;
  receipt_number?: Maybe<Scalars['String']['output']>;
  starting_balance: Scalars['Float']['output'];
  statement_descriptor?: Maybe<Scalars['String']['output']>;
  status?: Maybe<GqlStripeInvoiceStatus>;
  status_transitions: GqlStripeInvoiceStatusTransitions;
  subscription?: Maybe<Scalars['String']['output']>;
  subscription_proration_date?: Maybe<Scalars['Float']['output']>;
  subtotal: Scalars['Float']['output'];
  tax?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
  webhooks_delivered_at?: Maybe<Scalars['Float']['output']>;
}

export interface GqlStripeInvoiceLineItem {
  amount: Scalars['Float']['output'];
  amount_excluding_tax?: Maybe<Scalars['Float']['output']>;
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discount_amounts?: Maybe<Scalars['JSON']['output']>;
  discountable: Scalars['Boolean']['output'];
  discounts: Scalars['JSON']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  invoice?: Maybe<Scalars['String']['output']>;
  invoice_item?: Maybe<Scalars['String']['output']>;
  livemode: Scalars['Boolean']['output'];
  metadata: Scalars['JSON']['output'];
  object: Scalars['String']['output'];
  period: Scalars['JSON']['output'];
  plan?: Maybe<Scalars['JSON']['output']>;
  price?: Maybe<Scalars['JSON']['output']>;
  proration: Scalars['Boolean']['output'];
  proration_details?: Maybe<Scalars['JSON']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  subscription?: Maybe<Scalars['String']['output']>;
  subscription_item?: Maybe<Scalars['String']['output']>;
  tax_amounts?: Maybe<Scalars['JSON']['output']>;
  tax_rates?: Maybe<Scalars['JSON']['output']>;
  type: Scalars['String']['output'];
  unit_amount_excluding_tax?: Maybe<Scalars['String']['output']>;
}

export enum GqlStripeInvoiceStatus {
  Draft = 'draft',
  Open = 'open',
  Paid = 'paid',
  Uncollectible = 'uncollectible',
  Void = 'void'
}

export interface GqlStripeInvoiceStatusTransitions {
  finalized_at?: Maybe<Scalars['Int']['output']>;
  marked_uncollectible_at?: Maybe<Scalars['Int']['output']>;
  paid_at?: Maybe<Scalars['Int']['output']>;
  voided_at?: Maybe<Scalars['Int']['output']>;
}

export interface GqlStripeLineItem {
  amount_discount: Scalars['Float']['output'];
  amount_subtotal: Scalars['Float']['output'];
  amount_tax: Scalars['Float']['output'];
  amount_total: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  discounts?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  object: Scalars['String']['output'];
  price?: Maybe<GqlStripePrice>;
  quantity?: Maybe<Scalars['Float']['output']>;
  taxes?: Maybe<Scalars['JSON']['output']>;
}

export interface GqlStripeLineItemList {
  data: Array<GqlStripeLineItem>;
  has_more: Scalars['Boolean']['output'];
  object: Scalars['String']['output'];
  url: Scalars['String']['output'];
}

export interface GqlStripePaymentIntent {
  amount: Scalars['Float']['output'];
  amount_capturable: Scalars['Float']['output'];
  amount_details: Scalars['JSON']['output'];
  amount_received: Scalars['Float']['output'];
  application?: Maybe<Scalars['String']['output']>;
  application_fee_amount?: Maybe<Scalars['Float']['output']>;
  automatic_payment_methods?: Maybe<Scalars['JSON']['output']>;
  canceled_at?: Maybe<Scalars['Float']['output']>;
  cancellation_reason?: Maybe<Scalars['String']['output']>;
  capture_method: Scalars['String']['output'];
  client_secret: Scalars['String']['output'];
  confirmation_method: Scalars['String']['output'];
  created: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  customer: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoice?: Maybe<Scalars['String']['output']>;
  last_payment_error?: Maybe<Scalars['JSON']['output']>;
  latest_charge?: Maybe<Scalars['String']['output']>;
  metadata: Scalars['JSON']['output'];
  next_action?: Maybe<Scalars['JSON']['output']>;
  object: Scalars['String']['output'];
  on_behalf_of?: Maybe<Scalars['String']['output']>;
  payment_method?: Maybe<Scalars['String']['output']>;
  payment_method_options: Scalars['JSON']['output'];
  payment_method_types: Array<Scalars['String']['output']>;
  processing?: Maybe<Scalars['JSON']['output']>;
  receipt_email?: Maybe<Scalars['String']['output']>;
  review?: Maybe<Scalars['String']['output']>;
  setup_future_usage?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  statement_descriptor?: Maybe<Scalars['String']['output']>;
  statement_descriptor_suffix?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
}

export interface GqlStripePaymentMethod {
  billing_details: Scalars['JSON']['output'];
  card?: Maybe<GqlStripePmCard>;
  created: Scalars['Float']['output'];
  customer?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  link?: Maybe<GqlStripePmLink>;
  livemode: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  object: Scalars['String']['output'];
  type: Scalars['String']['output'];
}

export interface GqlStripePmCard {
  brand: Scalars['String']['output'];
  checks?: Maybe<Scalars['JSON']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_brand?: Maybe<Scalars['String']['output']>;
  exp_month: Scalars['Float']['output'];
  exp_year: Scalars['Float']['output'];
  fingerprint?: Maybe<Scalars['String']['output']>;
  funding: Scalars['String']['output'];
  iin?: Maybe<Scalars['String']['output']>;
  issuer?: Maybe<Scalars['String']['output']>;
  last4: Scalars['String']['output'];
  networks?: Maybe<Scalars['JSON']['output']>;
  three_d_secure_usage?: Maybe<Scalars['JSON']['output']>;
  wallet?: Maybe<Scalars['JSON']['output']>;
}

export interface GqlStripePmLink {
  email?: Maybe<Scalars['String']['output']>;
}

export interface GqlStripePrice {
  active: Scalars['Boolean']['output'];
  billing_scheme: Scalars['String']['output'];
  created: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  livemode: Scalars['Boolean']['output'];
  lookup_key?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  object: Scalars['String']['output'];
  product: Scalars['String']['output'];
  recurring?: Maybe<GqlStripePriceRecurring>;
  tax_behavior?: Maybe<Scalars['String']['output']>;
  tiers?: Maybe<Scalars['JSON']['output']>;
  tiers_mode?: Maybe<Scalars['String']['output']>;
  transform_quantity?: Maybe<Scalars['JSON']['output']>;
  type: Scalars['String']['output'];
  unit_amount?: Maybe<Scalars['Float']['output']>;
  unit_amount_decimal?: Maybe<Scalars['String']['output']>;
}

export interface GqlStripePriceRecurring {
  aggregate_usage?: Maybe<Scalars['String']['output']>;
  interval: GqlStripeRecurringInterval;
  interval_count: Scalars['Float']['output'];
  trial_period_days?: Maybe<Scalars['Int']['output']>;
  usage_type: Scalars['String']['output'];
}

export interface GqlStripeProduct {
  active: Scalars['Boolean']['output'];
  attributes?: Maybe<Scalars['JSON']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  created: Scalars['Float']['output'];
  deactivate_on?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images: Scalars['JSON']['output'];
  livemode: Scalars['Boolean']['output'];
  metadata: Scalars['JSON']['output'];
  name: Scalars['String']['output'];
  object: Scalars['String']['output'];
  package_dimensions?: Maybe<Scalars['JSON']['output']>;
  shippable?: Maybe<Scalars['Boolean']['output']>;
  statement_descriptor?: Maybe<Scalars['String']['output']>;
  tax_code?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  unit_label?: Maybe<Scalars['String']['output']>;
  updated: Scalars['Float']['output'];
  url?: Maybe<Scalars['String']['output']>;
}

export interface GqlStripePromotionCode {
  active: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  coupon: GqlStripeCoupon;
  id: Scalars['ID']['output'];
  object: Scalars['String']['output'];
}

export interface GqlStripeQuote {
  amount_subtotal: Scalars['Float']['output'];
  amount_total: Scalars['Float']['output'];
  application?: Maybe<Scalars['String']['output']>;
  application_fee_amount?: Maybe<Scalars['Float']['output']>;
  application_fee_percent?: Maybe<Scalars['Float']['output']>;
  collection_method: Scalars['String']['output'];
  computed: GqlQuoteComputed;
  created: Scalars['Float']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  default_tax_rates?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discounts: Scalars['JSON']['output'];
  expires_at: Scalars['Float']['output'];
  footer?: Maybe<Scalars['String']['output']>;
  from_quote?: Maybe<Scalars['JSON']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoice?: Maybe<Scalars['String']['output']>;
  invoice_settings: Scalars['JSON']['output'];
  line_items?: Maybe<GqlStripeLineItemList>;
  livemode: Scalars['Boolean']['output'];
  metadata: Scalars['JSON']['output'];
  number?: Maybe<Scalars['String']['output']>;
  object: Scalars['String']['output'];
  on_behalf_of?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  status_transitions: Scalars['JSON']['output'];
  subscription?: Maybe<Scalars['String']['output']>;
  subscription_data: Scalars['JSON']['output'];
  subscription_schedule?: Maybe<Scalars['String']['output']>;
  total_details: GqlQuoteTotalDetails;
  transfer_data?: Maybe<Scalars['JSON']['output']>;
}

export interface GqlStripeQuoteSetPromoInput {
  couponId: Scalars['String']['input'];
  quoteId: Scalars['String']['input'];
}

export enum GqlStripeRecurringInterval {
  Day = 'day',
  Month = 'month',
  Week = 'week',
  Year = 'year'
}

export interface GqlStripeSubscription {
  application: Scalars['String']['output'];
  application_fee_percent?: Maybe<Scalars['Float']['output']>;
  billing_cycle_anchor: Scalars['Float']['output'];
  billing_thresholds?: Maybe<Scalars['JSON']['output']>;
  cancel_at?: Maybe<Scalars['Float']['output']>;
  cancel_at_period_end: Scalars['Boolean']['output'];
  canceled_at?: Maybe<Scalars['Float']['output']>;
  collection_method: Scalars['String']['output'];
  created: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  current_period_end: Scalars['Float']['output'];
  current_period_start: Scalars['Float']['output'];
  customer: Scalars['String']['output'];
  days_until_due?: Maybe<Scalars['Float']['output']>;
  default_payment_method?: Maybe<Scalars['String']['output']>;
  default_source?: Maybe<Scalars['String']['output']>;
  default_tax_rates?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<GqlStripeDiscount>;
  ended_at?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  items: GqlStripeSubscriptionItems;
  latest_invoice?: Maybe<Scalars['String']['output']>;
  livemode: Scalars['Boolean']['output'];
  metadata: Scalars['JSON']['output'];
  next_pending_invoice_item_invoice?: Maybe<Scalars['Float']['output']>;
  object: Scalars['String']['output'];
  pause_collection?: Maybe<Scalars['JSON']['output']>;
  payment_settings?: Maybe<Scalars['JSON']['output']>;
  pending_invoice_item_interval?: Maybe<Scalars['JSON']['output']>;
  pending_setup_intent?: Maybe<Scalars['String']['output']>;
  pending_update?: Maybe<Scalars['JSON']['output']>;
  schedule?: Maybe<Scalars['String']['output']>;
  start_date: Scalars['Float']['output'];
  status: GqlStripeSubscriptionStatus;
  subscriptionItems: Array<GqlStripeSubscriptionItem>;
  transfer_data?: Maybe<Scalars['JSON']['output']>;
  trial_end?: Maybe<Scalars['Float']['output']>;
  trial_start?: Maybe<Scalars['Float']['output']>;
}

export interface GqlStripeSubscriptionItem {
  billing_thresholds?: Maybe<Scalars['JSON']['output']>;
  created: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  metadata: Scalars['JSON']['output'];
  object: Scalars['String']['output'];
  plan: Scalars['JSON']['output'];
  price: GqlStripePrice;
  quantity?: Maybe<Scalars['JSON']['output']>;
  subscription: Scalars['JSON']['output'];
  tax_rates?: Maybe<Scalars['JSON']['output']>;
}

export interface GqlStripeSubscriptionItems {
  data: Array<GqlStripeSubscriptionItem>;
  has_more: Scalars['Boolean']['output'];
  url: Scalars['String']['output'];
}

export enum GqlStripeSubscriptionStatus {
  Active = 'active',
  Canceled = 'canceled',
  Incomplete = 'incomplete',
  IncompleteExpired = 'incomplete_expired',
  PastDue = 'past_due',
  Paused = 'paused',
  Trialing = 'trialing',
  Unpaid = 'unpaid'
}

export interface GqlStripeUpcomingInvoice {
  account_country?: Maybe<Scalars['String']['output']>;
  account_name?: Maybe<Scalars['String']['output']>;
  amount_due: Scalars['Float']['output'];
  amount_paid: Scalars['Float']['output'];
  amount_remaining: Scalars['Float']['output'];
  application?: Maybe<Scalars['String']['output']>;
  application_fee_amount?: Maybe<Scalars['Float']['output']>;
  attempt_count: Scalars['Float']['output'];
  attempted: Scalars['Boolean']['output'];
  auto_advance?: Maybe<Scalars['Boolean']['output']>;
  automatically_finalizes_at?: Maybe<Scalars['Float']['output']>;
  created: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  customer?: Maybe<Scalars['String']['output']>;
  customer_address?: Maybe<GqlStripeAddress>;
  customer_email?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_phone?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['Float']['output']>;
  effective_at?: Maybe<Scalars['Float']['output']>;
  ending_balance?: Maybe<Scalars['Float']['output']>;
  footer?: Maybe<Scalars['String']['output']>;
  hosted_invoice_url?: Maybe<Scalars['String']['output']>;
  invoice_pdf?: Maybe<Scalars['String']['output']>;
  last_finalization_error?: Maybe<Scalars['JSON']['output']>;
  lineItems: Array<GqlStripeInvoiceLineItem>;
  livemode: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  next_payment_attempt?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  object: Scalars['String']['output'];
  paid: Scalars['Boolean']['output'];
  paid_out_of_band: Scalars['Boolean']['output'];
  period_end: Scalars['Float']['output'];
  period_start: Scalars['Float']['output'];
  post_payment_credit_notes_amount: Scalars['Float']['output'];
  pre_payment_credit_notes_amount: Scalars['Float']['output'];
  quote?: Maybe<Scalars['String']['output']>;
  receipt_number?: Maybe<Scalars['String']['output']>;
  starting_balance: Scalars['Float']['output'];
  statement_descriptor?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  status_transitions: Scalars['JSON']['output'];
  subscription?: Maybe<Scalars['String']['output']>;
  subscription_proration_date?: Maybe<Scalars['Float']['output']>;
  subtotal: Scalars['Float']['output'];
  tax?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
  webhooks_delivered_at?: Maybe<Scalars['Float']['output']>;
}

export interface GqlStsMutationResponse {
  awaitingConfirmation?: Maybe<Scalars['Boolean']['output']>;
  createdSts: Array<GqlShareTransaction>;
  deletedIds: Array<Scalars['ID']['output']>;
  deletedStgs?: Maybe<Array<GqlStgDeletedResponse>>;
  stgs?: Maybe<Array<GqlShareTransactionGroup>>;
  updatedSts: Array<GqlShareTransaction>;
}

export interface GqlSubscription {
  fileUpdated: GqlBolagoFile;
  meetingParticipantUpdated: GqlMeetingParticipant;
}


export interface GqlSubscriptionFileUpdatedArgs {
  channel: Scalars['String']['input'];
}


export interface GqlSubscriptionMeetingParticipantUpdatedArgs {
  channel: Scalars['String']['input'];
}

export interface GqlSutSubscription {
  activeProduct?: Maybe<GqlStripeProduct>;
  canUseProFeature: Scalars['Boolean']['output'];
  companyId: GqlCompany;
  isActive: Scalars['Boolean']['output'];
  stripeSub?: Maybe<GqlStripeSubscription>;
}

export interface GqlTodo {
  createdAt: Scalars['Date']['output'];
  descriptionPrimaryLang?: Maybe<Scalars['String']['output']>;
  descriptionSecondaryLang?: Maybe<Scalars['String']['output']>;
  done: Scalars['Boolean']['output'];
  dueDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  identity?: Maybe<GqlIdentity>;
  identityId?: Maybe<Scalars['ID']['output']>;
  meetingTodo: GqlMeetingTodo;
  updatedAt: Scalars['Date']['output'];
}

/** Create todo */
export interface GqlTodoCreateInput {
  descriptionPrimaryLang?: InputMaybe<Scalars['String']['input']>;
  descriptionSecondaryLang?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  identityId?: InputMaybe<Scalars['ID']['input']>;
}

/** todo set done */
export interface GqlTodoSetDoneInput {
  done: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
}

/** Update todo */
export interface GqlTodoUpdateInput {
  descriptionPrimaryLang?: InputMaybe<Scalars['String']['input']>;
  descriptionSecondaryLang?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  identityId?: InputMaybe<Scalars['ID']['input']>;
}

export enum GqlTransactionKind {
  BlockPartition = 'BlockPartition',
  CurrencyChange = 'CurrencyChange',
  Issue = 'Issue',
  Merge = 'Merge',
  ShareClassConvert = 'ShareClassConvert',
  Split = 'Split',
  Transfer = 'Transfer',
  Unissue = 'Unissue'
}

export interface GqlUpdateCapTableInput {
  displayName?: InputMaybe<Scalars['String']['input']>;
  fullyDiluted?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  pricePerShare?: InputMaybe<Scalars['String']['input']>;
  recordDate?: InputMaybe<Scalars['Date']['input']>;
  unregisteredShares?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlUpdateFileInput {
  id: Scalars['ID']['input'];
  sharedWithShareholders?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface GqlUpdateIdentityInput {
  address?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlUpdateRegistrationTodoItem {
  completed: Scalars['Boolean']['input'];
  kind: GqlRegistrationTodoItemKind;
  optionsRegistrationId?: InputMaybe<Scalars['ID']['input']>;
  optionsSharesRegistrationId?: InputMaybe<Scalars['ID']['input']>;
  shareRegistrationId?: InputMaybe<Scalars['ID']['input']>;
}

export interface GqlUser {
  admin: Scalars['Boolean']['output'];
  communicationLanguage: Scalars['String']['output'];
  companyLimit?: Maybe<Scalars['Int']['output']>;
  companySuggestionsSyncedDate?: Maybe<Scalars['Date']['output']>;
  companyUsers: Array<GqlCompanyUser>;
  createdAt: Scalars['Date']['output'];
  currentSignInAt?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailMd5?: Maybe<Scalars['String']['output']>;
  featurePreferences: GqlUserFeaturePreferences;
  hubspotObjectId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identities: Array<GqlIdentity>;
  jwtEpoch: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  personalId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  referralSource?: Maybe<GqlReferralSource>;
  referralSourceOther?: Maybe<Scalars['String']['output']>;
  signInCount: Scalars['Int']['output'];
  unconfirmedEmail?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
}

export interface GqlUserFeaturePreferences {
  allowDocumentsBeta?: Maybe<Scalars['Boolean']['output']>;
  documentBannerDismissed?: Maybe<Scalars['Boolean']['output']>;
  documents?: Maybe<Scalars['Boolean']['output']>;
}

export interface GqlUserSendPromoInviteInput {
  email: Scalars['String']['input'];
  english: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  promoCode: Scalars['String']['input'];
}

export interface GqlUserSetContactDetailsInput {
  communicationLanguage: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  referralSource?: InputMaybe<GqlReferralSource>;
  referralSourceOther?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlValidatorError {
  long?: Maybe<Scalars['String']['output']>;
  short?: Maybe<Scalars['String']['output']>;
}

export interface GqlValidatorMultilangError {
  en: GqlValidatorError;
  sv: GqlValidatorError;
}

export interface GqlValidatorStatus {
  completed: Scalars['Boolean']['output'];
  error?: Maybe<GqlValidatorMultilangError>;
  hasError: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  severity: GqlSeverity;
}

export enum GqlValuationMethod {
  Assets = 'Assets',
  Issue = 'Issue',
  ManualIssue = 'ManualIssue',
  Other = 'Other'
}

export interface GqlVestedAndAllocated {
  allocated: Scalars['String']['output'];
  identity: GqlIdentity;
  shareClass: GqlShareClass;
  subscribable: Scalars['String']['output'];
  total: Scalars['String']['output'];
  vested: Scalars['String']['output'];
}

export enum GqlVestingOccasionStatus {
  ToVest = 'TO_VEST',
  Vested = 'VESTED',
  WontVest = 'WONT_VEST'
}

export enum GqlVestingStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Ongoing = 'ONGOING',
  Pending = 'PENDING'
}

export interface GqlWarrantBoardMember {
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  identity: GqlIdentity;
  identityId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
  warrantProgram: GqlWarrantProgram;
  warrantProgramId: Scalars['ID']['output'];
}

export interface GqlWarrantDocument {
  createdAt: Scalars['Date']['output'];
  file: GqlBolagoFile;
  fileId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
  warrantProgram: GqlWarrantProgram;
  warrantProgramId: Scalars['ID']['output'];
}

export interface GqlWarrantParticipant {
  claim?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  customVestingFullyConfigured: Scalars['Boolean']['output'];
  forcedRedemption: Scalars['Boolean']['output'];
  forcedSaleAtIpo: Scalars['Boolean']['output'];
  hasDatelessVesting: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  identity: GqlIdentity;
  identityId: Scalars['ID']['output'];
  latestAgreementDoc?: Maybe<GqlBolagoFile>;
  leaveOfAbsence: Scalars['Boolean']['output'];
  leaveOfAbsenceDays: Scalars['Int']['output'];
  optionsRegistration: GqlOptionsRegistration;
  optionsRegistrationId: Scalars['ID']['output'];
  paidForAccess: Scalars['Boolean']['output'];
  paymentKind: Scalars['Int']['output'];
  paymentStatus: Scalars['Int']['output'];
  quantity?: Maybe<Scalars['String']['output']>;
  quantityInvalidated?: Maybe<Scalars['String']['output']>;
  quantityLeft: Scalars['String']['output'];
  quantityRepurchased: Scalars['String']['output'];
  representatives: Array<GqlOptionsSubscriberRepresentative>;
  repurchaseVested: Scalars['Boolean']['output'];
  shareClass: GqlShareClass;
  splitFactor: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  vestedPercentage: Scalars['String']['output'];
  vestedQuantity: Scalars['String']['output'];
  vestedQuantityOnEndDate?: Maybe<Scalars['String']['output']>;
  vestingAcceleration: Scalars['Boolean']['output'];
  vestingCliffDuration: Scalars['Int']['output'];
  vestingCustomKindPrimaryLang?: Maybe<Scalars['String']['output']>;
  vestingCustomKindSecondaryLang?: Maybe<Scalars['String']['output']>;
  vestingDuration: Scalars['Int']['output'];
  vestingEndDate?: Maybe<Scalars['Date']['output']>;
  vestingExplanationPrimaryLang?: Maybe<Scalars['String']['output']>;
  vestingExplanationSecondaryLang?: Maybe<Scalars['String']['output']>;
  vestingFrequency: Scalars['Int']['output'];
  vestingKind: Scalars['Int']['output'];
  vestingLastPotentialDate?: Maybe<Scalars['Date']['output']>;
  vestingOccasions: Array<GqlWarrantParticipantVestingOccasion>;
  vestingStatus: GqlVestingStatus;
  wontVestQuantity?: Maybe<Scalars['String']['output']>;
}


export interface GqlWarrantParticipantVestedQuantityArgs {
  date?: InputMaybe<Scalars['Date']['input']>;
  includeAfterEndDate?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface GqlWarrantParticipantVestingOccasion {
  descriptionPrimaryLang?: Maybe<Scalars['String']['output']>;
  descriptionSecondaryLang?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isValid: Scalars['Boolean']['output'];
  quantity: Scalars['String']['output'];
  requirementPrimaryLang?: Maybe<Scalars['String']['output']>;
  requirementSecondaryLang?: Maybe<Scalars['String']['output']>;
  sortOrder: Scalars['Int']['output'];
  status: GqlVestingOccasionStatus;
  totalVested?: Maybe<Scalars['String']['output']>;
  vestingDate?: Maybe<Scalars['Date']['output']>;
  warrantParticipantId: Scalars['ID']['output'];
}

export interface GqlWarrantProgram {
  agreementStatus: GqlAgreementStatus;
  allocated: Scalars['String']['output'];
  antlerWise: Scalars['Boolean']['output'];
  archived: Scalars['Boolean']['output'];
  articlesOfAssoc?: Maybe<GqlArticlesOfAssoc>;
  boardsStatementDate?: Maybe<Scalars['Date']['output']>;
  boardsStatementEn?: Maybe<Scalars['String']['output']>;
  boardsStatementOption?: Maybe<GqlBoardsStatementOption>;
  boardsStatementSv?: Maybe<Scalars['String']['output']>;
  company: GqlCompany;
  companyId: Scalars['ID']['output'];
  contact?: Maybe<GqlIdentity>;
  createdAt: Scalars['Date']['output'];
  currency: GqlCurrency;
  decisionDate?: Maybe<Scalars['Date']['output']>;
  decisionStatus: GqlDecisionStatus;
  deletable: GqlDeletable;
  description: Scalars['String']['output'];
  discountPricePerWarrant?: Maybe<Scalars['String']['output']>;
  forAdvisors?: Maybe<Scalars['Boolean']['output']>;
  forBoardMembers: Scalars['Boolean']['output'];
  forEmployees: Scalars['Boolean']['output'];
  forInvestors: Scalars['Boolean']['output'];
  ibanAddress?: Maybe<Scalars['String']['output']>;
  ibanBank?: Maybe<Scalars['String']['output']>;
  ibanBic?: Maybe<Scalars['String']['output']>;
  ibanNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  illiquidityDiscount?: Maybe<Scalars['String']['output']>;
  latestAuditorStatement?: Maybe<GqlBolagoFile>;
  latestAuditorStatementNonCash?: Maybe<GqlBolagoFile>;
  latestAuditorStatementOffset?: Maybe<GqlBolagoFile>;
  maxNumberOfOptions?: Maybe<Scalars['String']['output']>;
  meetingConcern?: Maybe<GqlMeetingConcern>;
  minRoundSizeAmount?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  niceFounders: Array<GqlNiceFounder>;
  nonCashStatementPl?: Maybe<Scalars['String']['output']>;
  nonCashStatementSl?: Maybe<Scalars['String']['output']>;
  optionsRegistrations: Array<GqlOptionsRegistration>;
  optionsSharesRegistrations: Array<GqlOptionsSharesRegistration>;
  otherIncreasesOfShares: Scalars['String']['output'];
  paidForAt?: Maybe<Scalars['Date']['output']>;
  payBeforeDate?: Maybe<Scalars['Date']['output']>;
  paymentAccountKind: GqlPaymentAccountKind;
  paymentAccountNumber?: Maybe<Scalars['String']['output']>;
  paymentKindCash: Scalars['Boolean']['output'];
  paymentKindNonCash: Scalars['Boolean']['output'];
  paymentKindOffset: Scalars['Boolean']['output'];
  paymentMethodsCount: GqlWpPaymentMethodsCountResponse;
  paymentName?: Maybe<Scalars['String']['output']>;
  pricePerWarrant?: Maybe<Scalars['String']['output']>;
  primaryLang: Scalars['Boolean']['output'];
  registrationStatus: GqlRegistrationStatus;
  requiresShareLimitChange: Scalars['Boolean']['output'];
  riksbankenRates?: Maybe<Array<GqlRiksbankenObservations>>;
  riskfreeInterestRate?: Maybe<Scalars['String']['output']>;
  secondaryLang: Scalars['Boolean']['output'];
  serviceKind?: Maybe<Scalars['Int']['output']>;
  shareClasses: Array<GqlShareClassWithMinMax>;
  shareSubscribeEndDate?: Maybe<Scalars['Date']['output']>;
  shareSubscribeStartDate?: Maybe<Scalars['Date']['output']>;
  shareholdersAgreementKind?: Maybe<Scalars['Int']['output']>;
  signatory?: Maybe<GqlIdentity>;
  signatoryId?: Maybe<Scalars['String']['output']>;
  snrAuthorization?: Maybe<GqlSnrAuthorization>;
  snrAuthorizationId?: Maybe<Scalars['String']['output']>;
  snrBond?: Maybe<GqlSnrBond>;
  snrBondId?: Maybe<Scalars['String']['output']>;
  snrCaseId?: Maybe<Scalars['String']['output']>;
  strikePrice?: Maybe<Scalars['String']['output']>;
  strikePriceFromQuotaValue?: Maybe<Scalars['Boolean']['output']>;
  stripeInvoiceId?: Maybe<Scalars['String']['output']>;
  subscriberAccess: Scalars['Boolean']['output'];
  updatedAt: Scalars['Date']['output'];
  useNetStrike: Scalars['Boolean']['output'];
  useRiksbankenRate?: Maybe<Scalars['Boolean']['output']>;
  usesStepper: Scalars['Boolean']['output'];
  validatorErrors?: Maybe<GqlWpValidatorErrors>;
  valuationCompanyValue?: Maybe<Scalars['String']['output']>;
  valuationDate?: Maybe<Scalars['Date']['output']>;
  valuationMethod?: Maybe<GqlValuationMethod>;
  valuationNumberOfShares?: Maybe<Scalars['String']['output']>;
  valuationSccId?: Maybe<Scalars['ID']['output']>;
  valuationShareIssueId?: Maybe<Scalars['ID']['output']>;
  volatility?: Maybe<Scalars['String']['output']>;
  volatilityDate?: Maybe<Scalars['Date']['output']>;
  volatilityDocument?: Maybe<Scalars['String']['output']>;
  warrantBoardMembers: Array<GqlWarrantBoardMember>;
  warrantDocuments: Array<GqlWarrantDocument>;
  warrantEndDate?: Maybe<Scalars['Date']['output']>;
  warrantKind: GqlWarrantProgramKind;
  warrantShareholders: Array<GqlWarrantShareholder>;
  warrantStartDate?: Maybe<Scalars['Date']['output']>;
  warrantSubscribeEndDate?: Maybe<Scalars['Date']['output']>;
  warrantsForQeso: Scalars['Boolean']['output'];
  wiseCeil?: Maybe<Scalars['String']['output']>;
  wiseDepBondsRecordDay?: Maybe<Scalars['Date']['output']>;
  wiseDependencyBonds: Array<GqlWiseDependencyBond>;
  wiseFloor?: Maybe<Scalars['String']['output']>;
  wiseFullyDiluted?: Maybe<Scalars['Boolean']['output']>;
}

/** Kind of warrant program */
export enum GqlWarrantProgramKind {
  Employee = 'Employee',
  Nice = 'Nice',
  Warrant = 'Warrant',
  Wise = 'Wise'
}

export interface GqlWarrantProgramsPagedResult {
  filteredCount: Scalars['Int']['output'];
  models: Array<GqlWarrantProgram>;
  totalCount: Scalars['Int']['output'];
}

export interface GqlWarrantShareholder {
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  numberOfShares: Scalars['Int']['output'];
  proxy?: Maybe<GqlIdentity>;
  proxyId?: Maybe<Scalars['ID']['output']>;
  shareholder: GqlShareholder;
  shareholderId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
  warrantProgram: GqlWarrantProgram;
  warrantProgramId: Scalars['ID']['output'];
}

export interface GqlWdbCreateInput {
  kind: Scalars['String']['input'];
  name: Scalars['String']['input'];
  numberOfOptions: Scalars['String']['input'];
  warrantProgramId: Scalars['ID']['input'];
}

export interface GqlWdbDeletedResponse {
  id: Scalars['ID']['output'];
  warrantProgram: GqlWarrantProgram;
}

export interface GqlWdbEditInput {
  id: Scalars['ID']['input'];
  kind: Scalars['String']['input'];
  name: Scalars['String']['input'];
  numberOfOptions: Scalars['String']['input'];
}

export interface GqlWdbResetResponse {
  deletedIds: Array<Scalars['ID']['output']>;
  warrantProgram: GqlWarrantProgram;
  wiseDebendencyBonds: Array<GqlWiseDependencyBond>;
}

export interface GqlWiseDependencyBond {
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  name: Scalars['String']['output'];
  numberOfOptions: Scalars['String']['output'];
  snrBondId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['Date']['output'];
  warrantProgram: GqlWarrantProgram;
  warrantProgramId: Scalars['ID']['output'];
}

export interface GqlWiseValidatorErrors {
  auditorsStatement: GqlValidatorStatus;
  boardsStatement: GqlValidatorStatus;
  convertiblePrice: GqlValidatorStatus;
  dates: GqlValidatorStatus;
  dilution: GqlValidatorStatus;
  duration: GqlValidatorStatus;
  language: GqlValidatorStatus;
  meeting: GqlValidatorStatus;
  nonCash: GqlValidatorStatus;
  payByOffset: GqlValidatorStatus;
  paymentKind: GqlValidatorStatus;
  recordDay: GqlValidatorStatus;
}

export interface GqlWpConnectAuthorizationInput {
  id: Scalars['ID']['input'];
  snrAuthorizationId: Scalars['ID']['input'];
}

/** Connect meeting */
export interface GqlWpConnectMeetingInput {
  id: Scalars['ID']['input'];
  meetingId: Scalars['ID']['input'];
  snrAuthorizationId?: InputMaybe<Scalars['ID']['input']>;
}

export interface GqlWpConnectMeetingResponse {
  aiSetDoneResponse?: Maybe<GqlAiSetDoneResponse>;
  warrantProgram: GqlWarrantProgram;
}

/** Create warrant program */
export interface GqlWpCreateInput {
  antlerWise: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  discountPricePerWarrant: Scalars['String']['input'];
  illiquidityDiscount: Scalars['String']['input'];
  paymentAccountKind: GqlPaymentAccountKind;
  primaryLang: Scalars['Boolean']['input'];
  secondaryLang: Scalars['Boolean']['input'];
  shareClasses: Array<GqlShareClassWithMinMaxInput>;
  useRiksbankenRate: Scalars['Boolean']['input'];
  usesStepper?: InputMaybe<Scalars['Boolean']['input']>;
  warrantKind: GqlWarrantProgramKind;
  warrantsForQeso: Scalars['Boolean']['input'];
}

/** Create and connect meeting */
export interface GqlWpCreateMeetingInput {
  id: Scalars['ID']['input'];
  meetingCreate: GqlMeetingCreateInput;
  snrAuthorizationId?: InputMaybe<Scalars['ID']['input']>;
}

export interface GqlWpDeletedResponse {
  aiDeletedResponses?: Maybe<Array<GqlAiDeletedResponse>>;
  aiSetDoneResponse?: Maybe<GqlAiSetDoneResponse>;
  id: Scalars['ID']['output'];
  mcDeletedResponse?: Maybe<GqlMcDeletedResponse>;
  orDeletedResponses: Array<GqlOrDeletedResponse>;
  osrDeletedResponses: Array<GqlOsrDeletedResponse>;
}

/** Disconnect authorization, will also disconnect meeting if there is one connected */
export interface GqlWpDisconnectAuthorizationInput {
  id: Scalars['ID']['input'];
}

/** Disconnect meeting */
export interface GqlWpDisconnectMeetingInput {
  id: Scalars['ID']['input'];
}

export interface GqlWpDisconnectMeetingResponse {
  aiDeletedResponses?: Maybe<Array<GqlAiDeletedResponse>>;
  aiSetDoneResponse?: Maybe<GqlAiSetDoneResponse>;
  mcDeletedResponse?: Maybe<GqlMcDeletedResponse>;
  warrantProgram: GqlWarrantProgram;
}

/** Create warrant program from snr bond */
export interface GqlWpFromSnrBondInput {
  description: Scalars['String']['input'];
  snrBondId: Scalars['ID']['input'];
}

export interface GqlWpOptionsLeftInput {
  id: Scalars['ID']['input'];
  shareClassName: Scalars['String']['input'];
}

export interface GqlWpPaymentMethodsCountResponse {
  cash: Scalars['Float']['output'];
  nonCash: Scalars['Float']['output'];
  offset: Scalars['Float']['output'];
}

/** Set wpp boards statement */
export interface GqlWpSetBoardsStatementInput {
  boardsStatementDate?: InputMaybe<Scalars['Date']['input']>;
  boardsStatementEn?: InputMaybe<Scalars['String']['input']>;
  boardsStatementOption: GqlBoardsStatementOption;
  boardsStatementSv?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
}

export interface GqlWpSetBoardsStatementResponse {
  aiSetDoneResponse?: Maybe<GqlAiSetDoneResponse>;
  warrantProgram: GqlWarrantProgram;
}

/** Set wp dates */
export interface GqlWpSetDatesInput {
  duration: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  payBeforeDate?: InputMaybe<Scalars['Date']['input']>;
  shareSubscribeEndDate: Scalars['Date']['input'];
  shareSubscribeStartDate?: InputMaybe<Scalars['Date']['input']>;
  warrantStartDate: Scalars['Date']['input'];
  warrantSubscribeEndDate?: InputMaybe<Scalars['Date']['input']>;
}

/** Set wpp description */
export interface GqlWpSetDescriptionInput {
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
}

/** Set wp languages */
export interface GqlWpSetLanguageInput {
  id: Scalars['ID']['input'];
  primaryLang: Scalars['Boolean']['input'];
  secondaryLang: Scalars['Boolean']['input'];
}

/** Set max number of options */
export interface GqlWpSetMaxNumberOfOptionsInput {
  id: Scalars['ID']['input'];
  maxNumberOfOptions: Scalars['String']['input'];
}

export interface GqlWpSetNicePriceInput {
  id: Scalars['ID']['input'];
  illiquidityDiscount: Scalars['String']['input'];
  maxNumberOfOptions: Scalars['String']['input'];
  minRoundSizeAmount?: InputMaybe<Scalars['String']['input']>;
  pricePerWarrant: Scalars['String']['input'];
  wiseCeil: Scalars['String']['input'];
  wiseFloor: Scalars['String']['input'];
}

/** Set non cash statement */
export interface GqlWpSetNonCashStatementInput {
  id: Scalars['ID']['input'];
  nonCashStatementPl?: InputMaybe<Scalars['String']['input']>;
  nonCashStatementSl?: InputMaybe<Scalars['String']['input']>;
  paymentKind?: InputMaybe<Scalars['Int']['input']>;
}

export interface GqlWpSetNumberOfSharesInput {
  id: Scalars['ID']['input'];
  valuationNumberOfShares: Scalars['String']['input'];
}

/** Set wp payment kind */
export interface GqlWpSetPaymentKindInput {
  id: Scalars['ID']['input'];
  paymentKindCash: Scalars['Boolean']['input'];
  paymentKindNonCash: Scalars['Boolean']['input'];
  paymentKindOffset: Scalars['Boolean']['input'];
}

export interface GqlWpSetPaymentKindResponse {
  documents: Array<GqlBolagoFile>;
  orDeletedResponses: Array<GqlOrDeletedResponse>;
  warrantProgram: GqlWarrantProgram;
  wppDeletedResponses: Array<GqlWppDeletedResponse>;
}

/** Set wp price per warrant and other values from playground */
export interface GqlWpSetPlaygroundInput {
  duration: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  illiquidityDiscount: Scalars['String']['input'];
  pricePerWarrant: Scalars['String']['input'];
  riskfreeInterestRate: Scalars['String']['input'];
  strikePrice: Scalars['String']['input'];
  useRiksbankenRate: Scalars['Boolean']['input'];
  volatility: Scalars['String']['input'];
}

export interface GqlWpSetReasonInput {
  forAdvisors: Scalars['Boolean']['input'];
  forBoardMembers: Scalars['Boolean']['input'];
  forEmployees: Scalars['Boolean']['input'];
  forInvestors: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
}

/** Set wp strike price */
export interface GqlWpSetStrikePriceInput {
  id: Scalars['ID']['input'];
  strikePrice: Scalars['String']['input'];
  strikePriceFromQuotaValue?: InputMaybe<Scalars['Boolean']['input']>;
  useNetStrike: Scalars['Boolean']['input'];
}

/** Set wp valuation */
export interface GqlWpSetValuationInput {
  id: Scalars['ID']['input'];
  valuationCompanyValue: Scalars['String']['input'];
  valuationDate: Scalars['Date']['input'];
  valuationMethod: GqlValuationMethod;
  valuationNumberOfShares: Scalars['String']['input'];
  valuationSccId?: InputMaybe<Scalars['ID']['input']>;
  valuationShareIssueId?: InputMaybe<Scalars['ID']['input']>;
}

/** Set wp strike price */
export interface GqlWpSetVolatilityInput {
  id: Scalars['ID']['input'];
  volatility: Scalars['String']['input'];
}

export interface GqlWpSetWiseFullyDilutedInput {
  id: Scalars['ID']['input'];
  wiseFullyDiluted: Scalars['Boolean']['input'];
}

export interface GqlWpSetWisePriceInput {
  currency: GqlCurrency;
  id: Scalars['ID']['input'];
  illiquidityDiscount: Scalars['String']['input'];
  maxNumberOfOptions: Scalars['String']['input'];
  pricePerWarrant: Scalars['String']['input'];
  wiseCeil: Scalars['String']['input'];
  wiseFloor: Scalars['String']['input'];
}

export interface GqlWpSetWiseRecordDayInput {
  id: Scalars['ID']['input'];
  wiseDepBondsRecordDay: Scalars['Date']['input'];
}

/** update wp */
export interface GqlWpUpdateInput {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  subscriberAccess?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface GqlWpValidatorErrors {
  auditorsStatement: GqlValidatorStatus;
  boardsStatement: GqlValidatorStatus;
  dates: GqlValidatorStatus;
  duration: GqlValidatorStatus;
  language: GqlValidatorStatus;
  maxNumberOfOptions: GqlValidatorStatus;
  meeting: GqlValidatorStatus;
  nonCash: GqlValidatorStatus;
  payByOffset: GqlValidatorStatus;
  paymentKind: GqlValidatorStatus;
  playground: GqlValidatorStatus;
  shareClasses: GqlValidatorStatus;
  strikePrice: GqlValidatorStatus;
  valuation: GqlValidatorStatus;
  volatility: GqlValidatorStatus;
}

/** Set wp start date */
export interface GqlWpaSetDurationInput {
  id: Scalars['ID']['input'];
  warrantEndDate: Scalars['Date']['input'];
  warrantStartDate: Scalars['Date']['input'];
}

/** Create share issue participant */
export interface GqlWpbmCreateInput {
  identityInput: GqlCreateIdentityInput;
  warrantProgramId: Scalars['ID']['input'];
}

export interface GqlWpbmDeletedResponse {
  id: Scalars['ID']['output'];
}

/** Create warrant participant */
export interface GqlWppCreateInput {
  claim?: InputMaybe<Scalars['String']['input']>;
  identityInput: GqlCreateIdentityInput;
  optionsRegistrationId: Scalars['ID']['input'];
  paymentKind: Scalars['Int']['input'];
  quantity?: InputMaybe<Scalars['String']['input']>;
  shareClass: GqlShareClassInput;
}

export interface GqlWppDefaults {
  companyId: Scalars['ID']['output'];
  forcedRedemption: Scalars['Boolean']['output'];
  forcedSaleAtIpo: Scalars['Boolean']['output'];
  leaveOfAbsence: Scalars['Boolean']['output'];
  leaveOfAbsenceDays: Scalars['Int']['output'];
  repurchaseVested: Scalars['Boolean']['output'];
  vestingAcceleration: Scalars['Boolean']['output'];
  vestingCliffDuration: Scalars['Int']['output'];
  vestingDuration: Scalars['Int']['output'];
  vestingFrequency: Scalars['Int']['output'];
  vestingKind: Scalars['Int']['output'];
}

/** Delete warrant participant response */
export interface GqlWppDeletedResponse {
  documents: Array<GqlBolagoFile>;
  id: Scalars['ID']['output'];
  osrDeletedResponses: Array<GqlOptionsSubscriberRepresentativeDeletedResponse>;
}

export interface GqlWppPagedResult {
  models: Array<GqlWarrantParticipant>;
  totalCount: Scalars['Int']['output'];
}

/** Sort warrant participants */
export interface GqlWppSort {
  direction: GqlSortOrder;
  field: Scalars['String']['input'];
}

export interface GqlWppUpdateInput {
  claim?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  forcedRedemption?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  identityInput?: InputMaybe<GqlCreateIdentityInput>;
  leaveOfAbsence?: InputMaybe<Scalars['Boolean']['input']>;
  leaveOfAbsenceDays?: InputMaybe<Scalars['Int']['input']>;
  paymentStatus?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  quantityInvalidated?: InputMaybe<Scalars['String']['input']>;
  quantityRepurchased?: InputMaybe<Scalars['String']['input']>;
  repurchaseVested?: InputMaybe<Scalars['Boolean']['input']>;
  shareClass?: InputMaybe<GqlShareClassInput>;
  vestingAcceleration?: InputMaybe<Scalars['Boolean']['input']>;
  vestingCliffDuration?: InputMaybe<Scalars['Int']['input']>;
  vestingCustomKindPrimaryLang?: InputMaybe<Scalars['String']['input']>;
  vestingCustomKindSecondaryLang?: InputMaybe<Scalars['String']['input']>;
  vestingDuration?: InputMaybe<Scalars['Int']['input']>;
  vestingEndDate?: InputMaybe<Scalars['Date']['input']>;
  vestingFrequency?: InputMaybe<Scalars['Int']['input']>;
  vestingKind?: InputMaybe<Scalars['Int']['input']>;
}

/** Update warrant participant response */
export interface GqlWppUpdateResponse {
  documents: Array<GqlBolagoFile>;
  warrantParticipant: GqlWarrantParticipant;
}

export interface GqlWppValidatorErrors {
  cliff: GqlValidatorStatus;
  paymentStatus: GqlValidatorStatus;
  proxy: GqlValidatorStatus;
}

/** Create vesting occassion */
export interface GqlWppVestingOccasionCreateInput {
  descriptionPrimaryLang: Scalars['String']['input'];
  descriptionSecondaryLang: Scalars['String']['input'];
  quantity: Scalars['String']['input'];
  requirementPrimaryLang: Scalars['String']['input'];
  requirementSecondaryLang: Scalars['String']['input'];
  sortOrder: Scalars['Int']['input'];
  vestingDate?: InputMaybe<Scalars['Date']['input']>;
  warrantParticipantId: Scalars['ID']['input'];
}

export interface GqlWppVestingOccasionUpdateInput {
  descriptionPrimaryLang?: InputMaybe<Scalars['String']['input']>;
  descriptionSecondaryLang?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['String']['input']>;
  requirementPrimaryLang?: InputMaybe<Scalars['String']['input']>;
  requirementSecondaryLang?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  vestingDate?: InputMaybe<Scalars['Date']['input']>;
}

/** Create warrant participant */
export interface GqlWshCreateInput {
  numberOfShares: Scalars['Int']['input'];
  shareholderId: Scalars['ID']['input'];
  warrantProgramId: Scalars['ID']['input'];
}

export interface GqlWshDeletedResponse {
  id: Scalars['ID']['output'];
}

/** Import share state to warrant shareholder */
export interface GqlWshImportShareStateInput {
  date: Scalars['Date']['input'];
  warrantProgramId: Scalars['ID']['input'];
}

export interface GqlWshImportShareStateResponse {
  added: Array<GqlWarrantShareholder>;
  removed: Array<GqlWshDeletedResponse>;
}

/** set proxy */
export interface GqlWshSetProxyInput {
  id: Scalars['ID']['input'];
  proxyInput: GqlCreateIdentityInput;
}

export interface GqlWshUpdateResponse {
  documents: Array<GqlBolagoFile>;
  warrantShareholder: GqlWarrantShareholder;
}

export enum GqlZignedAgreementStatus {
  Cancelled = 'cancelled',
  Draft = 'draft',
  FailedToGenerate = 'failed_to_generate',
  Fulfilled = 'fulfilled',
  Generating = 'generating',
  Open = 'open',
  Pending = 'pending'
}

export enum GqlZignedParticipantRole {
  Approver = 'approver',
  Signer = 'signer'
}

export enum GqlZignedParticipantStatus {
  Draft = 'draft',
  Fulfilled = 'fulfilled',
  Initiated = 'initiated',
  Pending = 'pending',
  Processing = 'processing',
  Rejected = 'rejected'
}

export enum GqlDecisionKind {
  BoardDecision = 'BoardDecision',
  BoardDecisionWithShApproval = 'BoardDecisionWithShApproval',
  ShareHoldersMeeting = 'ShareHoldersMeeting'
}
